// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type ServerSentEventsResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { AbortEditSessionAgenticArtifactWorkspaceTransactionData, AbortEditSessionAgenticArtifactWorkspaceTransactionErrors, AbortEditSessionAgenticArtifactWorkspaceTransactionResponses, AbortProjectAgenticArtifactWorkspaceTransactionData, AbortProjectAgenticArtifactWorkspaceTransactionErrors, AbortProjectAgenticArtifactWorkspaceTransactionResponses, AbortThreadAgenticArtifactWorkspaceTransactionData, AbortThreadAgenticArtifactWorkspaceTransactionErrors, AbortThreadAgenticArtifactWorkspaceTransactionResponses, AcceptInvitationData, AcceptInvitationErrors, AcceptInvitationResponses, AcceptProjectInviteLinkData, AcceptProjectInviteLinkErrors, AcceptProjectInviteLinkResponses, AnswerChatQuestionsData, AnswerChatQuestionsErrors, AnswerChatQuestionsResponses, AppendEditSessionExternalRunRecordData, AppendEditSessionExternalRunRecordErrors, AppendEditSessionExternalRunRecordResponses, AppendProjectExternalRunRecordData, AppendProjectExternalRunRecordErrors, AppendProjectExternalRunRecordResponses, AppendThreadExternalRunRecordData, AppendThreadExternalRunRecordErrors, AppendThreadExternalRunRecordResponses, ApplyEditSessionAgenticArtifactWorkspaceTransactionPatchData, ApplyEditSessionAgenticArtifactWorkspaceTransactionPatchErrors, ApplyEditSessionAgenticArtifactWorkspaceTransactionPatchResponses, ApplyProjectAgenticArtifactWorkspaceTransactionPatchData, ApplyProjectAgenticArtifactWorkspaceTransactionPatchErrors, ApplyProjectAgenticArtifactWorkspaceTransactionPatchResponses, ApplyThreadAgenticArtifactWorkspaceTransactionPatchData, ApplyThreadAgenticArtifactWorkspaceTransactionPatchErrors, ApplyThreadAgenticArtifactWorkspaceTransactionPatchResponses, ArchiveEditSessionData, ArchiveEditSessionErrors, ArchiveEditSessionResponses, ArchiveOrganizationData, ArchiveOrganizationErrors, ArchiveOrganizationResponses, ArchiveProjectData, ArchiveProjectErrors, ArchiveProjectResponses, ArchiveThreadData, ArchiveThreadErrors, ArchiveThreadResponses, BeginEditSessionAgenticArtifactWorkspaceTransactionData, BeginEditSessionAgenticArtifactWorkspaceTransactionErrors, BeginEditSessionAgenticArtifactWorkspaceTransactionResponses, BeginProjectAgenticArtifactWorkspaceTransactionData, BeginProjectAgenticArtifactWorkspaceTransactionErrors, BeginProjectAgenticArtifactWorkspaceTransactionResponses, BeginThreadAgenticArtifactWorkspaceTransactionData, BeginThreadAgenticArtifactWorkspaceTransactionErrors, BeginThreadAgenticArtifactWorkspaceTransactionResponses, BrowserCreateCapabilityTokenData, BrowserCreateCapabilityTokenErrors, BrowserCreateCapabilityTokenResponses, BrowserDevLoginData, BrowserDevLoginErrors, BrowserDevLoginResponses, BrowserGenerateExternalAuthCodeData, BrowserGenerateExternalAuthCodeErrors, BrowserGenerateExternalAuthCodeResponses, BrowserGoogleLoginData, BrowserGoogleLoginErrors, BrowserGoogleLoginResponses, BrowserLogoutData, BrowserLogoutErrors, BrowserLogoutResponses, BuildStructuredValueInEditSessionData, BuildStructuredValueInEditSessionErrors, BuildStructuredValueInEditSessionResponses, BuildStructuredValueInEditThreadData, BuildStructuredValueInEditThreadErrors, BuildStructuredValueInEditThreadResponses, BuildStructuredValueInProjectData, BuildStructuredValueInProjectErrors, BuildStructuredValueInProjectResponses, CancelEditSessionExternalRunData, CancelEditSessionExternalRunErrors, CancelEditSessionExternalRunResponses, CancelMergeResolutionThreadData, CancelMergeResolutionThreadErrors, CancelMergeResolutionThreadResponses, CancelProjectExternalRunData, CancelProjectExternalRunErrors, CancelProjectExternalRunResponses, CancelThreadExternalRunData, CancelThreadExternalRunErrors, CancelThreadExternalRunResponses, CanMergeEditSessionData, CanMergeEditSessionErrors, CanMergeEditSessionResponses, CanMergeThreadData, CanMergeThreadErrors, CanMergeThreadResponses, CanSyncEditSessionData, CanSyncEditSessionErrors, CanSyncEditSessionResponses, CanSyncThreadData, CanSyncThreadErrors, CanSyncThreadResponses, CheckAuthzActionsData, CheckAuthzActionsErrors, CheckAuthzActionsResponses, CompleteEditSessionExternalRunData, CompleteEditSessionExternalRunErrors, CompleteEditSessionExternalRunResponses, CompleteProjectExternalRunData, CompleteProjectExternalRunErrors, CompleteProjectExternalRunResponses, CompleteThreadExternalRunData, CompleteThreadExternalRunErrors, CompleteThreadExternalRunResponses, CopyBlobData, CopyBlobErrors, CopyBlobResponses, CopyFsEntryData, CopyFsEntryErrors, CopyFsEntryResponses, CopyThreadFsEntryData, CopyThreadFsEntryErrors, CopyThreadFsEntryResponses, CreateAiPersonaData, CreateAiPersonaErrors, CreateAiPersonaResponses, CreateBillingPurchaseData, CreateBillingPurchaseErrors, CreateBillingPurchaseResponses, CreateBlobData, CreateBlobErrors, CreateBlobResponses, CreateBlobUploadUrlData, CreateBlobUploadUrlErrors, CreateBlobUploadUrlResponses, CreateBundleData, CreateBundleEnvironmentData, CreateBundleEnvironmentErrors, CreateBundleEnvironmentResponses, CreateBundleErrors, CreateBundleResponses, CreateBundleSourceData, CreateBundleSourceErrors, CreateBundleSourceResponses, CreateCapabilityTokenData, CreateCapabilityTokenErrors, CreateCapabilityTokenResponses, CreateChatBranchMessageData, CreateChatBranchMessageErrors, CreateChatBranchMessageResponses, CreateCustomerPortalSessionData, CreateCustomerPortalSessionErrors, CreateCustomerPortalSessionResponses, CreateEditSessionChatData, CreateEditSessionChatErrors, CreateEditSessionChatResponses, CreateEditSessionData, CreateEditSessionErrors, CreateEditSessionExternalRunData, CreateEditSessionExternalRunErrors, CreateEditSessionExternalRunResponses, CreateEditSessionExternalRunWorkspaceTransactionData, CreateEditSessionExternalRunWorkspaceTransactionErrors, CreateEditSessionExternalRunWorkspaceTransactionResponses, CreateEditSessionResponses, CreateEditSessionThreadData, CreateEditSessionThreadErrors, CreateEditSessionThreadResponses, CreateFsEntryData, CreateFsEntryErrors, CreateFsEntryFromDataData, CreateFsEntryFromDataErrors, CreateFsEntryFromDataResponses, CreateFsEntryResponses, CreateOrganizationData, CreateOrganizationErrors, CreateOrganizationProjectData, CreateOrganizationProjectErrors, CreateOrganizationProjectResponses, CreateOrganizationResponses, CreatePaymentMethodSetupData, CreatePaymentMethodSetupErrors, CreatePaymentMethodSetupResponses, CreateProjectExternalRunData, CreateProjectExternalRunErrors, CreateProjectExternalRunResponses, CreateProjectExternalRunWorkspaceTransactionData, CreateProjectExternalRunWorkspaceTransactionErrors, CreateProjectExternalRunWorkspaceTransactionResponses, CreateProjectInviteLinkData, CreateProjectInviteLinkErrors, CreateProjectInviteLinkResponses, CreateProjectMarketingData, CreateProjectMarketingErrors, CreateProjectMarketingResponses, CreateThreadExternalRunData, CreateThreadExternalRunErrors, CreateThreadExternalRunResponses, CreateThreadExternalRunWorkspaceTransactionData, CreateThreadExternalRunWorkspaceTransactionErrors, CreateThreadExternalRunWorkspaceTransactionResponses, CreateThreadFsEntryData, CreateThreadFsEntryErrors, CreateThreadFsEntryFromDataData, CreateThreadFsEntryFromDataErrors, CreateThreadFsEntryFromDataResponses, CreateThreadFsEntryResponses, CreateUserBillingPurchaseData, CreateUserBillingPurchaseErrors, CreateUserBillingPurchaseResponses, CreateUserChatData, CreateUserChatErrors, CreateUserChatResponses, CreateUserCustomerPortalSessionData, CreateUserCustomerPortalSessionErrors, CreateUserCustomerPortalSessionResponses, CreateUserPaymentMethodSetupData, CreateUserPaymentMethodSetupErrors, CreateUserPaymentMethodSetupResponses, DeclineInvitationData, DeclineInvitationErrors, DeclineInvitationResponses, DeleteAiPersonaData, DeleteAiPersonaErrors, DeleteAiPersonaResponses, DeleteBillingPaymentMethodData, DeleteBillingPaymentMethodErrors, DeleteBillingPaymentMethodResponses, DeleteBlobData, DeleteBlobErrors, DeleteBlobResponses, DeleteBundleData, DeleteBundleDeploymentData, DeleteBundleDeploymentErrors, DeleteBundleDeploymentResponses, DeleteBundleEnvironmentData, DeleteBundleEnvironmentErrors, DeleteBundleEnvironmentResponses, DeleteBundleErrors, DeleteBundleResponses, DeleteBundleSourceData, DeleteBundleSourceErrors, DeleteBundleSourceResponses, DeleteChatBranchData, DeleteChatBranchErrors, DeleteChatBranchResponses, DeleteChatData, DeleteChatErrors, DeleteChatResponses, DeleteEditSessionData, DeleteEditSessionErrors, DeleteEditSessionExternalRunData, DeleteEditSessionExternalRunErrors, DeleteEditSessionExternalRunResponses, DeleteEditSessionResponses, DeleteFsEntryData, DeleteFsEntryErrors, DeleteFsEntryResponses, DeleteInvitationData, DeleteInvitationErrors, DeleteInvitationResponses, DeleteProjectExternalRunData, DeleteProjectExternalRunErrors, DeleteProjectExternalRunResponses, DeleteProjectMarketingData, DeleteProjectMarketingErrors, DeleteProjectMarketingResponses, DeleteThreadData, DeleteThreadErrors, DeleteThreadExternalRunData, DeleteThreadExternalRunErrors, DeleteThreadExternalRunResponses, DeleteThreadFsEntryData, DeleteThreadFsEntryErrors, DeleteThreadFsEntryResponses, DeleteThreadResponses, DeleteUserAvatarData, DeleteUserAvatarErrors, DeleteUserAvatarRedirectData, DeleteUserAvatarRedirectErrors, DeleteUserAvatarResponses, DeleteUserBillingPaymentMethodData, DeleteUserBillingPaymentMethodErrors, DeleteUserBillingPaymentMethodResponses, DeleteUserByIdData, DeleteUserByIdErrors, DeleteUserByIdResponses, DeleteUserData, DeleteUserErrors, DeployBundleData, DeployBundleErrors, DeployBundleResponses, DevLoginData, DevLoginErrors, DevLoginResponses, DiffBundlesData, DiffBundlesErrors, DiffBundlesResponses, DuplicateProjectData, DuplicateProjectErrors, DuplicateProjectResponses, GenerateBundleContentUploadUrlData, GenerateBundleContentUploadUrlErrors, GenerateBundleContentUploadUrlResponses, GenerateExternalAuthCodeData, GenerateExternalAuthCodeErrors, GenerateExternalAuthCodeResponses, GetAgenticArtifactContentByTokenData, GetAgenticArtifactContentByTokenErrors, GetAgenticArtifactContentByTokenResponses, GetAiPersonaData, GetAiPersonaErrors, GetAiPersonaResponses, GetBillingInvoiceData, GetBillingInvoiceErrors, GetBillingInvoiceResponses, GetBillingPurchaseAttemptData, GetBillingPurchaseAttemptErrors, GetBillingPurchaseAttemptResponses, GetBillingPurchaseOptionsData, GetBillingPurchaseOptionsErrors, GetBillingPurchaseOptionsResponses, GetBillingSummaryData, GetBillingSummaryErrors, GetBillingSummaryResponses, GetBlobContentData, GetBlobContentErrors, GetBlobDownloadUrlData, GetBlobDownloadUrlErrors, GetBlobDownloadUrlResponses, GetBlobLocalFileData, GetBlobLocalFileErrors, GetBlobLocalFileResponses, GetBlobLocalGitFileData, GetBlobLocalGitFileErrors, GetBlobLocalGitFileResponses, GetBundleContentRedirectData, GetBundleContentRedirectErrors, GetBundleData, GetBundleDeploymentData, GetBundleDeploymentErrors, GetBundleDeploymentResponses, GetBundleEnvironmentData, GetBundleEnvironmentErrors, GetBundleEnvironmentResponses, GetBundleErrors, GetBundleResponses, GetBundleSourceData, GetBundleSourceErrors, GetBundleSourceResponses, GetChatBranchData, GetChatBranchErrors, GetChatBranchLlmViewData, GetChatBranchLlmViewErrors, GetChatBranchLlmViewResponses, GetChatBranchResponses, GetChatBranchUsageSummaryData, GetChatBranchUsageSummaryErrors, GetChatBranchUsageSummaryResponses, GetChatData, GetChatErrors, GetChatResponses, GetContentTreeData, GetContentTreeErrors, GetContentTreeResponses, GetEditSessionAgenticArtifactContentData, GetEditSessionAgenticArtifactContentErrors, GetEditSessionAgenticArtifactWorkspaceTransactionContentData, GetEditSessionAgenticArtifactWorkspaceTransactionContentErrors, GetEditSessionAgenticArtifactWorkspaceTransactionContentResponses, GetEditSessionAgenticArtifactWorkspaceTransactionData, GetEditSessionAgenticArtifactWorkspaceTransactionErrors, GetEditSessionAgenticArtifactWorkspaceTransactionResponses, GetEditSessionContentTreeData, GetEditSessionContentTreeErrors, GetEditSessionContentTreeResponses, GetEditSessionData, GetEditSessionDiffData, GetEditSessionDiffErrors, GetEditSessionDiffResponses, GetEditSessionErrors, GetEditSessionExternalRunData, GetEditSessionExternalRunErrors, GetEditSessionExternalRunRecordContentData, GetEditSessionExternalRunRecordContentErrors, GetEditSessionExternalRunRecordContentResponses, GetEditSessionExternalRunResponses, GetEditSessionFsEntryByPathData, GetEditSessionFsEntryByPathErrors, GetEditSessionFsEntryByPathResponses, GetEditSessionFsEntryContentByPathData, GetEditSessionFsEntryContentByPathErrors, GetEditSessionFsEntryContentData, GetEditSessionFsEntryContentErrors, GetEditSessionFsEntryData, GetEditSessionFsEntryErrors, GetEditSessionFsEntryResponses, GetEditSessionHistoryItemData, GetEditSessionHistoryItemDiffData, GetEditSessionHistoryItemDiffErrors, GetEditSessionHistoryItemDiffResponses, GetEditSessionHistoryItemErrors, GetEditSessionHistoryItemResponses, GetEditSessionHistoryItemSummaryData, GetEditSessionHistoryItemSummaryErrors, GetEditSessionHistoryItemSummaryResponses, GetEditSessionResponses, GetFsEntryByPathData, GetFsEntryByPathErrors, GetFsEntryByPathResponses, GetFsEntryContentByPathData, GetFsEntryContentByPathErrors, GetFsEntryContentData, GetFsEntryContentErrors, GetFsEntryData, GetFsEntryErrors, GetFsEntryResponses, GetHealthData, GetHealthErrors, GetHealthResponses, GetInvitationByTokenData, GetInvitationByTokenErrors, GetInvitationByTokenResponses, GetInvitationResourceByTokenData, GetInvitationResourceByTokenErrors, GetInvitationResourceByTokenResponses, GetOrganizationData, GetOrganizationErrors, GetOrganizationResponses, GetOrgUsageSummaryData, GetOrgUsageSummaryErrors, GetOrgUsageSummaryResponses, GetPaymentMethodSetupAttemptData, GetPaymentMethodSetupAttemptErrors, GetPaymentMethodSetupAttemptResponses, GetProjectAgenticArtifactContentData, GetProjectAgenticArtifactContentErrors, GetProjectAgenticArtifactWorkspaceTransactionContentData, GetProjectAgenticArtifactWorkspaceTransactionContentErrors, GetProjectAgenticArtifactWorkspaceTransactionContentResponses, GetProjectAgenticArtifactWorkspaceTransactionData, GetProjectAgenticArtifactWorkspaceTransactionErrors, GetProjectAgenticArtifactWorkspaceTransactionResponses, GetProjectCopyOperationData, GetProjectCopyOperationErrors, GetProjectCopyOperationResponses, GetProjectData, GetProjectErrors, GetProjectExternalRunData, GetProjectExternalRunErrors, GetProjectExternalRunRecordContentData, GetProjectExternalRunRecordContentErrors, GetProjectExternalRunRecordContentResponses, GetProjectExternalRunResponses, GetProjectInviteLinkPreviewData, GetProjectInviteLinkPreviewErrors, GetProjectInviteLinkPreviewResponses, GetProjectResponses, GetProjectTemplateData, GetProjectTemplateErrors, GetProjectTemplateResponses, GetProjectUsageSummaryData, GetProjectUsageSummaryErrors, GetProjectUsageSummaryResponses, GetServiceAccountByIdData, GetServiceAccountByIdErrors, GetServiceAccountByIdResponses, GetServiceAccountRedirectData, GetServiceAccountRedirectErrors, GetStructuredTypeInfoInEditSessionData, GetStructuredTypeInfoInEditSessionErrors, GetStructuredTypeInfoInEditSessionResponses, GetStructuredTypeInfoInEditThreadData, GetStructuredTypeInfoInEditThreadErrors, GetStructuredTypeInfoInEditThreadResponses, GetStructuredTypeInfoInProjectData, GetStructuredTypeInfoInProjectErrors, GetStructuredTypeInfoInProjectResponses, GetStructuredTypeSchemaInEditSessionData, GetStructuredTypeSchemaInEditSessionErrors, GetStructuredTypeSchemaInEditSessionResponses, GetStructuredTypeSchemaInEditThreadData, GetStructuredTypeSchemaInEditThreadErrors, GetStructuredTypeSchemaInEditThreadResponses, GetStructuredTypeSchemaInProjectData, GetStructuredTypeSchemaInProjectErrors, GetStructuredTypeSchemaInProjectResponses, GetStructuredValueEditorSchemaInEditSessionData, GetStructuredValueEditorSchemaInEditSessionErrors, GetStructuredValueEditorSchemaInEditSessionResponses, GetStructuredValueEditorSchemaInEditThreadData, GetStructuredValueEditorSchemaInEditThreadErrors, GetStructuredValueEditorSchemaInEditThreadResponses, GetStructuredValueInfoInEditSessionData, GetStructuredValueInfoInEditSessionErrors, GetStructuredValueInfoInEditSessionResponses, GetStructuredValueInfoInEditThreadData, GetStructuredValueInfoInEditThreadErrors, GetStructuredValueInfoInEditThreadResponses, GetStructuredValueInfoInProjectData, GetStructuredValueInfoInProjectErrors, GetStructuredValueInfoInProjectResponses, GetThreadAgenticArtifactContentData, GetThreadAgenticArtifactContentErrors, GetThreadAgenticArtifactWorkspaceTransactionContentData, GetThreadAgenticArtifactWorkspaceTransactionContentErrors, GetThreadAgenticArtifactWorkspaceTransactionContentResponses, GetThreadAgenticArtifactWorkspaceTransactionData, GetThreadAgenticArtifactWorkspaceTransactionErrors, GetThreadAgenticArtifactWorkspaceTransactionResponses, GetThreadContentTreeData, GetThreadContentTreeErrors, GetThreadContentTreeResponses, GetThreadData, GetThreadDiffData, GetThreadDiffErrors, GetThreadDiffResponses, GetThreadErrors, GetThreadExternalRunData, GetThreadExternalRunErrors, GetThreadExternalRunRecordContentData, GetThreadExternalRunRecordContentErrors, GetThreadExternalRunRecordContentResponses, GetThreadExternalRunResponses, GetThreadFsEntryByPathData, GetThreadFsEntryByPathErrors, GetThreadFsEntryByPathResponses, GetThreadFsEntryContentByPathData, GetThreadFsEntryContentByPathErrors, GetThreadFsEntryContentData, GetThreadFsEntryContentErrors, GetThreadFsEntryData, GetThreadFsEntryErrors, GetThreadFsEntryResponses, GetThreadHistoryItemData, GetThreadHistoryItemDiffData, GetThreadHistoryItemDiffErrors, GetThreadHistoryItemDiffResponses, GetThreadHistoryItemErrors, GetThreadHistoryItemResponses, GetThreadHistoryItemSummaryData, GetThreadHistoryItemSummaryErrors, GetThreadHistoryItemSummaryResponses, GetThreadResponses, GetUserAvatarData, GetUserAvatarErrors, GetUserAvatarRedirectData, GetUserAvatarRedirectErrors, GetUserBillingInvoiceData, GetUserBillingInvoiceErrors, GetUserBillingInvoiceResponses, GetUserBillingPurchaseAttemptData, GetUserBillingPurchaseAttemptErrors, GetUserBillingPurchaseAttemptResponses, GetUserBillingPurchaseOptionsData, GetUserBillingPurchaseOptionsErrors, GetUserBillingPurchaseOptionsResponses, GetUserBillingSummaryData, GetUserBillingSummaryErrors, GetUserBillingSummaryResponses, GetUserData, GetUserErrors, GetUserPaymentMethodSetupAttemptData, GetUserPaymentMethodSetupAttemptErrors, GetUserPaymentMethodSetupAttemptResponses, GetUserRedirectData, GetUserRedirectErrors, GetUserResponses, GetUserUsageSummaryData, GetUserUsageSummaryErrors, GetUserUsageSummaryResponses, GoogleLoginData, GoogleLoginErrors, GoogleLoginResponses, InteractWithChatMessageData, InteractWithChatMessageErrors, InteractWithChatMessageResponses, ListAiPersonasData, ListAiPersonasErrors, ListAiPersonasResponses, ListBillingInvoicesData, ListBillingInvoicesErrors, ListBillingInvoicesResponses, ListBillingPaymentMethodsData, ListBillingPaymentMethodsErrors, ListBillingPaymentMethodsResponses, ListBundleDeploymentsData, ListBundleDeploymentsErrors, ListBundleDeploymentsResponses, ListBundleEnvironmentDeploymentsData, ListBundleEnvironmentDeploymentsErrors, ListBundleEnvironmentDeploymentsResponses, ListChatBranchesData, ListChatBranchesErrors, ListChatBranchesResponses, ListChatBranchMessagesData, ListChatBranchMessagesErrors, ListChatBranchMessagesResponses, ListContextSuggestionsData, ListContextSuggestionsErrors, ListContextSuggestionsResponses, ListEditSessionAgenticArtifactsData, ListEditSessionAgenticArtifactsErrors, ListEditSessionAgenticArtifactsResponses, ListEditSessionAgenticArtifactWorkspaceTransactionEntriesData, ListEditSessionAgenticArtifactWorkspaceTransactionEntriesErrors, ListEditSessionAgenticArtifactWorkspaceTransactionEntriesResponses, ListEditSessionChatsData, ListEditSessionChatsErrors, ListEditSessionChatsResponses, ListEditSessionExternalRunRecordsData, ListEditSessionExternalRunRecordsErrors, ListEditSessionExternalRunRecordsResponses, ListEditSessionExternalRunsData, ListEditSessionExternalRunsErrors, ListEditSessionExternalRunsResponses, ListEditSessionFsEntriesData, ListEditSessionFsEntriesErrors, ListEditSessionFsEntriesResponses, ListEditSessionHistoryData, ListEditSessionHistoryErrors, ListEditSessionHistoryResponses, ListEditSessionProblemsData, ListEditSessionProblemsErrors, ListEditSessionProblemsResponses, ListEditSessionsData, ListEditSessionsErrors, ListEditSessionSkillsData, ListEditSessionSkillsErrors, ListEditSessionSkillsResponses, ListEditSessionsResponses, ListEditSessionThreadsData, ListEditSessionThreadsErrors, ListEditSessionThreadSkillsData, ListEditSessionThreadSkillsErrors, ListEditSessionThreadSkillsResponses, ListEditSessionThreadsResponses, ListFsEntriesData, ListFsEntriesErrors, ListFsEntriesResponses, ListLlmModelOptionsData, ListLlmModelOptionsErrors, ListLlmModelOptionsResponses, ListOrganizationInvitationsData, ListOrganizationInvitationsErrors, ListOrganizationInvitationsResponses, ListOrganizationMembersData, ListOrganizationMembersErrors, ListOrganizationMembersResponses, ListOrganizationProjectsData, ListOrganizationProjectsErrors, ListOrganizationProjectsResponses, ListOrganizationsData, ListOrganizationsErrors, ListOrganizationsResponses, ListOrgUsageHistoryData, ListOrgUsageHistoryErrors, ListOrgUsageHistoryResponses, ListProblemsData, ListProblemsErrors, ListProblemsResponses, ListProjectAgenticArtifactsData, ListProjectAgenticArtifactsErrors, ListProjectAgenticArtifactsResponses, ListProjectAgenticArtifactWorkspaceTransactionEntriesData, ListProjectAgenticArtifactWorkspaceTransactionEntriesErrors, ListProjectAgenticArtifactWorkspaceTransactionEntriesResponses, ListProjectBundleEnvironmentsData, ListProjectBundleEnvironmentsErrors, ListProjectBundleEnvironmentsResponses, ListProjectBundleSourcesData, ListProjectBundleSourcesErrors, ListProjectBundleSourcesResponses, ListProjectExternalRunRecordsData, ListProjectExternalRunRecordsErrors, ListProjectExternalRunRecordsResponses, ListProjectExternalRunsData, ListProjectExternalRunsErrors, ListProjectExternalRunsResponses, ListProjectInvitationsData, ListProjectInvitationsErrors, ListProjectInvitationsResponses, ListProjectInviteLinksData, ListProjectInviteLinksErrors, ListProjectInviteLinksResponses, ListProjectMarketingData, ListProjectMarketingErrors, ListProjectMarketingResponses, ListProjectMembersData, ListProjectMembersErrors, ListProjectMembersResponses, ListProjectSkillsData, ListProjectSkillsErrors, ListProjectSkillsResponses, ListProjectTemplatesData, ListProjectTemplatesErrors, ListProjectTemplatesResponses, ListProjectUsageHistoryData, ListProjectUsageHistoryErrors, ListProjectUsageHistoryResponses, ListSourceBundlesData, ListSourceBundlesErrors, ListSourceBundlesResponses, ListThreadAgenticArtifactsData, ListThreadAgenticArtifactsErrors, ListThreadAgenticArtifactsResponses, ListThreadAgenticArtifactWorkspaceTransactionEntriesData, ListThreadAgenticArtifactWorkspaceTransactionEntriesErrors, ListThreadAgenticArtifactWorkspaceTransactionEntriesResponses, ListThreadExternalRunRecordsData, ListThreadExternalRunRecordsErrors, ListThreadExternalRunRecordsResponses, ListThreadExternalRunsData, ListThreadExternalRunsErrors, ListThreadExternalRunsResponses, ListThreadFsEntriesData, ListThreadFsEntriesErrors, ListThreadFsEntriesResponses, ListThreadHistoryData, ListThreadHistoryErrors, ListThreadHistoryResponses, ListThreadProblemsData, ListThreadProblemsErrors, ListThreadProblemsResponses, ListUserBillingInvoicesData, ListUserBillingInvoicesErrors, ListUserBillingInvoicesResponses, ListUserBillingPaymentMethodsData, ListUserBillingPaymentMethodsErrors, ListUserBillingPaymentMethodsResponses, ListUserChatsData, ListUserChatsErrors, ListUserChatsResponses, ListUserInvitationsData, ListUserInvitationsErrors, ListUserInvitationsRedirectData, ListUserInvitationsRedirectErrors, ListUserInvitationsResponses, ListUserMembershipsData, ListUserMembershipsErrors, ListUserMembershipsRedirectData, ListUserMembershipsRedirectErrors, ListUserMembershipsResponses, ListUserUsageHistoryData, ListUserUsageHistoryErrors, ListUserUsageHistoryResponses, LogoutData, LogoutErrors, LogoutResponses, MergeEditSessionData, MergeEditSessionErrors, MergeEditSessionResponses, MergeThreadData, MergeThreadErrors, MergeThreadResponses, PatchFsEntryContentData, PatchFsEntryContentErrors, PatchFsEntryContentResponses, PatchThreadFsEntryContentData, PatchThreadFsEntryContentErrors, PatchThreadFsEntryContentResponses, PromoteEditSessionAgenticArtifactWorkspaceTransactionData, PromoteEditSessionAgenticArtifactWorkspaceTransactionErrors, PromoteEditSessionAgenticArtifactWorkspaceTransactionResponses, PromoteProjectAgenticArtifactWorkspaceTransactionData, PromoteProjectAgenticArtifactWorkspaceTransactionErrors, PromoteProjectAgenticArtifactWorkspaceTransactionResponses, PromoteThreadAgenticArtifactWorkspaceTransactionData, PromoteThreadAgenticArtifactWorkspaceTransactionErrors, PromoteThreadAgenticArtifactWorkspaceTransactionResponses, RecordUserPresenceData, RecordUserPresenceErrors, RecordUserPresenceResponses, RedeemExternalAuthCodeData, RedeemExternalAuthCodeErrors, RedeemExternalAuthCodeResponses, RedirectStructuredValueTypeInEditSessionData, RedirectStructuredValueTypeInEditSessionErrors, RedirectStructuredValueTypeInEditThreadData, RedirectStructuredValueTypeInEditThreadErrors, RedirectStructuredValueTypeInProjectData, RedirectStructuredValueTypeInProjectErrors, RedirectStructuredValueTypeSchemaInEditSessionData, RedirectStructuredValueTypeSchemaInEditSessionErrors, RedirectStructuredValueTypeSchemaInEditThreadData, RedirectStructuredValueTypeSchemaInEditThreadErrors, RedirectStructuredValueTypeSchemaInProjectData, RedirectStructuredValueTypeSchemaInProjectErrors, RedirectToChatMessagesData, RedirectToChatMessagesErrors, RedirectToCreateChatMessageData, RedirectToCreateChatMessageErrors, RedirectToCurrentBundleContentData, RedirectToCurrentBundleContentErrors, RedirectToCurrentBundleData, RedirectToCurrentBundleErrors, RedirectToUserBillingInvoiceData, RedirectToUserBillingInvoiceErrors, RedirectToUserBillingInvoicesData, RedirectToUserBillingInvoicesErrors, RedirectToUserBillingPaymentMethodsData, RedirectToUserBillingPaymentMethodsErrors, RedirectToUserBillingSummaryData, RedirectToUserBillingSummaryErrors, RedirectToUserChatsData, RedirectToUserChatsErrors, RedirectToUserOrganizationMembershipsData, RedirectToUserOrganizationMembershipsErrors, RedirectToUserOrganizationsData, RedirectToUserOrganizationsErrors, RedirectToUserPresenceRecordData, RedirectToUserPresenceRecordErrors, RedirectToUserProjectMembershipsData, RedirectToUserProjectMembershipsErrors, RedirectToUserProjectsData, RedirectToUserProjectsErrors, RedirectToUserUsageHistoryData, RedirectToUserUsageHistoryErrors, RedirectToUserUsageSummaryData, RedirectToUserUsageSummaryErrors, RedoEditSessionData, RedoEditSessionErrors, RedoEditSessionResponses, RefreshContentTreeData, RefreshContentTreeErrors, RefreshContentTreeResponses, RefreshEditSessionContentTreeData, RefreshEditSessionContentTreeErrors, RefreshEditSessionContentTreeResponses, RefreshThreadContentTreeData, RefreshThreadContentTreeErrors, RefreshThreadContentTreeResponses, RefreshTokenData, RefreshTokenErrors, RefreshTokenResponses, ReimportContentPathData, ReimportContentPathErrors, ReimportContentPathResponses, ReimportEditSessionContentPathData, ReimportEditSessionContentPathErrors, ReimportEditSessionContentPathResponses, ReimportFsEntryData, ReimportFsEntryErrors, ReimportFsEntryResponses, ReimportThreadContentPathData, ReimportThreadContentPathErrors, ReimportThreadContentPathResponses, ReimportThreadFsEntryData, ReimportThreadFsEntryErrors, ReimportThreadFsEntryResponses, RemoveOrganizationMemberData, RemoveOrganizationMemberErrors, RemoveOrganizationMemberResponses, RemoveProjectMemberData, RemoveProjectMemberErrors, RemoveProjectMemberResponses, RenameProjectMarketingData, RenameProjectMarketingErrors, RenameProjectMarketingResponses, ReplaceFsEntryContentData, ReplaceFsEntryContentErrors, ReplaceFsEntryContentResponses, ReplaceThreadFsEntryContentData, ReplaceThreadFsEntryContentErrors, ReplaceThreadFsEntryContentResponses, ReportUsageRecordsData, ReportUsageRecordsErrors, ReportUsageRecordsResponses, RequestThreadUploadUrlData, RequestThreadUploadUrlErrors, RequestThreadUploadUrlResponses, RequestUploadUrlData, RequestUploadUrlErrors, RequestUploadUrlResponses, RevertEditSessionData, RevertEditSessionErrors, RevertEditSessionResponses, RevertThreadData, RevertThreadErrors, RevertThreadResponses, RevokeProjectInviteLinkData, RevokeProjectInviteLinkErrors, RevokeProjectInviteLinkResponses, RunEditSessionPluginBinaryData, RunEditSessionPluginBinaryErrors, RunEditSessionPluginBinaryResponses, RunEditSessionPluginScriptData, RunEditSessionPluginScriptErrors, RunEditSessionPluginScriptResponses, RunEditSessionSkillBinaryData, RunEditSessionSkillBinaryErrors, RunEditSessionSkillBinaryResponses, RunEditSessionSkillScriptData, RunEditSessionSkillScriptErrors, RunEditSessionSkillScriptResponses, RunEditSessionThreadPluginBinaryData, RunEditSessionThreadPluginBinaryErrors, RunEditSessionThreadPluginBinaryResponses, RunEditSessionThreadPluginScriptData, RunEditSessionThreadPluginScriptErrors, RunEditSessionThreadPluginScriptResponses, RunEditSessionThreadSkillBinaryData, RunEditSessionThreadSkillBinaryErrors, RunEditSessionThreadSkillBinaryResponses, RunEditSessionThreadSkillScriptData, RunEditSessionThreadSkillScriptErrors, RunEditSessionThreadSkillScriptResponses, RunProjectPluginBinaryData, RunProjectPluginBinaryErrors, RunProjectPluginBinaryResponses, RunProjectPluginScriptData, RunProjectPluginScriptErrors, RunProjectPluginScriptResponses, RunProjectSkillBinaryData, RunProjectSkillBinaryErrors, RunProjectSkillBinaryResponses, RunProjectSkillScriptData, RunProjectSkillScriptErrors, RunProjectSkillScriptResponses, SearchEditSessionAgenticArtifactsData, SearchEditSessionAgenticArtifactsErrors, SearchEditSessionAgenticArtifactsResponses, SearchProjectAgenticArtifactsData, SearchProjectAgenticArtifactsErrors, SearchProjectAgenticArtifactsResponses, SearchThreadAgenticArtifactsData, SearchThreadAgenticArtifactsErrors, SearchThreadAgenticArtifactsResponses, SeedLocalDevEnterpriseData, SeedLocalDevEnterpriseErrors, SeedLocalDevEnterpriseResponses, SeedOrgProjectsData, SeedOrgProjectsErrors, SeedOrgProjectsResponses, SendOrganizationInvitationData, SendOrganizationInvitationErrors, SendOrganizationInvitationResponses, SendProjectInvitationData, SendProjectInvitationErrors, SendProjectInvitationResponses, SetDefaultPaymentMethodData, SetDefaultPaymentMethodErrors, SetDefaultPaymentMethodResponses, SetUpBillingData, SetUpBillingErrors, SetUpBillingResponses, SetUpUserBillingData, SetUpUserBillingErrors, SetUpUserBillingResponses, SetUserDefaultPaymentMethodData, SetUserDefaultPaymentMethodErrors, SetUserDefaultPaymentMethodResponses, StartEditSessionExternalRunData, StartEditSessionExternalRunErrors, StartEditSessionExternalRunResponses, StartProjectExternalRunData, StartProjectExternalRunErrors, StartProjectExternalRunResponses, StartThreadExternalRunData, StartThreadExternalRunErrors, StartThreadExternalRunResponses, StopAiPersonaAnswerData, StopAiPersonaAnswerErrors, StopAiPersonaAnswerResponses, StreamEventsData, StreamEventsErrors, StreamEventsResponse, StreamEventsResponses, SwitchChatBranchData, SwitchChatBranchErrors, SwitchChatBranchResponses, SyncEditSessionData, SyncEditSessionErrors, SyncEditSessionResponses, SyncThreadData, SyncThreadErrors, SyncThreadResponses, TouchEditSessionAgenticArtifactWorkspaceTransactionData, TouchEditSessionAgenticArtifactWorkspaceTransactionErrors, TouchEditSessionAgenticArtifactWorkspaceTransactionResponses, TouchProjectAgenticArtifactWorkspaceTransactionData, TouchProjectAgenticArtifactWorkspaceTransactionErrors, TouchProjectAgenticArtifactWorkspaceTransactionResponses, TouchThreadAgenticArtifactWorkspaceTransactionData, TouchThreadAgenticArtifactWorkspaceTransactionErrors, TouchThreadAgenticArtifactWorkspaceTransactionResponses, TransferOwnershipData, TransferOwnershipErrors, TransferOwnershipResponses, TriggerEditSessionValidationData, TriggerEditSessionValidationErrors, TriggerEditSessionValidationResponses, TriggerThreadValidationData, TriggerThreadValidationErrors, TriggerThreadValidationResponses, UnarchiveThreadData, UnarchiveThreadErrors, UnarchiveThreadResponses, UndoEditSessionData, UndoEditSessionErrors, UndoEditSessionResponses, UpdateAiPersonaData, UpdateAiPersonaErrors, UpdateAiPersonaResponses, UpdateBundleData, UpdateBundleDeploymentData, UpdateBundleDeploymentErrors, UpdateBundleDeploymentResponses, UpdateBundleEnvironmentData, UpdateBundleEnvironmentErrors, UpdateBundleEnvironmentResponses, UpdateBundleErrors, UpdateBundleResponses, UpdateBundleSourceData, UpdateBundleSourceErrors, UpdateBundleSourceResponses, UpdateChatBranchMessageData, UpdateChatBranchMessageErrors, UpdateChatBranchMessageResponses, UpdateChatData, UpdateChatErrors, UpdateChatResponses, UpdateEditSessionData, UpdateEditSessionErrors, UpdateEditSessionExternalRunSettingsData, UpdateEditSessionExternalRunSettingsErrors, UpdateEditSessionExternalRunSettingsResponses, UpdateEditSessionResponses, UpdateFsEntryData, UpdateFsEntryErrors, UpdateFsEntryResponses, UpdateOrganizationData, UpdateOrganizationErrors, UpdateOrganizationMemberData, UpdateOrganizationMemberErrors, UpdateOrganizationMemberResponses, UpdateOrganizationResponses, UpdateProjectData, UpdateProjectErrors, UpdateProjectExternalRunSettingsData, UpdateProjectExternalRunSettingsErrors, UpdateProjectExternalRunSettingsResponses, UpdateProjectMemberData, UpdateProjectMemberErrors, UpdateProjectMemberResponses, UpdateProjectResponses, UpdateThreadData, UpdateThreadErrors, UpdateThreadExternalRunSettingsData, UpdateThreadExternalRunSettingsErrors, UpdateThreadExternalRunSettingsResponses, UpdateThreadFsEntryData, UpdateThreadFsEntryErrors, UpdateThreadFsEntryResponses, UpdateThreadResponses, UpdateUserByIdData, UpdateUserByIdErrors, UpdateUserByIdResponses, UpdateUserData, UpdateUserErrors, UploadBlobLocalFileData, UploadBlobLocalFileErrors, UploadBlobLocalFileResponses, UploadBlobLocalGitFileData, UploadBlobLocalGitFileErrors, UploadBlobLocalGitFileResponses, UploadProjectThumbnailData, UploadProjectThumbnailErrors, UploadProjectThumbnailResponses, UploadUserAvatarData, UploadUserAvatarErrors, UploadUserAvatarRedirectData, UploadUserAvatarRedirectErrors, UploadUserAvatarResponses, ValidateEditSessionFsEntryData, ValidateEditSessionFsEntryErrors, ValidateEditSessionFsEntryResponses, ValidateThreadFsEntryData, ValidateThreadFsEntryErrors, ValidateThreadFsEntryResponses } from './types.gen';
import { ABORT_EDIT_SESSION_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL, ABORT_PROJECT_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL, ABORT_THREAD_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL, ACCEPT_INVITATION_URL, ACCEPT_PROJECT_INVITE_LINK_URL, ANSWER_CHAT_QUESTIONS_URL, APPEND_EDIT_SESSION_EXTERNAL_RUN_RECORD_URL, APPEND_PROJECT_EXTERNAL_RUN_RECORD_URL, APPEND_THREAD_EXTERNAL_RUN_RECORD_URL, APPLY_EDIT_SESSION_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_PATCH_URL, APPLY_PROJECT_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_PATCH_URL, APPLY_THREAD_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_PATCH_URL, ARCHIVE_EDIT_SESSION_URL, ARCHIVE_ORGANIZATION_URL, ARCHIVE_PROJECT_URL, ARCHIVE_THREAD_URL, BEGIN_EDIT_SESSION_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL, BEGIN_PROJECT_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL, BEGIN_THREAD_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL, BROWSER_CREATE_CAPABILITY_TOKEN_URL, BROWSER_DEV_LOGIN_URL, BROWSER_GENERATE_EXTERNAL_AUTH_CODE_URL, BROWSER_GOOGLE_LOGIN_URL, BROWSER_LOGOUT_URL, BUILD_STRUCTURED_VALUE_IN_EDIT_SESSION_URL, BUILD_STRUCTURED_VALUE_IN_EDIT_THREAD_URL, BUILD_STRUCTURED_VALUE_IN_PROJECT_URL, CAN_MERGE_EDIT_SESSION_URL, CAN_MERGE_THREAD_URL, CAN_SYNC_EDIT_SESSION_URL, CAN_SYNC_THREAD_URL, CANCEL_EDIT_SESSION_EXTERNAL_RUN_URL, CANCEL_MERGE_RESOLUTION_THREAD_URL, CANCEL_PROJECT_EXTERNAL_RUN_URL, CANCEL_THREAD_EXTERNAL_RUN_URL, CHECK_AUTHZ_ACTIONS_URL, COMPLETE_EDIT_SESSION_EXTERNAL_RUN_URL, COMPLETE_PROJECT_EXTERNAL_RUN_URL, COMPLETE_THREAD_EXTERNAL_RUN_URL, COPY_BLOB_URL, COPY_FS_ENTRY_URL, COPY_THREAD_FS_ENTRY_URL, CREATE_AI_PERSONA_URL, CREATE_BILLING_PURCHASE_URL, CREATE_BLOB_UPLOAD_URL_URL, CREATE_BLOB_URL, CREATE_BUNDLE_ENVIRONMENT_URL, CREATE_BUNDLE_SOURCE_URL, CREATE_BUNDLE_URL, CREATE_CAPABILITY_TOKEN_URL, CREATE_CHAT_BRANCH_MESSAGE_URL, CREATE_CUSTOMER_PORTAL_SESSION_URL, CREATE_EDIT_SESSION_CHAT_URL, CREATE_EDIT_SESSION_EXTERNAL_RUN_URL, CREATE_EDIT_SESSION_EXTERNAL_RUN_WORKSPACE_TRANSACTION_URL, CREATE_EDIT_SESSION_THREAD_URL, CREATE_EDIT_SESSION_URL, CREATE_FS_ENTRY_FROM_DATA_URL, CREATE_FS_ENTRY_URL, CREATE_ORGANIZATION_PROJECT_URL, CREATE_ORGANIZATION_URL, CREATE_PAYMENT_METHOD_SETUP_URL, CREATE_PROJECT_EXTERNAL_RUN_URL, CREATE_PROJECT_EXTERNAL_RUN_WORKSPACE_TRANSACTION_URL, CREATE_PROJECT_INVITE_LINK_URL, CREATE_PROJECT_MARKETING_URL, CREATE_THREAD_EXTERNAL_RUN_URL, CREATE_THREAD_EXTERNAL_RUN_WORKSPACE_TRANSACTION_URL, CREATE_THREAD_FS_ENTRY_FROM_DATA_URL, CREATE_THREAD_FS_ENTRY_URL, CREATE_USER_BILLING_PURCHASE_URL, CREATE_USER_CHAT_URL, CREATE_USER_CUSTOMER_PORTAL_SESSION_URL, CREATE_USER_PAYMENT_METHOD_SETUP_URL, DECLINE_INVITATION_URL, DELETE_AI_PERSONA_URL, DELETE_BILLING_PAYMENT_METHOD_URL, DELETE_BLOB_URL, DELETE_BUNDLE_DEPLOYMENT_URL, DELETE_BUNDLE_ENVIRONMENT_URL, DELETE_BUNDLE_SOURCE_URL, DELETE_BUNDLE_URL, DELETE_CHAT_BRANCH_URL, DELETE_CHAT_URL, DELETE_EDIT_SESSION_EXTERNAL_RUN_URL, DELETE_EDIT_SESSION_URL, DELETE_FS_ENTRY_URL, DELETE_INVITATION_URL, DELETE_PROJECT_EXTERNAL_RUN_URL, DELETE_PROJECT_MARKETING_URL, DELETE_THREAD_EXTERNAL_RUN_URL, DELETE_THREAD_FS_ENTRY_URL, DELETE_THREAD_URL, DELETE_USER_AVATAR_REDIRECT_URL, DELETE_USER_AVATAR_URL, DELETE_USER_BILLING_PAYMENT_METHOD_URL, DELETE_USER_BY_ID_URL, DELETE_USER_URL, DEPLOY_BUNDLE_URL, DEV_LOGIN_URL, DIFF_BUNDLES_URL, DUPLICATE_PROJECT_URL, GENERATE_BUNDLE_CONTENT_UPLOAD_URL_URL, GENERATE_EXTERNAL_AUTH_CODE_URL, GET_AGENTIC_ARTIFACT_CONTENT_BY_TOKEN_URL, GET_AI_PERSONA_URL, GET_BILLING_INVOICE_URL, GET_BILLING_PURCHASE_ATTEMPT_URL, GET_BILLING_PURCHASE_OPTIONS_URL, GET_BILLING_SUMMARY_URL, GET_BLOB_CONTENT_URL, GET_BLOB_DOWNLOAD_URL_URL, GET_BLOB_LOCAL_FILE_URL, GET_BLOB_LOCAL_GIT_FILE_URL, GET_BUNDLE_CONTENT_REDIRECT_URL, GET_BUNDLE_DEPLOYMENT_URL, GET_BUNDLE_ENVIRONMENT_URL, GET_BUNDLE_SOURCE_URL, GET_BUNDLE_URL, GET_CHAT_BRANCH_LLM_VIEW_URL, GET_CHAT_BRANCH_URL, GET_CHAT_BRANCH_USAGE_SUMMARY_URL, GET_CHAT_URL, GET_CONTENT_TREE_URL, GET_EDIT_SESSION_AGENTIC_ARTIFACT_CONTENT_URL, GET_EDIT_SESSION_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_CONTENT_URL, GET_EDIT_SESSION_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL, GET_EDIT_SESSION_CONTENT_TREE_URL, GET_EDIT_SESSION_DIFF_URL, GET_EDIT_SESSION_EXTERNAL_RUN_RECORD_CONTENT_URL, GET_EDIT_SESSION_EXTERNAL_RUN_URL, GET_EDIT_SESSION_FS_ENTRY_BY_PATH_URL, GET_EDIT_SESSION_FS_ENTRY_CONTENT_BY_PATH_URL, GET_EDIT_SESSION_FS_ENTRY_CONTENT_URL, GET_EDIT_SESSION_FS_ENTRY_URL, GET_EDIT_SESSION_HISTORY_ITEM_DIFF_URL, GET_EDIT_SESSION_HISTORY_ITEM_SUMMARY_URL, GET_EDIT_SESSION_HISTORY_ITEM_URL, GET_EDIT_SESSION_URL, GET_FS_ENTRY_BY_PATH_URL, GET_FS_ENTRY_CONTENT_BY_PATH_URL, GET_FS_ENTRY_CONTENT_URL, GET_FS_ENTRY_URL, GET_HEALTH_URL, GET_INVITATION_BY_TOKEN_URL, GET_INVITATION_RESOURCE_BY_TOKEN_URL, GET_ORG_USAGE_SUMMARY_URL, GET_ORGANIZATION_URL, GET_PAYMENT_METHOD_SETUP_ATTEMPT_URL, GET_PROJECT_AGENTIC_ARTIFACT_CONTENT_URL, GET_PROJECT_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_CONTENT_URL, GET_PROJECT_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL, GET_PROJECT_COPY_OPERATION_URL, GET_PROJECT_EXTERNAL_RUN_RECORD_CONTENT_URL, GET_PROJECT_EXTERNAL_RUN_URL, GET_PROJECT_INVITE_LINK_PREVIEW_URL, GET_PROJECT_TEMPLATE_URL, GET_PROJECT_URL, GET_PROJECT_USAGE_SUMMARY_URL, GET_SERVICE_ACCOUNT_BY_ID_URL, GET_SERVICE_ACCOUNT_REDIRECT_URL, GET_STRUCTURED_TYPE_INFO_IN_EDIT_SESSION_URL, GET_STRUCTURED_TYPE_INFO_IN_EDIT_THREAD_URL, GET_STRUCTURED_TYPE_INFO_IN_PROJECT_URL, GET_STRUCTURED_TYPE_SCHEMA_IN_EDIT_SESSION_URL, GET_STRUCTURED_TYPE_SCHEMA_IN_EDIT_THREAD_URL, GET_STRUCTURED_TYPE_SCHEMA_IN_PROJECT_URL, GET_STRUCTURED_VALUE_EDITOR_SCHEMA_IN_EDIT_SESSION_URL, GET_STRUCTURED_VALUE_EDITOR_SCHEMA_IN_EDIT_THREAD_URL, GET_STRUCTURED_VALUE_INFO_IN_EDIT_SESSION_URL, GET_STRUCTURED_VALUE_INFO_IN_EDIT_THREAD_URL, GET_STRUCTURED_VALUE_INFO_IN_PROJECT_URL, GET_THREAD_AGENTIC_ARTIFACT_CONTENT_URL, GET_THREAD_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_CONTENT_URL, GET_THREAD_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL, GET_THREAD_CONTENT_TREE_URL, GET_THREAD_DIFF_URL, GET_THREAD_EXTERNAL_RUN_RECORD_CONTENT_URL, GET_THREAD_EXTERNAL_RUN_URL, GET_THREAD_FS_ENTRY_BY_PATH_URL, GET_THREAD_FS_ENTRY_CONTENT_BY_PATH_URL, GET_THREAD_FS_ENTRY_CONTENT_URL, GET_THREAD_FS_ENTRY_URL, GET_THREAD_HISTORY_ITEM_DIFF_URL, GET_THREAD_HISTORY_ITEM_SUMMARY_URL, GET_THREAD_HISTORY_ITEM_URL, GET_THREAD_URL, GET_USER_AVATAR_REDIRECT_URL, GET_USER_AVATAR_URL, GET_USER_BILLING_INVOICE_URL, GET_USER_BILLING_PURCHASE_ATTEMPT_URL, GET_USER_BILLING_PURCHASE_OPTIONS_URL, GET_USER_BILLING_SUMMARY_URL, GET_USER_PAYMENT_METHOD_SETUP_ATTEMPT_URL, GET_USER_REDIRECT_URL, GET_USER_URL, GET_USER_USAGE_SUMMARY_URL, GOOGLE_LOGIN_URL, INTERACT_WITH_CHAT_MESSAGE_URL, LIST_AI_PERSONAS_URL, LIST_BILLING_INVOICES_URL, LIST_BILLING_PAYMENT_METHODS_URL, LIST_BUNDLE_DEPLOYMENTS_URL, LIST_BUNDLE_ENVIRONMENT_DEPLOYMENTS_URL, LIST_CHAT_BRANCH_MESSAGES_URL, LIST_CHAT_BRANCHES_URL, LIST_CONTEXT_SUGGESTIONS_URL, LIST_EDIT_SESSION_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_ENTRIES_URL, LIST_EDIT_SESSION_AGENTIC_ARTIFACTS_URL, LIST_EDIT_SESSION_CHATS_URL, LIST_EDIT_SESSION_EXTERNAL_RUN_RECORDS_URL, LIST_EDIT_SESSION_EXTERNAL_RUNS_URL, LIST_EDIT_SESSION_FS_ENTRIES_URL, LIST_EDIT_SESSION_HISTORY_URL, LIST_EDIT_SESSION_PROBLEMS_URL, LIST_EDIT_SESSION_SKILLS_URL, LIST_EDIT_SESSION_THREAD_SKILLS_URL, LIST_EDIT_SESSION_THREADS_URL, LIST_EDIT_SESSIONS_URL, LIST_FS_ENTRIES_URL, LIST_LLM_MODEL_OPTIONS_URL, LIST_ORG_USAGE_HISTORY_URL, LIST_ORGANIZATION_INVITATIONS_URL, LIST_ORGANIZATION_MEMBERS_URL, LIST_ORGANIZATION_PROJECTS_URL, LIST_ORGANIZATIONS_URL, LIST_PROBLEMS_URL, LIST_PROJECT_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_ENTRIES_URL, LIST_PROJECT_AGENTIC_ARTIFACTS_URL, LIST_PROJECT_BUNDLE_ENVIRONMENTS_URL, LIST_PROJECT_BUNDLE_SOURCES_URL, LIST_PROJECT_EXTERNAL_RUN_RECORDS_URL, LIST_PROJECT_EXTERNAL_RUNS_URL, LIST_PROJECT_INVITATIONS_URL, LIST_PROJECT_INVITE_LINKS_URL, LIST_PROJECT_MARKETING_URL, LIST_PROJECT_MEMBERS_URL, LIST_PROJECT_SKILLS_URL, LIST_PROJECT_TEMPLATES_URL, LIST_PROJECT_USAGE_HISTORY_URL, LIST_SOURCE_BUNDLES_URL, LIST_THREAD_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_ENTRIES_URL, LIST_THREAD_AGENTIC_ARTIFACTS_URL, LIST_THREAD_EXTERNAL_RUN_RECORDS_URL, LIST_THREAD_EXTERNAL_RUNS_URL, LIST_THREAD_FS_ENTRIES_URL, LIST_THREAD_HISTORY_URL, LIST_THREAD_PROBLEMS_URL, LIST_USER_BILLING_INVOICES_URL, LIST_USER_BILLING_PAYMENT_METHODS_URL, LIST_USER_CHATS_URL, LIST_USER_INVITATIONS_REDIRECT_URL, LIST_USER_INVITATIONS_URL, LIST_USER_MEMBERSHIPS_REDIRECT_URL, LIST_USER_MEMBERSHIPS_URL, LIST_USER_USAGE_HISTORY_URL, LOGOUT_URL, MERGE_EDIT_SESSION_URL, MERGE_THREAD_URL, PATCH_FS_ENTRY_CONTENT_URL, PATCH_THREAD_FS_ENTRY_CONTENT_URL, PROMOTE_EDIT_SESSION_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL, PROMOTE_PROJECT_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL, PROMOTE_THREAD_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL, RECORD_USER_PRESENCE_URL, REDEEM_EXTERNAL_AUTH_CODE_URL, REDIRECT_STRUCTURED_VALUE_TYPE_IN_EDIT_SESSION_URL, REDIRECT_STRUCTURED_VALUE_TYPE_IN_EDIT_THREAD_URL, REDIRECT_STRUCTURED_VALUE_TYPE_IN_PROJECT_URL, REDIRECT_STRUCTURED_VALUE_TYPE_SCHEMA_IN_EDIT_SESSION_URL, REDIRECT_STRUCTURED_VALUE_TYPE_SCHEMA_IN_EDIT_THREAD_URL, REDIRECT_STRUCTURED_VALUE_TYPE_SCHEMA_IN_PROJECT_URL, REDIRECT_TO_CHAT_MESSAGES_URL, REDIRECT_TO_CREATE_CHAT_MESSAGE_URL, REDIRECT_TO_CURRENT_BUNDLE_CONTENT_URL, REDIRECT_TO_CURRENT_BUNDLE_URL, REDIRECT_TO_USER_BILLING_INVOICE_URL, REDIRECT_TO_USER_BILLING_INVOICES_URL, REDIRECT_TO_USER_BILLING_PAYMENT_METHODS_URL, REDIRECT_TO_USER_BILLING_SUMMARY_URL, REDIRECT_TO_USER_CHATS_URL, REDIRECT_TO_USER_ORGANIZATION_MEMBERSHIPS_URL, REDIRECT_TO_USER_ORGANIZATIONS_URL, REDIRECT_TO_USER_PRESENCE_RECORD_URL, REDIRECT_TO_USER_PROJECT_MEMBERSHIPS_URL, REDIRECT_TO_USER_PROJECTS_URL, REDIRECT_TO_USER_USAGE_HISTORY_URL, REDIRECT_TO_USER_USAGE_SUMMARY_URL, REDO_EDIT_SESSION_URL, REFRESH_CONTENT_TREE_URL, REFRESH_EDIT_SESSION_CONTENT_TREE_URL, REFRESH_THREAD_CONTENT_TREE_URL, REFRESH_TOKEN_URL, REIMPORT_CONTENT_PATH_URL, REIMPORT_EDIT_SESSION_CONTENT_PATH_URL, REIMPORT_FS_ENTRY_URL, REIMPORT_THREAD_CONTENT_PATH_URL, REIMPORT_THREAD_FS_ENTRY_URL, REMOVE_ORGANIZATION_MEMBER_URL, REMOVE_PROJECT_MEMBER_URL, RENAME_PROJECT_MARKETING_URL, REPLACE_FS_ENTRY_CONTENT_URL, REPLACE_THREAD_FS_ENTRY_CONTENT_URL, REPORT_USAGE_RECORDS_URL, REQUEST_THREAD_UPLOAD_URL_URL, REQUEST_UPLOAD_URL_URL, REVERT_EDIT_SESSION_URL, REVERT_THREAD_URL, REVOKE_PROJECT_INVITE_LINK_URL, RUN_EDIT_SESSION_PLUGIN_BINARY_URL, RUN_EDIT_SESSION_PLUGIN_SCRIPT_URL, RUN_EDIT_SESSION_SKILL_BINARY_URL, RUN_EDIT_SESSION_SKILL_SCRIPT_URL, RUN_EDIT_SESSION_THREAD_PLUGIN_BINARY_URL, RUN_EDIT_SESSION_THREAD_PLUGIN_SCRIPT_URL, RUN_EDIT_SESSION_THREAD_SKILL_BINARY_URL, RUN_EDIT_SESSION_THREAD_SKILL_SCRIPT_URL, RUN_PROJECT_PLUGIN_BINARY_URL, RUN_PROJECT_PLUGIN_SCRIPT_URL, RUN_PROJECT_SKILL_BINARY_URL, RUN_PROJECT_SKILL_SCRIPT_URL, SEARCH_EDIT_SESSION_AGENTIC_ARTIFACTS_URL, SEARCH_PROJECT_AGENTIC_ARTIFACTS_URL, SEARCH_THREAD_AGENTIC_ARTIFACTS_URL, SEED_LOCAL_DEV_ENTERPRISE_URL, SEED_ORG_PROJECTS_URL, SEND_ORGANIZATION_INVITATION_URL, SEND_PROJECT_INVITATION_URL, SET_DEFAULT_PAYMENT_METHOD_URL, SET_UP_BILLING_URL, SET_UP_USER_BILLING_URL, SET_USER_DEFAULT_PAYMENT_METHOD_URL, START_EDIT_SESSION_EXTERNAL_RUN_URL, START_PROJECT_EXTERNAL_RUN_URL, START_THREAD_EXTERNAL_RUN_URL, STOP_AI_PERSONA_ANSWER_URL, STREAM_EVENTS_URL, SWITCH_CHAT_BRANCH_URL, SYNC_EDIT_SESSION_URL, SYNC_THREAD_URL, TOUCH_EDIT_SESSION_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL, TOUCH_PROJECT_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL, TOUCH_THREAD_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL, TRANSFER_OWNERSHIP_URL, TRIGGER_EDIT_SESSION_VALIDATION_URL, TRIGGER_THREAD_VALIDATION_URL, UNARCHIVE_THREAD_URL, UNDO_EDIT_SESSION_URL, UPDATE_AI_PERSONA_URL, UPDATE_BUNDLE_DEPLOYMENT_URL, UPDATE_BUNDLE_ENVIRONMENT_URL, UPDATE_BUNDLE_SOURCE_URL, UPDATE_BUNDLE_URL, UPDATE_CHAT_BRANCH_MESSAGE_URL, UPDATE_CHAT_URL, UPDATE_EDIT_SESSION_EXTERNAL_RUN_SETTINGS_URL, UPDATE_EDIT_SESSION_URL, UPDATE_FS_ENTRY_URL, UPDATE_ORGANIZATION_MEMBER_URL, UPDATE_ORGANIZATION_URL, UPDATE_PROJECT_EXTERNAL_RUN_SETTINGS_URL, UPDATE_PROJECT_MEMBER_URL, UPDATE_PROJECT_URL, UPDATE_THREAD_EXTERNAL_RUN_SETTINGS_URL, UPDATE_THREAD_FS_ENTRY_URL, UPDATE_THREAD_URL, UPDATE_USER_BY_ID_URL, UPDATE_USER_URL, UPLOAD_BLOB_LOCAL_FILE_URL, UPLOAD_BLOB_LOCAL_GIT_FILE_URL, UPLOAD_PROJECT_THUMBNAIL_URL, UPLOAD_USER_AVATAR_REDIRECT_URL, UPLOAD_USER_AVATAR_URL, VALIDATE_EDIT_SESSION_FS_ENTRY_URL, VALIDATE_THREAD_FS_ENTRY_URL } from './urls.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Health check endpoint
 */
export const getHealth = <ThrowOnError extends boolean = false>(options?: Options<GetHealthData, ThrowOnError>): RequestResult<GetHealthResponses, GetHealthErrors, ThrowOnError> => (options?.client ?? client).get<GetHealthResponses, GetHealthErrors, ThrowOnError>({ url: GET_HEALTH_URL, ...options });

/**
 * List project agentic artifacts
 */
export const listProjectAgenticArtifacts = <ThrowOnError extends boolean = false>(options: Options<ListProjectAgenticArtifactsData, ThrowOnError>): RequestResult<ListProjectAgenticArtifactsResponses, ListProjectAgenticArtifactsErrors, ThrowOnError> => (options.client ?? client).get<ListProjectAgenticArtifactsResponses, ListProjectAgenticArtifactsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_PROJECT_AGENTIC_ARTIFACTS_URL,
    ...options
});

/**
 * Download project agentic artifact content
 *
 * Returns a 307 redirect to a signed URL for retrieving the raw file content or a packaged directory zip archive.
 */
export const getProjectAgenticArtifactContent = <ThrowOnError extends boolean = false>(options: Options<GetProjectAgenticArtifactContentData, ThrowOnError>): RequestResult<unknown, GetProjectAgenticArtifactContentErrors, ThrowOnError> => (options.client ?? client).get<unknown, GetProjectAgenticArtifactContentErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_PROJECT_AGENTIC_ARTIFACT_CONTENT_URL,
    ...options
});

/**
 * Search project agentic artifacts
 */
export const searchProjectAgenticArtifacts = <ThrowOnError extends boolean = false>(options: Options<SearchProjectAgenticArtifactsData, ThrowOnError>): RequestResult<SearchProjectAgenticArtifactsResponses, SearchProjectAgenticArtifactsErrors, ThrowOnError> => (options.client ?? client).get<SearchProjectAgenticArtifactsResponses, SearchProjectAgenticArtifactsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: SEARCH_PROJECT_AGENTIC_ARTIFACTS_URL,
    ...options
});

/**
 * List edit session agentic artifacts
 */
export const listEditSessionAgenticArtifacts = <ThrowOnError extends boolean = false>(options: Options<ListEditSessionAgenticArtifactsData, ThrowOnError>): RequestResult<ListEditSessionAgenticArtifactsResponses, ListEditSessionAgenticArtifactsErrors, ThrowOnError> => (options.client ?? client).get<ListEditSessionAgenticArtifactsResponses, ListEditSessionAgenticArtifactsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_EDIT_SESSION_AGENTIC_ARTIFACTS_URL,
    ...options
});

/**
 * Download edit session agentic artifact content
 *
 * Returns a 307 redirect to a signed URL for retrieving the raw file content or a packaged directory zip archive.
 */
export const getEditSessionAgenticArtifactContent = <ThrowOnError extends boolean = false>(options: Options<GetEditSessionAgenticArtifactContentData, ThrowOnError>): RequestResult<unknown, GetEditSessionAgenticArtifactContentErrors, ThrowOnError> => (options.client ?? client).get<unknown, GetEditSessionAgenticArtifactContentErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_EDIT_SESSION_AGENTIC_ARTIFACT_CONTENT_URL,
    ...options
});

/**
 * Search edit session agentic artifacts
 */
export const searchEditSessionAgenticArtifacts = <ThrowOnError extends boolean = false>(options: Options<SearchEditSessionAgenticArtifactsData, ThrowOnError>): RequestResult<SearchEditSessionAgenticArtifactsResponses, SearchEditSessionAgenticArtifactsErrors, ThrowOnError> => (options.client ?? client).get<SearchEditSessionAgenticArtifactsResponses, SearchEditSessionAgenticArtifactsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: SEARCH_EDIT_SESSION_AGENTIC_ARTIFACTS_URL,
    ...options
});

/**
 * List thread agentic artifacts
 */
export const listThreadAgenticArtifacts = <ThrowOnError extends boolean = false>(options: Options<ListThreadAgenticArtifactsData, ThrowOnError>): RequestResult<ListThreadAgenticArtifactsResponses, ListThreadAgenticArtifactsErrors, ThrowOnError> => (options.client ?? client).get<ListThreadAgenticArtifactsResponses, ListThreadAgenticArtifactsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_THREAD_AGENTIC_ARTIFACTS_URL,
    ...options
});

/**
 * Download thread agentic artifact content
 *
 * Returns a 307 redirect to a signed URL for retrieving the raw file content or a packaged directory zip archive.
 */
export const getThreadAgenticArtifactContent = <ThrowOnError extends boolean = false>(options: Options<GetThreadAgenticArtifactContentData, ThrowOnError>): RequestResult<unknown, GetThreadAgenticArtifactContentErrors, ThrowOnError> => (options.client ?? client).get<unknown, GetThreadAgenticArtifactContentErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_THREAD_AGENTIC_ARTIFACT_CONTENT_URL,
    ...options
});

/**
 * Search thread agentic artifacts
 */
export const searchThreadAgenticArtifacts = <ThrowOnError extends boolean = false>(options: Options<SearchThreadAgenticArtifactsData, ThrowOnError>): RequestResult<SearchThreadAgenticArtifactsResponses, SearchThreadAgenticArtifactsErrors, ThrowOnError> => (options.client ?? client).get<SearchThreadAgenticArtifactsResponses, SearchThreadAgenticArtifactsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: SEARCH_THREAD_AGENTIC_ARTIFACTS_URL,
    ...options
});

/**
 * Download agentic artifact content via signed token
 *
 * Returns the raw file content or a packaged directory zip archive. Range headers are supported only for file downloads.
 */
export const getAgenticArtifactContentByToken = <ThrowOnError extends boolean = false>(options: Options<GetAgenticArtifactContentByTokenData, ThrowOnError>): RequestResult<GetAgenticArtifactContentByTokenResponses, GetAgenticArtifactContentByTokenErrors, ThrowOnError> => (options.client ?? client).get<GetAgenticArtifactContentByTokenResponses, GetAgenticArtifactContentByTokenErrors, ThrowOnError>({ url: GET_AGENTIC_ARTIFACT_CONTENT_BY_TOKEN_URL, ...options });

/**
 * Begin an agentic artifact workspace transaction
 *
 * Creates an isolated virtual workspace. When source_path is omitted or
 * null, the virtual workspace starts empty. Otherwise, source_path is
 * snapshotted when the transaction begins. The transaction ID is the only
 * handle callers use for subsequent operations.
 *
 */
export const beginProjectAgenticArtifactWorkspaceTransaction = <ThrowOnError extends boolean = false>(options: Options<BeginProjectAgenticArtifactWorkspaceTransactionData, ThrowOnError>): RequestResult<BeginProjectAgenticArtifactWorkspaceTransactionResponses, BeginProjectAgenticArtifactWorkspaceTransactionErrors, ThrowOnError> => (options.client ?? client).post<BeginProjectAgenticArtifactWorkspaceTransactionResponses, BeginProjectAgenticArtifactWorkspaceTransactionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: BEGIN_PROJECT_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Abort an agentic artifact workspace transaction
 *
 * Aborts an open transaction and removes its isolated staging workspace.
 */
export const abortProjectAgenticArtifactWorkspaceTransaction = <ThrowOnError extends boolean = false>(options: Options<AbortProjectAgenticArtifactWorkspaceTransactionData, ThrowOnError>): RequestResult<AbortProjectAgenticArtifactWorkspaceTransactionResponses, AbortProjectAgenticArtifactWorkspaceTransactionErrors, ThrowOnError> => (options.client ?? client).delete<AbortProjectAgenticArtifactWorkspaceTransactionResponses, AbortProjectAgenticArtifactWorkspaceTransactionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: ABORT_PROJECT_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL,
    ...options
});

/**
 * Get agentic artifact workspace transaction status
 */
export const getProjectAgenticArtifactWorkspaceTransaction = <ThrowOnError extends boolean = false>(options: Options<GetProjectAgenticArtifactWorkspaceTransactionData, ThrowOnError>): RequestResult<GetProjectAgenticArtifactWorkspaceTransactionResponses, GetProjectAgenticArtifactWorkspaceTransactionErrors, ThrowOnError> => (options.client ?? client).get<GetProjectAgenticArtifactWorkspaceTransactionResponses, GetProjectAgenticArtifactWorkspaceTransactionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_PROJECT_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL,
    ...options
});

/**
 * Record activity on a project workspace transaction
 */
export const touchProjectAgenticArtifactWorkspaceTransaction = <ThrowOnError extends boolean = false>(options: Options<TouchProjectAgenticArtifactWorkspaceTransactionData, ThrowOnError>): RequestResult<TouchProjectAgenticArtifactWorkspaceTransactionResponses, TouchProjectAgenticArtifactWorkspaceTransactionErrors, ThrowOnError> => (options.client ?? client).post<TouchProjectAgenticArtifactWorkspaceTransactionResponses, TouchProjectAgenticArtifactWorkspaceTransactionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: TOUCH_PROJECT_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL,
    ...options
});

/**
 * Read content of a file in an agentic artifact workspace transaction
 *
 * Returns the raw content of a regular file from the transaction's current private root.
 * Range headers are supported. Symlinks and directories are rejected.
 *
 */
export const getProjectAgenticArtifactWorkspaceTransactionContent = <ThrowOnError extends boolean = false>(options: Options<GetProjectAgenticArtifactWorkspaceTransactionContentData, ThrowOnError>): RequestResult<GetProjectAgenticArtifactWorkspaceTransactionContentResponses, GetProjectAgenticArtifactWorkspaceTransactionContentErrors, ThrowOnError> => (options.client ?? client).get<GetProjectAgenticArtifactWorkspaceTransactionContentResponses, GetProjectAgenticArtifactWorkspaceTransactionContentErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_PROJECT_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_CONTENT_URL,
    ...options
});

/**
 * List entries in an agentic artifact workspace transaction
 *
 * Lists the transaction's current private root, equivalent to an ls operation.
 */
export const listProjectAgenticArtifactWorkspaceTransactionEntries = <ThrowOnError extends boolean = false>(options: Options<ListProjectAgenticArtifactWorkspaceTransactionEntriesData, ThrowOnError>): RequestResult<ListProjectAgenticArtifactWorkspaceTransactionEntriesResponses, ListProjectAgenticArtifactWorkspaceTransactionEntriesErrors, ThrowOnError> => (options.client ?? client).get<ListProjectAgenticArtifactWorkspaceTransactionEntriesResponses, ListProjectAgenticArtifactWorkspaceTransactionEntriesErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_PROJECT_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_ENTRIES_URL,
    ...options
});

/**
 * Apply one complete unified text diff
 *
 * Applies one complete multi-file Git-compatible unified diff to the
 * transaction's current private root. The entire request is accepted or
 * rejected: if any file or hunk conflicts, no file from the request is
 * retained and the response identifies every detected conflict.
 *
 * The MVP accepts regular text files only. Git's `new file mode 100644`
 * header is accepted and ignored; added files receive the server's fixed
 * non-executable regular-file mode. Binary hunks, renames, copies,
 * executable or special modes, symlinks, absolute paths, and path traversal
 * are rejected.
 *
 */
export const applyProjectAgenticArtifactWorkspaceTransactionPatch = <ThrowOnError extends boolean = false>(options: Options<ApplyProjectAgenticArtifactWorkspaceTransactionPatchData, ThrowOnError>): RequestResult<ApplyProjectAgenticArtifactWorkspaceTransactionPatchResponses, ApplyProjectAgenticArtifactWorkspaceTransactionPatchErrors, ThrowOnError> => (options.client ?? client).post<ApplyProjectAgenticArtifactWorkspaceTransactionPatchResponses, ApplyProjectAgenticArtifactWorkspaceTransactionPatchErrors, ThrowOnError>({
    bodySerializer: null,
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: APPLY_PROJECT_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_PATCH_URL,
    ...options,
    headers: {
        'Content-Type': 'text/x-diff',
        ...options.headers
    }
});

/**
 * Promote an agentic artifact workspace transaction
 *
 * Makes the completed private root visible at destination_path. With
 * require_not_exist, promotion fails if the destination already exists.
 * With override, an existing destination is moved to a same-filesystem,
 * transaction-specific backup, the staged root is moved into place, and
 * the backup is deleted only after promotion is durably committed.
 *
 */
export const promoteProjectAgenticArtifactWorkspaceTransaction = <ThrowOnError extends boolean = false>(options: Options<PromoteProjectAgenticArtifactWorkspaceTransactionData, ThrowOnError>): RequestResult<PromoteProjectAgenticArtifactWorkspaceTransactionResponses, PromoteProjectAgenticArtifactWorkspaceTransactionErrors, ThrowOnError> => (options.client ?? client).post<PromoteProjectAgenticArtifactWorkspaceTransactionResponses, PromoteProjectAgenticArtifactWorkspaceTransactionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: PROMOTE_PROJECT_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Begin an edit-session agentic artifact workspace transaction
 */
export const beginEditSessionAgenticArtifactWorkspaceTransaction = <ThrowOnError extends boolean = false>(options: Options<BeginEditSessionAgenticArtifactWorkspaceTransactionData, ThrowOnError>): RequestResult<BeginEditSessionAgenticArtifactWorkspaceTransactionResponses, BeginEditSessionAgenticArtifactWorkspaceTransactionErrors, ThrowOnError> => (options.client ?? client).post<BeginEditSessionAgenticArtifactWorkspaceTransactionResponses, BeginEditSessionAgenticArtifactWorkspaceTransactionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: BEGIN_EDIT_SESSION_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Abort an edit-session agentic artifact workspace transaction
 */
export const abortEditSessionAgenticArtifactWorkspaceTransaction = <ThrowOnError extends boolean = false>(options: Options<AbortEditSessionAgenticArtifactWorkspaceTransactionData, ThrowOnError>): RequestResult<AbortEditSessionAgenticArtifactWorkspaceTransactionResponses, AbortEditSessionAgenticArtifactWorkspaceTransactionErrors, ThrowOnError> => (options.client ?? client).delete<AbortEditSessionAgenticArtifactWorkspaceTransactionResponses, AbortEditSessionAgenticArtifactWorkspaceTransactionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: ABORT_EDIT_SESSION_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL,
    ...options
});

/**
 * Get edit-session agentic artifact workspace transaction status
 */
export const getEditSessionAgenticArtifactWorkspaceTransaction = <ThrowOnError extends boolean = false>(options: Options<GetEditSessionAgenticArtifactWorkspaceTransactionData, ThrowOnError>): RequestResult<GetEditSessionAgenticArtifactWorkspaceTransactionResponses, GetEditSessionAgenticArtifactWorkspaceTransactionErrors, ThrowOnError> => (options.client ?? client).get<GetEditSessionAgenticArtifactWorkspaceTransactionResponses, GetEditSessionAgenticArtifactWorkspaceTransactionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_EDIT_SESSION_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL,
    ...options
});

/**
 * Record activity on an edit-session workspace transaction
 */
export const touchEditSessionAgenticArtifactWorkspaceTransaction = <ThrowOnError extends boolean = false>(options: Options<TouchEditSessionAgenticArtifactWorkspaceTransactionData, ThrowOnError>): RequestResult<TouchEditSessionAgenticArtifactWorkspaceTransactionResponses, TouchEditSessionAgenticArtifactWorkspaceTransactionErrors, ThrowOnError> => (options.client ?? client).post<TouchEditSessionAgenticArtifactWorkspaceTransactionResponses, TouchEditSessionAgenticArtifactWorkspaceTransactionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: TOUCH_EDIT_SESSION_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL,
    ...options
});

/**
 * Read edit-session workspace transaction file content
 */
export const getEditSessionAgenticArtifactWorkspaceTransactionContent = <ThrowOnError extends boolean = false>(options: Options<GetEditSessionAgenticArtifactWorkspaceTransactionContentData, ThrowOnError>): RequestResult<GetEditSessionAgenticArtifactWorkspaceTransactionContentResponses, GetEditSessionAgenticArtifactWorkspaceTransactionContentErrors, ThrowOnError> => (options.client ?? client).get<GetEditSessionAgenticArtifactWorkspaceTransactionContentResponses, GetEditSessionAgenticArtifactWorkspaceTransactionContentErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_EDIT_SESSION_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_CONTENT_URL,
    ...options
});

/**
 * List entries in an edit-session workspace transaction
 */
export const listEditSessionAgenticArtifactWorkspaceTransactionEntries = <ThrowOnError extends boolean = false>(options: Options<ListEditSessionAgenticArtifactWorkspaceTransactionEntriesData, ThrowOnError>): RequestResult<ListEditSessionAgenticArtifactWorkspaceTransactionEntriesResponses, ListEditSessionAgenticArtifactWorkspaceTransactionEntriesErrors, ThrowOnError> => (options.client ?? client).get<ListEditSessionAgenticArtifactWorkspaceTransactionEntriesResponses, ListEditSessionAgenticArtifactWorkspaceTransactionEntriesErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_EDIT_SESSION_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_ENTRIES_URL,
    ...options
});

/**
 * Apply a patch to an edit-session workspace transaction
 */
export const applyEditSessionAgenticArtifactWorkspaceTransactionPatch = <ThrowOnError extends boolean = false>(options: Options<ApplyEditSessionAgenticArtifactWorkspaceTransactionPatchData, ThrowOnError>): RequestResult<ApplyEditSessionAgenticArtifactWorkspaceTransactionPatchResponses, ApplyEditSessionAgenticArtifactWorkspaceTransactionPatchErrors, ThrowOnError> => (options.client ?? client).post<ApplyEditSessionAgenticArtifactWorkspaceTransactionPatchResponses, ApplyEditSessionAgenticArtifactWorkspaceTransactionPatchErrors, ThrowOnError>({
    bodySerializer: null,
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: APPLY_EDIT_SESSION_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_PATCH_URL,
    ...options,
    headers: {
        'Content-Type': 'text/x-diff',
        ...options.headers
    }
});

/**
 * Promote an edit-session agentic artifact workspace transaction
 */
export const promoteEditSessionAgenticArtifactWorkspaceTransaction = <ThrowOnError extends boolean = false>(options: Options<PromoteEditSessionAgenticArtifactWorkspaceTransactionData, ThrowOnError>): RequestResult<PromoteEditSessionAgenticArtifactWorkspaceTransactionResponses, PromoteEditSessionAgenticArtifactWorkspaceTransactionErrors, ThrowOnError> => (options.client ?? client).post<PromoteEditSessionAgenticArtifactWorkspaceTransactionResponses, PromoteEditSessionAgenticArtifactWorkspaceTransactionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: PROMOTE_EDIT_SESSION_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Begin a thread agentic artifact workspace transaction
 */
export const beginThreadAgenticArtifactWorkspaceTransaction = <ThrowOnError extends boolean = false>(options: Options<BeginThreadAgenticArtifactWorkspaceTransactionData, ThrowOnError>): RequestResult<BeginThreadAgenticArtifactWorkspaceTransactionResponses, BeginThreadAgenticArtifactWorkspaceTransactionErrors, ThrowOnError> => (options.client ?? client).post<BeginThreadAgenticArtifactWorkspaceTransactionResponses, BeginThreadAgenticArtifactWorkspaceTransactionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: BEGIN_THREAD_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Abort a thread agentic artifact workspace transaction
 */
export const abortThreadAgenticArtifactWorkspaceTransaction = <ThrowOnError extends boolean = false>(options: Options<AbortThreadAgenticArtifactWorkspaceTransactionData, ThrowOnError>): RequestResult<AbortThreadAgenticArtifactWorkspaceTransactionResponses, AbortThreadAgenticArtifactWorkspaceTransactionErrors, ThrowOnError> => (options.client ?? client).delete<AbortThreadAgenticArtifactWorkspaceTransactionResponses, AbortThreadAgenticArtifactWorkspaceTransactionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: ABORT_THREAD_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL,
    ...options
});

/**
 * Get thread agentic artifact workspace transaction status
 */
export const getThreadAgenticArtifactWorkspaceTransaction = <ThrowOnError extends boolean = false>(options: Options<GetThreadAgenticArtifactWorkspaceTransactionData, ThrowOnError>): RequestResult<GetThreadAgenticArtifactWorkspaceTransactionResponses, GetThreadAgenticArtifactWorkspaceTransactionErrors, ThrowOnError> => (options.client ?? client).get<GetThreadAgenticArtifactWorkspaceTransactionResponses, GetThreadAgenticArtifactWorkspaceTransactionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_THREAD_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL,
    ...options
});

/**
 * Record activity on a thread workspace transaction
 */
export const touchThreadAgenticArtifactWorkspaceTransaction = <ThrowOnError extends boolean = false>(options: Options<TouchThreadAgenticArtifactWorkspaceTransactionData, ThrowOnError>): RequestResult<TouchThreadAgenticArtifactWorkspaceTransactionResponses, TouchThreadAgenticArtifactWorkspaceTransactionErrors, ThrowOnError> => (options.client ?? client).post<TouchThreadAgenticArtifactWorkspaceTransactionResponses, TouchThreadAgenticArtifactWorkspaceTransactionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: TOUCH_THREAD_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL,
    ...options
});

/**
 * Read thread workspace transaction file content
 */
export const getThreadAgenticArtifactWorkspaceTransactionContent = <ThrowOnError extends boolean = false>(options: Options<GetThreadAgenticArtifactWorkspaceTransactionContentData, ThrowOnError>): RequestResult<GetThreadAgenticArtifactWorkspaceTransactionContentResponses, GetThreadAgenticArtifactWorkspaceTransactionContentErrors, ThrowOnError> => (options.client ?? client).get<GetThreadAgenticArtifactWorkspaceTransactionContentResponses, GetThreadAgenticArtifactWorkspaceTransactionContentErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_THREAD_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_CONTENT_URL,
    ...options
});

/**
 * List entries in a thread workspace transaction
 */
export const listThreadAgenticArtifactWorkspaceTransactionEntries = <ThrowOnError extends boolean = false>(options: Options<ListThreadAgenticArtifactWorkspaceTransactionEntriesData, ThrowOnError>): RequestResult<ListThreadAgenticArtifactWorkspaceTransactionEntriesResponses, ListThreadAgenticArtifactWorkspaceTransactionEntriesErrors, ThrowOnError> => (options.client ?? client).get<ListThreadAgenticArtifactWorkspaceTransactionEntriesResponses, ListThreadAgenticArtifactWorkspaceTransactionEntriesErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_THREAD_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_ENTRIES_URL,
    ...options
});

/**
 * Apply a patch to a thread workspace transaction
 */
export const applyThreadAgenticArtifactWorkspaceTransactionPatch = <ThrowOnError extends boolean = false>(options: Options<ApplyThreadAgenticArtifactWorkspaceTransactionPatchData, ThrowOnError>): RequestResult<ApplyThreadAgenticArtifactWorkspaceTransactionPatchResponses, ApplyThreadAgenticArtifactWorkspaceTransactionPatchErrors, ThrowOnError> => (options.client ?? client).post<ApplyThreadAgenticArtifactWorkspaceTransactionPatchResponses, ApplyThreadAgenticArtifactWorkspaceTransactionPatchErrors, ThrowOnError>({
    bodySerializer: null,
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: APPLY_THREAD_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_PATCH_URL,
    ...options,
    headers: {
        'Content-Type': 'text/x-diff',
        ...options.headers
    }
});

/**
 * Promote a thread agentic artifact workspace transaction
 */
export const promoteThreadAgenticArtifactWorkspaceTransaction = <ThrowOnError extends boolean = false>(options: Options<PromoteThreadAgenticArtifactWorkspaceTransactionData, ThrowOnError>): RequestResult<PromoteThreadAgenticArtifactWorkspaceTransactionResponses, PromoteThreadAgenticArtifactWorkspaceTransactionErrors, ThrowOnError> => (options.client ?? client).post<PromoteThreadAgenticArtifactWorkspaceTransactionResponses, PromoteThreadAgenticArtifactWorkspaceTransactionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: PROMOTE_THREAD_AGENTIC_ARTIFACT_WORKSPACE_TRANSACTION_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all AI personas
 */
export const listAiPersonas = <ThrowOnError extends boolean = false>(options?: Options<ListAiPersonasData, ThrowOnError>): RequestResult<ListAiPersonasResponses, ListAiPersonasErrors, ThrowOnError> => (options?.client ?? client).get<ListAiPersonasResponses, ListAiPersonasErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_AI_PERSONAS_URL,
    ...options
});

/**
 * Create a new AI persona
 */
export const createAiPersona = <ThrowOnError extends boolean = false>(options: Options<CreateAiPersonaData, ThrowOnError>): RequestResult<CreateAiPersonaResponses, CreateAiPersonaErrors, ThrowOnError> => (options.client ?? client).post<CreateAiPersonaResponses, CreateAiPersonaErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_AI_PERSONA_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an AI persona by ID
 */
export const deleteAiPersona = <ThrowOnError extends boolean = false>(options: Options<DeleteAiPersonaData, ThrowOnError>): RequestResult<DeleteAiPersonaResponses, DeleteAiPersonaErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAiPersonaResponses, DeleteAiPersonaErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: DELETE_AI_PERSONA_URL,
    ...options
});

/**
 * Get an AI persona by ID
 */
export const getAiPersona = <ThrowOnError extends boolean = false>(options: Options<GetAiPersonaData, ThrowOnError>): RequestResult<GetAiPersonaResponses, GetAiPersonaErrors, ThrowOnError> => (options.client ?? client).get<GetAiPersonaResponses, GetAiPersonaErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_AI_PERSONA_URL,
    ...options
});

/**
 * Update an AI persona by ID
 */
export const updateAiPersona = <ThrowOnError extends boolean = false>(options: Options<UpdateAiPersonaData, ThrowOnError>): RequestResult<UpdateAiPersonaResponses, UpdateAiPersonaErrors, ThrowOnError> => (options.client ?? client).patch<UpdateAiPersonaResponses, UpdateAiPersonaErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: UPDATE_AI_PERSONA_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Stop current AI persona answer generation
 */
export const stopAiPersonaAnswer = <ThrowOnError extends boolean = false>(options: Options<StopAiPersonaAnswerData, ThrowOnError>): RequestResult<StopAiPersonaAnswerResponses, StopAiPersonaAnswerErrors, ThrowOnError> => (options.client ?? client).post<StopAiPersonaAnswerResponses, StopAiPersonaAnswerErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: STOP_AI_PERSONA_ANSWER_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Refresh access token
 */
export const refreshToken = <ThrowOnError extends boolean = false>(options: Options<RefreshTokenData, ThrowOnError>): RequestResult<RefreshTokenResponses, RefreshTokenErrors, ThrowOnError> => (options.client ?? client).post<RefreshTokenResponses, RefreshTokenErrors, ThrowOnError>({ url: REFRESH_TOKEN_URL, ...options });

/**
 * End user session
 */
export const logout = <ThrowOnError extends boolean = false>(options: Options<LogoutData, ThrowOnError>): RequestResult<LogoutResponses, LogoutErrors, ThrowOnError> => (options.client ?? client).post<LogoutResponses, LogoutErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LOGOUT_URL,
    ...options
});

/**
 * Mint a capability token for an admitted audience
 */
export const createCapabilityToken = <ThrowOnError extends boolean = false>(options: Options<CreateCapabilityTokenData, ThrowOnError>): RequestResult<CreateCapabilityTokenResponses, CreateCapabilityTokenErrors, ThrowOnError> => (options.client ?? client).post<CreateCapabilityTokenResponses, CreateCapabilityTokenErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_CAPABILITY_TOKEN_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mint a capability token for browser clients
 */
export const browserCreateCapabilityToken = <ThrowOnError extends boolean = false>(options: Options<BrowserCreateCapabilityTokenData, ThrowOnError>): RequestResult<BrowserCreateCapabilityTokenResponses, BrowserCreateCapabilityTokenErrors, ThrowOnError> => (options.client ?? client).post<BrowserCreateCapabilityTokenResponses, BrowserCreateCapabilityTokenErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '_session_token-47f9d89c4',
            type: 'apiKey'
        }],
    url: BROWSER_CREATE_CAPABILITY_TOKEN_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * End user session
 */
export const browserLogout = <ThrowOnError extends boolean = false>(options?: Options<BrowserLogoutData, ThrowOnError>): RequestResult<BrowserLogoutResponses, BrowserLogoutErrors, ThrowOnError> => (options?.client ?? client).post<BrowserLogoutResponses, BrowserLogoutErrors, ThrowOnError>({ url: BROWSER_LOGOUT_URL, ...options });

/**
 * Login or signup with Google ID Token
 */
export const googleLogin = <ThrowOnError extends boolean = false>(options: Options<GoogleLoginData, ThrowOnError>): RequestResult<GoogleLoginResponses, GoogleLoginErrors, ThrowOnError> => (options.client ?? client).post<GoogleLoginResponses, GoogleLoginErrors, ThrowOnError>({
    url: GOOGLE_LOGIN_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Login or signup with Google ID Token for browser clients
 */
export const browserGoogleLogin = <ThrowOnError extends boolean = false>(options: Options<BrowserGoogleLoginData, ThrowOnError>): RequestResult<BrowserGoogleLoginResponses, BrowserGoogleLoginErrors, ThrowOnError> => (options.client ?? client).post<BrowserGoogleLoginResponses, BrowserGoogleLoginErrors, ThrowOnError>({
    url: BROWSER_GOOGLE_LOGIN_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mint a short-lived authcode for an external service
 */
export const generateExternalAuthCode = <ThrowOnError extends boolean = false>(options: Options<GenerateExternalAuthCodeData, ThrowOnError>): RequestResult<GenerateExternalAuthCodeResponses, GenerateExternalAuthCodeErrors, ThrowOnError> => (options.client ?? client).post<GenerateExternalAuthCodeResponses, GenerateExternalAuthCodeErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GENERATE_EXTERNAL_AUTH_CODE_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mint a short-lived authcode for an external service for browser clients
 */
export const browserGenerateExternalAuthCode = <ThrowOnError extends boolean = false>(options: Options<BrowserGenerateExternalAuthCodeData, ThrowOnError>): RequestResult<BrowserGenerateExternalAuthCodeResponses, BrowserGenerateExternalAuthCodeErrors, ThrowOnError> => (options.client ?? client).post<BrowserGenerateExternalAuthCodeResponses, BrowserGenerateExternalAuthCodeErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '_session_token-47f9d89c4',
            type: 'apiKey'
        }],
    url: BROWSER_GENERATE_EXTERNAL_AUTH_CODE_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Redeem an authcode for an identity token
 */
export const redeemExternalAuthCode = <ThrowOnError extends boolean = false>(options: Options<RedeemExternalAuthCodeData, ThrowOnError>): RequestResult<RedeemExternalAuthCodeResponses, RedeemExternalAuthCodeErrors, ThrowOnError> => (options.client ?? client).post<RedeemExternalAuthCodeResponses, RedeemExternalAuthCodeErrors, ThrowOnError>({
    security: [{
            key: 'ServiceAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REDEEM_EXTERNAL_AUTH_CODE_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Development login (for testing purposes)
 */
export const devLogin = <ThrowOnError extends boolean = false>(options: Options<DevLoginData, ThrowOnError>): RequestResult<DevLoginResponses, DevLoginErrors, ThrowOnError> => (options.client ?? client).post<DevLoginResponses, DevLoginErrors, ThrowOnError>({
    url: DEV_LOGIN_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Development login for browser clients (for testing purposes)
 */
export const browserDevLogin = <ThrowOnError extends boolean = false>(options: Options<BrowserDevLoginData, ThrowOnError>): RequestResult<BrowserDevLoginResponses, BrowserDevLoginErrors, ThrowOnError> => (options.client ?? client).post<BrowserDevLoginResponses, BrowserDevLoginErrors, ThrowOnError>({
    url: BROWSER_DEV_LOGIN_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check whether the authenticated user may perform one or more actions on concrete resources
 */
export const checkAuthzActions = <ThrowOnError extends boolean = false>(options: Options<CheckAuthzActionsData, ThrowOnError>): RequestResult<CheckAuthzActionsResponses, CheckAuthzActionsErrors, ThrowOnError> => (options.client ?? client).post<CheckAuthzActionsResponses, CheckAuthzActionsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CHECK_AUTHZ_ACTIONS_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get organization billing summary
 *
 * Composes Dream Studio workflow and cached entitlement state with short-cached
 * Stripe display data. A vendor display failure does not fail the whole request:
 * fields owned by that vendor are null when no stored value exists, and its
 * unavailable marker is true.
 *
 * An organization without a billing account (never provisioned) returns `200` with
 * `account_state: not_provisioned`. Ledger-derived money and internal provider cost
 * are never returned. The usage window is the current UTC calendar month-to-date.
 *
 */
export const getBillingSummary = <ThrowOnError extends boolean = false>(options: Options<GetBillingSummaryData, ThrowOnError>): RequestResult<GetBillingSummaryResponses, GetBillingSummaryErrors, ThrowOnError> => (options.client ?? client).get<GetBillingSummaryResponses, GetBillingSummaryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_BILLING_SUMMARY_URL,
    ...options
});

/**
 * List organization payment methods
 *
 * Reads attached card payment methods and the actual invoice default from Stripe.
 * Removability is computed by Dream Studio from canonical Stripe state and is only
 * a rendering hint; deletion re-evaluates the rule. The complete collection is
 * returned because removability depends on the full method set. The default method
 * is first, followed by all other methods newest attached first; this endpoint is
 * intentionally not paginated in v1.
 *
 */
export const listBillingPaymentMethods = <ThrowOnError extends boolean = false>(options: Options<ListBillingPaymentMethodsData, ThrowOnError>): RequestResult<ListBillingPaymentMethodsResponses, ListBillingPaymentMethodsErrors, ThrowOnError> => (options.client ?? client).get<ListBillingPaymentMethodsResponses, ListBillingPaymentMethodsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_BILLING_PAYMENT_METHODS_URL,
    ...options
});

/**
 * Create or resume payment-method setup
 *
 * Creates or retrieves the Stripe setup object identified by the client-minted
 * Dream Studio `attempt_id`. Repeating an open attempt returns the same provider
 * setup and client secret. Reusing a closed attempt returns
 * `409 SETUP_ATTEMPT_NOT_OPEN`.
 *
 * Stripe returns the browser to the client's `return_path` on the request's own origin
 * (from trusted proxy metadata), with `attempt-id=<attempt_id>` appended to its query. The browser
 * cannot supply an origin, Stripe Customer ID, or provider setup-object ID.
 *
 */
export const createPaymentMethodSetup = <ThrowOnError extends boolean = false>(options: Options<CreatePaymentMethodSetupData, ThrowOnError>): RequestResult<CreatePaymentMethodSetupResponses, CreatePaymentMethodSetupErrors, ThrowOnError> => (options.client ?? client).post<CreatePaymentMethodSetupResponses, CreatePaymentMethodSetupErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_PAYMENT_METHOD_SETUP_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get payment-method setup attempt
 *
 * Returns Dream Studio's organization-scoped setup-attempt resource. `attempt_id`
 * is never interchangeable with a Stripe Checkout Session or SetupIntent ID.
 *
 */
export const getPaymentMethodSetupAttempt = <ThrowOnError extends boolean = false>(options: Options<GetPaymentMethodSetupAttemptData, ThrowOnError>): RequestResult<GetPaymentMethodSetupAttemptResponses, GetPaymentMethodSetupAttemptErrors, ThrowOnError> => (options.client ?? client).get<GetPaymentMethodSetupAttemptResponses, GetPaymentMethodSetupAttemptErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_PAYMENT_METHOD_SETUP_ATTEMPT_URL,
    ...options
});

/**
 * Get Dream Bucks purchase options
 *
 * What an organization can buy and at what price. The unit price comes from the server's
 * Dream Bucks peg; presets and bounds from its purchase configuration. `enabled` is false
 * while purchases are switched off.
 *
 */
export const getBillingPurchaseOptions = <ThrowOnError extends boolean = false>(options: Options<GetBillingPurchaseOptionsData, ThrowOnError>): RequestResult<GetBillingPurchaseOptionsResponses, GetBillingPurchaseOptionsErrors, ThrowOnError> => (options.client ?? client).get<GetBillingPurchaseOptionsResponses, GetBillingPurchaseOptionsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_BILLING_PURCHASE_OPTIONS_URL,
    ...options
});

/**
 * Create or resume a Dream Bucks purchase
 *
 * Creates or resumes the embedded Stripe Checkout (card payment) for the client-minted
 * `attempt_id`. Repeating an open attempt returns the same checkout; reusing one with another
 * amount is a 400, and reusing a closed one `409 PURCHASE_ATTEMPT_NOT_OPEN`. The organization
 * must have a provisioned billing account. Once paid, the Dream Bucks are added by webhook;
 * poll the purchase attempt until it is `succeeded`. Every purchase also yields a Stripe invoice.
 *
 * Stripe returns the browser to the client's `return_path` on the request's own origin
 * (from trusted proxy metadata), with `attempt-id=<attempt_id>` appended to its query.
 *
 */
export const createBillingPurchase = <ThrowOnError extends boolean = false>(options: Options<CreateBillingPurchaseData, ThrowOnError>): RequestResult<CreateBillingPurchaseResponses, CreateBillingPurchaseErrors, ThrowOnError> => (options.client ?? client).post<CreateBillingPurchaseResponses, CreateBillingPurchaseErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_BILLING_PURCHASE_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a Dream Bucks purchase attempt
 *
 * Dream Studio's purchase-attempt resource; its status advances by Stripe webhook. `attempt_id`
 * is never interchangeable with a Stripe Checkout Session ID.
 *
 */
export const getBillingPurchaseAttempt = <ThrowOnError extends boolean = false>(options: Options<GetBillingPurchaseAttemptData, ThrowOnError>): RequestResult<GetBillingPurchaseAttemptResponses, GetBillingPurchaseAttemptErrors, ThrowOnError> => (options.client ?? client).get<GetBillingPurchaseAttemptResponses, GetBillingPurchaseAttemptErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_BILLING_PURCHASE_ATTEMPT_URL,
    ...options
});

/**
 * Set the invoice default payment method
 *
 * Verifies the payment method belongs to the organization's Stripe Customer,
 * records a new desired-default version, and applies it as Stripe's invoice
 * default before answering. After a 204, the next payment-method read shows the
 * new default. On a 503 the desired default is kept and applied by the next
 * set-default or completed card setup; retrying is safe.
 *
 */
export const setDefaultPaymentMethod = <ThrowOnError extends boolean = false>(options: Options<SetDefaultPaymentMethodData, ThrowOnError>): RequestResult<SetDefaultPaymentMethodResponses, SetDefaultPaymentMethodErrors, ThrowOnError> => (options.client ?? client).post<SetDefaultPaymentMethodResponses, SetDefaultPaymentMethodErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: SET_DEFAULT_PAYMENT_METHOD_URL,
    ...options
});

/**
 * Delete an organization payment method
 *
 * Fetches canonical Stripe state, verifies organization ownership, and re-evaluates
 * removability before detaching the payment method. A cached `removable: true`
 * value never authorizes deletion.
 *
 */
export const deleteBillingPaymentMethod = <ThrowOnError extends boolean = false>(options: Options<DeleteBillingPaymentMethodData, ThrowOnError>): RequestResult<DeleteBillingPaymentMethodResponses, DeleteBillingPaymentMethodErrors, ThrowOnError> => (options.client ?? client).delete<DeleteBillingPaymentMethodResponses, DeleteBillingPaymentMethodErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: DELETE_BILLING_PAYMENT_METHOD_URL,
    ...options
});

/**
 * List organization invoices
 *
 * Reads Stripe invoices live, newest first by Stripe invoice creation time. Draft
 * invoices are left out (not final: no number, amounts may still change). Stripe
 * pagination identifiers are encapsulated in Dream Studio's opaque cursors. A
 * request using `cursor` must omit `page_size`; this list does not support `around`.
 *
 */
export const listBillingInvoices = <ThrowOnError extends boolean = false>(options: Options<ListBillingInvoicesData, ThrowOnError>): RequestResult<ListBillingInvoicesResponses, ListBillingInvoicesErrors, ThrowOnError> => (options.client ?? client).get<ListBillingInvoicesResponses, ListBillingInvoicesErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_BILLING_INVOICES_URL,
    ...options
});

/**
 * Get organization invoice
 *
 * Fetches the Stripe invoice live and verifies that its Customer matches the
 * organization's billing account. The hosted URL is returned on the resource;
 * there is no separate action endpoint for opening an invoice.
 *
 */
export const getBillingInvoice = <ThrowOnError extends boolean = false>(options: Options<GetBillingInvoiceData, ThrowOnError>): RequestResult<GetBillingInvoiceResponses, GetBillingInvoiceErrors, ThrowOnError> => (options.client ?? client).get<GetBillingInvoiceResponses, GetBillingInvoiceErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_BILLING_INVOICE_URL,
    ...options
});

/**
 * Create customer portal session
 *
 * Creates a short-lived Stripe Customer Portal session. The portal's way back is the
 * client's `return_path` on the request's own origin (from trusted proxy metadata); the
 * browser cannot supply an origin or Stripe Customer ID.
 *
 */
export const createCustomerPortalSession = <ThrowOnError extends boolean = false>(options: Options<CreateCustomerPortalSessionData, ThrowOnError>): RequestResult<CreateCustomerPortalSessionResponses, CreateCustomerPortalSessionErrors, ThrowOnError> => (options.client ?? client).post<CreateCustomerPortalSessionResponses, CreateCustomerPortalSessionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_CUSTOMER_PORTAL_SESSION_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set up the organization's billing
 *
 * Self-serve setup: creates or resumes the organization's billing account (Stripe customer,
 * Metronome customer and contract), then grants the server's starter Dream Bucks, if any, once
 * per payer. Idempotent: repeating it completes a setup that failed partway, and changes nothing
 * once the account is ready. Offer it while the billing summary's `setup_available` is true;
 * afterwards the summary reads `account_state: ready`.
 *
 */
export const setUpBilling = <ThrowOnError extends boolean = false>(options: Options<SetUpBillingData, ThrowOnError>): RequestResult<SetUpBillingResponses, SetUpBillingErrors, ThrowOnError> => (options.client ?? client).post<SetUpBillingResponses, SetUpBillingErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: SET_UP_BILLING_URL,
    ...options
});

/**
 * Get a user's billing summary
 */
export const getUserBillingSummary = <ThrowOnError extends boolean = false>(options: Options<GetUserBillingSummaryData, ThrowOnError>): RequestResult<GetUserBillingSummaryResponses, GetUserBillingSummaryErrors, ThrowOnError> => (options.client ?? client).get<GetUserBillingSummaryResponses, GetUserBillingSummaryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_USER_BILLING_SUMMARY_URL,
    ...options
});

/**
 * List a user's payment methods
 */
export const listUserBillingPaymentMethods = <ThrowOnError extends boolean = false>(options: Options<ListUserBillingPaymentMethodsData, ThrowOnError>): RequestResult<ListUserBillingPaymentMethodsResponses, ListUserBillingPaymentMethodsErrors, ThrowOnError> => (options.client ?? client).get<ListUserBillingPaymentMethodsResponses, ListUserBillingPaymentMethodsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_USER_BILLING_PAYMENT_METHODS_URL,
    ...options
});

/**
 * Create or resume a user's payment-method setup
 */
export const createUserPaymentMethodSetup = <ThrowOnError extends boolean = false>(options: Options<CreateUserPaymentMethodSetupData, ThrowOnError>): RequestResult<CreateUserPaymentMethodSetupResponses, CreateUserPaymentMethodSetupErrors, ThrowOnError> => (options.client ?? client).post<CreateUserPaymentMethodSetupResponses, CreateUserPaymentMethodSetupErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_USER_PAYMENT_METHOD_SETUP_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a user's payment-method setup attempt
 */
export const getUserPaymentMethodSetupAttempt = <ThrowOnError extends boolean = false>(options: Options<GetUserPaymentMethodSetupAttemptData, ThrowOnError>): RequestResult<GetUserPaymentMethodSetupAttemptResponses, GetUserPaymentMethodSetupAttemptErrors, ThrowOnError> => (options.client ?? client).get<GetUserPaymentMethodSetupAttemptResponses, GetUserPaymentMethodSetupAttemptErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_USER_PAYMENT_METHOD_SETUP_ATTEMPT_URL,
    ...options
});

/**
 * Get a user's Dream Bucks purchase options
 */
export const getUserBillingPurchaseOptions = <ThrowOnError extends boolean = false>(options: Options<GetUserBillingPurchaseOptionsData, ThrowOnError>): RequestResult<GetUserBillingPurchaseOptionsResponses, GetUserBillingPurchaseOptionsErrors, ThrowOnError> => (options.client ?? client).get<GetUserBillingPurchaseOptionsResponses, GetUserBillingPurchaseOptionsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_USER_BILLING_PURCHASE_OPTIONS_URL,
    ...options
});

/**
 * Create or resume a user's Dream Bucks purchase
 */
export const createUserBillingPurchase = <ThrowOnError extends boolean = false>(options: Options<CreateUserBillingPurchaseData, ThrowOnError>): RequestResult<CreateUserBillingPurchaseResponses, CreateUserBillingPurchaseErrors, ThrowOnError> => (options.client ?? client).post<CreateUserBillingPurchaseResponses, CreateUserBillingPurchaseErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_USER_BILLING_PURCHASE_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a user's Dream Bucks purchase attempt
 */
export const getUserBillingPurchaseAttempt = <ThrowOnError extends boolean = false>(options: Options<GetUserBillingPurchaseAttemptData, ThrowOnError>): RequestResult<GetUserBillingPurchaseAttemptResponses, GetUserBillingPurchaseAttemptErrors, ThrowOnError> => (options.client ?? client).get<GetUserBillingPurchaseAttemptResponses, GetUserBillingPurchaseAttemptErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_USER_BILLING_PURCHASE_ATTEMPT_URL,
    ...options
});

/**
 * Set a user's invoice default payment method
 */
export const setUserDefaultPaymentMethod = <ThrowOnError extends boolean = false>(options: Options<SetUserDefaultPaymentMethodData, ThrowOnError>): RequestResult<SetUserDefaultPaymentMethodResponses, SetUserDefaultPaymentMethodErrors, ThrowOnError> => (options.client ?? client).post<SetUserDefaultPaymentMethodResponses, SetUserDefaultPaymentMethodErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: SET_USER_DEFAULT_PAYMENT_METHOD_URL,
    ...options
});

/**
 * Delete a user's payment method
 */
export const deleteUserBillingPaymentMethod = <ThrowOnError extends boolean = false>(options: Options<DeleteUserBillingPaymentMethodData, ThrowOnError>): RequestResult<DeleteUserBillingPaymentMethodResponses, DeleteUserBillingPaymentMethodErrors, ThrowOnError> => (options.client ?? client).delete<DeleteUserBillingPaymentMethodResponses, DeleteUserBillingPaymentMethodErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: DELETE_USER_BILLING_PAYMENT_METHOD_URL,
    ...options
});

/**
 * List a user's invoices
 *
 * As `listBillingInvoices`, for the signed-in user's own billing account.
 */
export const listUserBillingInvoices = <ThrowOnError extends boolean = false>(options: Options<ListUserBillingInvoicesData, ThrowOnError>): RequestResult<ListUserBillingInvoicesResponses, ListUserBillingInvoicesErrors, ThrowOnError> => (options.client ?? client).get<ListUserBillingInvoicesResponses, ListUserBillingInvoicesErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_USER_BILLING_INVOICES_URL,
    ...options
});

/**
 * Get a user's invoice
 *
 * As `getBillingInvoice`, for the signed-in user's own billing account.
 */
export const getUserBillingInvoice = <ThrowOnError extends boolean = false>(options: Options<GetUserBillingInvoiceData, ThrowOnError>): RequestResult<GetUserBillingInvoiceResponses, GetUserBillingInvoiceErrors, ThrowOnError> => (options.client ?? client).get<GetUserBillingInvoiceResponses, GetUserBillingInvoiceErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_USER_BILLING_INVOICE_URL,
    ...options
});

/**
 * Set up a user's billing
 *
 * The user form of `POST /organizations/{org_id}/billing/actions/set-up`, for the user's own
 * (personal) billing account. The caller may set up only their own.
 *
 */
export const setUpUserBilling = <ThrowOnError extends boolean = false>(options: Options<SetUpUserBillingData, ThrowOnError>): RequestResult<SetUpUserBillingResponses, SetUpUserBillingErrors, ThrowOnError> => (options.client ?? client).post<SetUpUserBillingResponses, SetUpUserBillingErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: SET_UP_USER_BILLING_URL,
    ...options
});

/**
 * Create a user's customer portal session
 *
 * As `createCustomerPortalSession`, for the signed-in user's own billing account.
 */
export const createUserCustomerPortalSession = <ThrowOnError extends boolean = false>(options: Options<CreateUserCustomerPortalSessionData, ThrowOnError>): RequestResult<CreateUserCustomerPortalSessionResponses, CreateUserCustomerPortalSessionErrors, ThrowOnError> => (options.client ?? client).post<CreateUserCustomerPortalSessionResponses, CreateUserCustomerPortalSessionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_USER_CUSTOMER_PORTAL_SESSION_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Convenience alias for the current user's billing summary
 */
export const redirectToUserBillingSummary = <ThrowOnError extends boolean = false>(options?: Options<RedirectToUserBillingSummaryData, ThrowOnError>): RequestResult<unknown, RedirectToUserBillingSummaryErrors, ThrowOnError> => (options?.client ?? client).get<unknown, RedirectToUserBillingSummaryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REDIRECT_TO_USER_BILLING_SUMMARY_URL,
    ...options
});

/**
 * Convenience alias for the current user's payment methods
 */
export const redirectToUserBillingPaymentMethods = <ThrowOnError extends boolean = false>(options?: Options<RedirectToUserBillingPaymentMethodsData, ThrowOnError>): RequestResult<unknown, RedirectToUserBillingPaymentMethodsErrors, ThrowOnError> => (options?.client ?? client).get<unknown, RedirectToUserBillingPaymentMethodsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REDIRECT_TO_USER_BILLING_PAYMENT_METHODS_URL,
    ...options
});

/**
 * Convenience alias for the current user's invoices
 *
 * Forwards `page_size` and `cursor` to the canonical list.
 */
export const redirectToUserBillingInvoices = <ThrowOnError extends boolean = false>(options?: Options<RedirectToUserBillingInvoicesData, ThrowOnError>): RequestResult<unknown, RedirectToUserBillingInvoicesErrors, ThrowOnError> => (options?.client ?? client).get<unknown, RedirectToUserBillingInvoicesErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REDIRECT_TO_USER_BILLING_INVOICES_URL,
    ...options
});

/**
 * Convenience alias for one of the current user's invoices
 */
export const redirectToUserBillingInvoice = <ThrowOnError extends boolean = false>(options: Options<RedirectToUserBillingInvoiceData, ThrowOnError>): RequestResult<unknown, RedirectToUserBillingInvoiceErrors, ThrowOnError> => (options.client ?? client).get<unknown, RedirectToUserBillingInvoiceErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REDIRECT_TO_USER_BILLING_INVOICE_URL,
    ...options
});

/**
 * Create a new blob
 *
 * Creates a new blob record in a pending state.
 * Once created, use the returned ID to get an upload URL to upload the actual content.
 *
 */
export const createBlob = <ThrowOnError extends boolean = false>(options: Options<CreateBlobData, ThrowOnError>): RequestResult<CreateBlobResponses, CreateBlobErrors, ThrowOnError> => (options.client ?? client).post<CreateBlobResponses, CreateBlobErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_BLOB_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a blob download URL
 *
 * Returns a fresh pre-signed URL for downloading an existing blob.
 */
export const getBlobDownloadUrl = <ThrowOnError extends boolean = false>(options: Options<GetBlobDownloadUrlData, ThrowOnError>): RequestResult<GetBlobDownloadUrlResponses, GetBlobDownloadUrlErrors, ThrowOnError> => (options.client ?? client).get<GetBlobDownloadUrlResponses, GetBlobDownloadUrlErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_BLOB_DOWNLOAD_URL_URL,
    ...options
});

/**
 * Copy a blob
 *
 * Creates an independent blob with the source content in the requested access scope.
 */
export const copyBlob = <ThrowOnError extends boolean = false>(options: Options<CopyBlobData, ThrowOnError>): RequestResult<CopyBlobResponses, CopyBlobErrors, ThrowOnError> => (options.client ?? client).post<CopyBlobResponses, CopyBlobErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: COPY_BLOB_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get public blob content
 *
 * Returns a no-store redirect to a fresh signed URL for uploaded blobs with a public read grant.
 */
export const getBlobContent = <ThrowOnError extends boolean = false>(options: Options<GetBlobContentData, ThrowOnError>): RequestResult<unknown, GetBlobContentErrors, ThrowOnError> => (options.client ?? client).get<unknown, GetBlobContentErrors, ThrowOnError>({ url: GET_BLOB_CONTENT_URL, ...options });

/**
 * Get a blob reupload URL
 *
 * Returns a fresh upload URL for an existing blob that allows reupload.
 */
export const createBlobUploadUrl = <ThrowOnError extends boolean = false>(options: Options<CreateBlobUploadUrlData, ThrowOnError>): RequestResult<CreateBlobUploadUrlResponses, CreateBlobUploadUrlErrors, ThrowOnError> => (options.client ?? client).post<CreateBlobUploadUrlResponses, CreateBlobUploadUrlErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_BLOB_UPLOAD_URL_URL,
    ...options
});

/**
 * Delete a blob
 *
 * Deletes an existing blob after authorizing against the blob's stored access scope.
 */
export const deleteBlob = <ThrowOnError extends boolean = false>(options: Options<DeleteBlobData, ThrowOnError>): RequestResult<DeleteBlobResponses, DeleteBlobErrors, ThrowOnError> => (options.client ?? client).delete<DeleteBlobResponses, DeleteBlobErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: DELETE_BLOB_URL,
    ...options
});

/**
 * Retrieve a file from local git blob storage
 */
export const getBlobLocalGitFile = <ThrowOnError extends boolean = false>(options: Options<GetBlobLocalGitFileData, ThrowOnError>): RequestResult<GetBlobLocalGitFileResponses, GetBlobLocalGitFileErrors, ThrowOnError> => (options.client ?? client).get<GetBlobLocalGitFileResponses, GetBlobLocalGitFileErrors, ThrowOnError>({ url: GET_BLOB_LOCAL_GIT_FILE_URL, ...options });

/**
 * Upload a file to local git blob storage
 */
export const uploadBlobLocalGitFile = <ThrowOnError extends boolean = false>(options: Options<UploadBlobLocalGitFileData, ThrowOnError>): RequestResult<UploadBlobLocalGitFileResponses, UploadBlobLocalGitFileErrors, ThrowOnError> => (options.client ?? client).post<UploadBlobLocalGitFileResponses, UploadBlobLocalGitFileErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: UPLOAD_BLOB_LOCAL_GIT_FILE_URL,
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Retrieve a file from local blob storage
 */
export const getBlobLocalFile = <ThrowOnError extends boolean = false>(options: Options<GetBlobLocalFileData, ThrowOnError>): RequestResult<GetBlobLocalFileResponses, GetBlobLocalFileErrors, ThrowOnError> => (options.client ?? client).get<GetBlobLocalFileResponses, GetBlobLocalFileErrors, ThrowOnError>({ url: GET_BLOB_LOCAL_FILE_URL, ...options });

/**
 * Upload a file to local blob storage
 */
export const uploadBlobLocalFile = <ThrowOnError extends boolean = false>(options: Options<UploadBlobLocalFileData, ThrowOnError>): RequestResult<UploadBlobLocalFileResponses, UploadBlobLocalFileErrors, ThrowOnError> => (options.client ?? client).post<UploadBlobLocalFileResponses, UploadBlobLocalFileErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: UPLOAD_BLOB_LOCAL_FILE_URL,
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * List project bundle sources
 */
export const listProjectBundleSources = <ThrowOnError extends boolean = false>(options: Options<ListProjectBundleSourcesData, ThrowOnError>): RequestResult<ListProjectBundleSourcesResponses, ListProjectBundleSourcesErrors, ThrowOnError> => (options.client ?? client).get<ListProjectBundleSourcesResponses, ListProjectBundleSourcesErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_PROJECT_BUNDLE_SOURCES_URL,
    ...options
});

/**
 * Create a new bundle source in project
 */
export const createBundleSource = <ThrowOnError extends boolean = false>(options: Options<CreateBundleSourceData, ThrowOnError>): RequestResult<CreateBundleSourceResponses, CreateBundleSourceErrors, ThrowOnError> => (options.client ?? client).post<CreateBundleSourceResponses, CreateBundleSourceErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_BUNDLE_SOURCE_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete bundle source
 */
export const deleteBundleSource = <ThrowOnError extends boolean = false>(options: Options<DeleteBundleSourceData, ThrowOnError>): RequestResult<DeleteBundleSourceResponses, DeleteBundleSourceErrors, ThrowOnError> => (options.client ?? client).delete<DeleteBundleSourceResponses, DeleteBundleSourceErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: DELETE_BUNDLE_SOURCE_URL,
    ...options
});

/**
 * Get bundle source details
 */
export const getBundleSource = <ThrowOnError extends boolean = false>(options: Options<GetBundleSourceData, ThrowOnError>): RequestResult<GetBundleSourceResponses, GetBundleSourceErrors, ThrowOnError> => (options.client ?? client).get<GetBundleSourceResponses, GetBundleSourceErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_BUNDLE_SOURCE_URL,
    ...options
});

/**
 * Update bundle source
 */
export const updateBundleSource = <ThrowOnError extends boolean = false>(options: Options<UpdateBundleSourceData, ThrowOnError>): RequestResult<UpdateBundleSourceResponses, UpdateBundleSourceErrors, ThrowOnError> => (options.client ?? client).patch<UpdateBundleSourceResponses, UpdateBundleSourceErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: UPDATE_BUNDLE_SOURCE_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List bundles for a source
 */
export const listSourceBundles = <ThrowOnError extends boolean = false>(options: Options<ListSourceBundlesData, ThrowOnError>): RequestResult<ListSourceBundlesResponses, ListSourceBundlesErrors, ThrowOnError> => (options.client ?? client).get<ListSourceBundlesResponses, ListSourceBundlesErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_SOURCE_BUNDLES_URL,
    ...options
});

/**
 * Create a new bundle under the source
 *
 * Creates a bundle without content. The response includes a pre-signed upload URL for uploading the content separately.
 */
export const createBundle = <ThrowOnError extends boolean = false>(options: Options<CreateBundleData, ThrowOnError>): RequestResult<CreateBundleResponses, CreateBundleErrors, ThrowOnError> => (options.client ?? client).post<CreateBundleResponses, CreateBundleErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_BUNDLE_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete bundle
 */
export const deleteBundle = <ThrowOnError extends boolean = false>(options: Options<DeleteBundleData, ThrowOnError>): RequestResult<DeleteBundleResponses, DeleteBundleErrors, ThrowOnError> => (options.client ?? client).delete<DeleteBundleResponses, DeleteBundleErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: DELETE_BUNDLE_URL,
    ...options
});

/**
 * Get bundle metadata (no content)
 */
export const getBundle = <ThrowOnError extends boolean = false>(options: Options<GetBundleData, ThrowOnError>): RequestResult<GetBundleResponses, GetBundleErrors, ThrowOnError> => (options.client ?? client).get<GetBundleResponses, GetBundleErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'ServiceAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_BUNDLE_URL,
    ...options
});

/**
 * Update bundle metadata
 */
export const updateBundle = <ThrowOnError extends boolean = false>(options: Options<UpdateBundleData, ThrowOnError>): RequestResult<UpdateBundleResponses, UpdateBundleErrors, ThrowOnError> => (options.client ?? client).patch<UpdateBundleResponses, UpdateBundleErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: UPDATE_BUNDLE_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get bundle content (raw)
 */
export const getBundleContentRedirect = <ThrowOnError extends boolean = false>(options: Options<GetBundleContentRedirectData, ThrowOnError>): RequestResult<unknown, GetBundleContentRedirectErrors, ThrowOnError> => (options.client ?? client).get<unknown, GetBundleContentRedirectErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'ServiceAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_BUNDLE_CONTENT_REDIRECT_URL,
    ...options
});

/**
 * Generate a pre-signed upload URL for bundle content
 */
export const generateBundleContentUploadUrl = <ThrowOnError extends boolean = false>(options: Options<GenerateBundleContentUploadUrlData, ThrowOnError>): RequestResult<GenerateBundleContentUploadUrlResponses, GenerateBundleContentUploadUrlErrors, ThrowOnError> => (options.client ?? client).post<GenerateBundleContentUploadUrlResponses, GenerateBundleContentUploadUrlErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GENERATE_BUNDLE_CONTENT_UPLOAD_URL_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List deployments for a bundle
 */
export const listBundleDeployments = <ThrowOnError extends boolean = false>(options: Options<ListBundleDeploymentsData, ThrowOnError>): RequestResult<ListBundleDeploymentsResponses, ListBundleDeploymentsErrors, ThrowOnError> => (options.client ?? client).get<ListBundleDeploymentsResponses, ListBundleDeploymentsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_BUNDLE_DEPLOYMENTS_URL,
    ...options
});

/**
 * Generate textual diff between two bundles
 *
 * Generates a unified diff between two bundles as plain text, same as the output of "diff -u bundle_content_1.txt bundle_content_2.txt".
 *
 */
export const diffBundles = <ThrowOnError extends boolean = false>(options: Options<DiffBundlesData, ThrowOnError>): RequestResult<DiffBundlesResponses, DiffBundlesErrors, ThrowOnError> => (options.client ?? client).post<DiffBundlesResponses, DiffBundlesErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: DIFF_BUNDLES_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deploy bundle to an environment
 *
 * Creates a new deployment of this bundle to the specified environment. This is the only way to create new deployments.
 */
export const deployBundle = <ThrowOnError extends boolean = false>(options: Options<DeployBundleData, ThrowOnError>): RequestResult<DeployBundleResponses, DeployBundleErrors, ThrowOnError> => (options.client ?? client).post<DeployBundleResponses, DeployBundleErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: DEPLOY_BUNDLE_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List project bundle environments
 */
export const listProjectBundleEnvironments = <ThrowOnError extends boolean = false>(options: Options<ListProjectBundleEnvironmentsData, ThrowOnError>): RequestResult<ListProjectBundleEnvironmentsResponses, ListProjectBundleEnvironmentsErrors, ThrowOnError> => (options.client ?? client).get<ListProjectBundleEnvironmentsResponses, ListProjectBundleEnvironmentsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_PROJECT_BUNDLE_ENVIRONMENTS_URL,
    ...options
});

/**
 * Create a new bundle environment in project
 */
export const createBundleEnvironment = <ThrowOnError extends boolean = false>(options: Options<CreateBundleEnvironmentData, ThrowOnError>): RequestResult<CreateBundleEnvironmentResponses, CreateBundleEnvironmentErrors, ThrowOnError> => (options.client ?? client).post<CreateBundleEnvironmentResponses, CreateBundleEnvironmentErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_BUNDLE_ENVIRONMENT_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete bundle environment
 */
export const deleteBundleEnvironment = <ThrowOnError extends boolean = false>(options: Options<DeleteBundleEnvironmentData, ThrowOnError>): RequestResult<DeleteBundleEnvironmentResponses, DeleteBundleEnvironmentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteBundleEnvironmentResponses, DeleteBundleEnvironmentErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: DELETE_BUNDLE_ENVIRONMENT_URL,
    ...options
});

/**
 * Get bundle environment details
 */
export const getBundleEnvironment = <ThrowOnError extends boolean = false>(options: Options<GetBundleEnvironmentData, ThrowOnError>): RequestResult<GetBundleEnvironmentResponses, GetBundleEnvironmentErrors, ThrowOnError> => (options.client ?? client).get<GetBundleEnvironmentResponses, GetBundleEnvironmentErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_BUNDLE_ENVIRONMENT_URL,
    ...options
});

/**
 * Update bundle environment metadata
 */
export const updateBundleEnvironment = <ThrowOnError extends boolean = false>(options: Options<UpdateBundleEnvironmentData, ThrowOnError>): RequestResult<UpdateBundleEnvironmentResponses, UpdateBundleEnvironmentErrors, ThrowOnError> => (options.client ?? client).patch<UpdateBundleEnvironmentResponses, UpdateBundleEnvironmentErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: UPDATE_BUNDLE_ENVIRONMENT_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Redirect to currently deployed bundle metadata
 *
 * Gets the current deployment for this environment and redirects to the associated bundle metadata
 */
export const redirectToCurrentBundle = <ThrowOnError extends boolean = false>(options: Options<RedirectToCurrentBundleData, ThrowOnError>): RequestResult<unknown, RedirectToCurrentBundleErrors, ThrowOnError> => (options.client ?? client).get<unknown, RedirectToCurrentBundleErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'ServiceAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REDIRECT_TO_CURRENT_BUNDLE_URL,
    ...options
});

/**
 * Redirect to currently deployed bundle content
 *
 * Gets the current deployment for this environment and redirects to the associated bundle content
 */
export const redirectToCurrentBundleContent = <ThrowOnError extends boolean = false>(options: Options<RedirectToCurrentBundleContentData, ThrowOnError>): RequestResult<unknown, RedirectToCurrentBundleContentErrors, ThrowOnError> => (options.client ?? client).get<unknown, RedirectToCurrentBundleContentErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'ServiceAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REDIRECT_TO_CURRENT_BUNDLE_CONTENT_URL,
    ...options
});

/**
 * List deployments for an environment
 */
export const listBundleEnvironmentDeployments = <ThrowOnError extends boolean = false>(options: Options<ListBundleEnvironmentDeploymentsData, ThrowOnError>): RequestResult<ListBundleEnvironmentDeploymentsResponses, ListBundleEnvironmentDeploymentsErrors, ThrowOnError> => (options.client ?? client).get<ListBundleEnvironmentDeploymentsResponses, ListBundleEnvironmentDeploymentsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_BUNDLE_ENVIRONMENT_DEPLOYMENTS_URL,
    ...options
});

/**
 * Delete deployment record
 */
export const deleteBundleDeployment = <ThrowOnError extends boolean = false>(options: Options<DeleteBundleDeploymentData, ThrowOnError>): RequestResult<DeleteBundleDeploymentResponses, DeleteBundleDeploymentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteBundleDeploymentResponses, DeleteBundleDeploymentErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: DELETE_BUNDLE_DEPLOYMENT_URL,
    ...options
});

/**
 * Get deployment details
 */
export const getBundleDeployment = <ThrowOnError extends boolean = false>(options: Options<GetBundleDeploymentData, ThrowOnError>): RequestResult<GetBundleDeploymentResponses, GetBundleDeploymentErrors, ThrowOnError> => (options.client ?? client).get<GetBundleDeploymentResponses, GetBundleDeploymentErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_BUNDLE_DEPLOYMENT_URL,
    ...options
});

/**
 * Update deployment metadata
 */
export const updateBundleDeployment = <ThrowOnError extends boolean = false>(options: Options<UpdateBundleDeploymentData, ThrowOnError>): RequestResult<UpdateBundleDeploymentResponses, UpdateBundleDeploymentErrors, ThrowOnError> => (options.client ?? client).patch<UpdateBundleDeploymentResponses, UpdateBundleDeploymentErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: UPDATE_BUNDLE_DEPLOYMENT_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Convenience alias - redirects to user's chats
 *
 * Convenience endpoint that redirects to `/users/{user_id}/chats` using the authenticated user's ID.
 * Returns 307 redirect for client to follow. Use canonical URLs directly when latency is critical.
 *
 */
export const redirectToUserChats = <ThrowOnError extends boolean = false>(options?: Options<RedirectToUserChatsData, ThrowOnError>): RequestResult<unknown, RedirectToUserChatsErrors, ThrowOnError> => (options?.client ?? client).get<unknown, RedirectToUserChatsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REDIRECT_TO_USER_CHATS_URL,
    ...options
});

/**
 * List chats created by user (lightweight - IDs + metadata)
 */
export const listUserChats = <ThrowOnError extends boolean = false>(options: Options<ListUserChatsData, ThrowOnError>): RequestResult<ListUserChatsResponses, ListUserChatsErrors, ThrowOnError> => (options.client ?? client).get<ListUserChatsResponses, ListUserChatsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_USER_CHATS_URL,
    ...options
});

/**
 * Create a new chat for user
 */
export const createUserChat = <ThrowOnError extends boolean = false>(options: Options<CreateUserChatData, ThrowOnError>): RequestResult<CreateUserChatResponses, CreateUserChatErrors, ThrowOnError> => (options.client ?? client).post<CreateUserChatResponses, CreateUserChatErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_USER_CHAT_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a chat by ID
 */
export const deleteChat = <ThrowOnError extends boolean = false>(options: Options<DeleteChatData, ThrowOnError>): RequestResult<DeleteChatResponses, DeleteChatErrors, ThrowOnError> => (options.client ?? client).delete<DeleteChatResponses, DeleteChatErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: DELETE_CHAT_URL,
    ...options
});

/**
 * Get a chat by ID
 */
export const getChat = <ThrowOnError extends boolean = false>(options: Options<GetChatData, ThrowOnError>): RequestResult<GetChatResponses, GetChatErrors, ThrowOnError> => (options.client ?? client).get<GetChatResponses, GetChatErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_CHAT_URL,
    ...options
});

/**
 * Update a chat by ID
 */
export const updateChat = <ThrowOnError extends boolean = false>(options: Options<UpdateChatData, ThrowOnError>): RequestResult<UpdateChatResponses, UpdateChatErrors, ThrowOnError> => (options.client ?? client).patch<UpdateChatResponses, UpdateChatErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: UPDATE_CHAT_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all branches in a chat
 *
 * Returns all branches belonging to this chat, including the root branch and any child branches.
 *
 */
export const listChatBranches = <ThrowOnError extends boolean = false>(options: Options<ListChatBranchesData, ThrowOnError>): RequestResult<ListChatBranchesResponses, ListChatBranchesErrors, ThrowOnError> => (options.client ?? client).get<ListChatBranchesResponses, ListChatBranchesErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_CHAT_BRANCHES_URL,
    ...options
});

/**
 * Switch current branch in chat
 */
export const switchChatBranch = <ThrowOnError extends boolean = false>(options: Options<SwitchChatBranchData, ThrowOnError>): RequestResult<SwitchChatBranchResponses, SwitchChatBranchErrors, ThrowOnError> => (options.client ?? client).post<SwitchChatBranchResponses, SwitchChatBranchErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: SWITCH_CHAT_BRANCH_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Convenience alias - redirects to current branch's messages
 *
 * Convenience endpoint that redirects to `/chat-branches/{branch_id}/messages` using the chat's current branch ID.
 * Returns 307 redirect for client to follow. Use canonical branch URLs directly when latency is critical.
 *
 */
export const redirectToChatMessages = <ThrowOnError extends boolean = false>(options: Options<RedirectToChatMessagesData, ThrowOnError>): RequestResult<unknown, RedirectToChatMessagesErrors, ThrowOnError> => (options.client ?? client).get<unknown, RedirectToChatMessagesErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REDIRECT_TO_CHAT_MESSAGES_URL,
    ...options
});

/**
 * Convenience alias - redirects to current branch for message creation
 *
 * Convenience endpoint that redirects to `/chat-branches/{branch_id}/messages` using the chat's current branch ID.
 * Returns 307 redirect for client to follow. Use canonical branch URLs directly when latency is critical.
 *
 */
export const redirectToCreateChatMessage = <ThrowOnError extends boolean = false>(options: Options<RedirectToCreateChatMessageData, ThrowOnError>): RequestResult<unknown, RedirectToCreateChatMessageErrors, ThrowOnError> => (options.client ?? client).post<unknown, RedirectToCreateChatMessageErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REDIRECT_TO_CREATE_CHAT_MESSAGE_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Edit a message in a branch (destructive edit or create thread)
 */
export const updateChatBranchMessage = <ThrowOnError extends boolean = false>(options: Options<UpdateChatBranchMessageData, ThrowOnError>): RequestResult<UpdateChatBranchMessageResponses, UpdateChatBranchMessageErrors, ThrowOnError> => (options.client ?? client).patch<UpdateChatBranchMessageResponses, UpdateChatBranchMessageErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: UPDATE_CHAT_BRANCH_MESSAGE_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a chat branch by ID
 */
export const deleteChatBranch = <ThrowOnError extends boolean = false>(options: Options<DeleteChatBranchData, ThrowOnError>): RequestResult<DeleteChatBranchResponses, DeleteChatBranchErrors, ThrowOnError> => (options.client ?? client).delete<DeleteChatBranchResponses, DeleteChatBranchErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: DELETE_CHAT_BRANCH_URL,
    ...options
});

/**
 * Get a chat branch by ID
 */
export const getChatBranch = <ThrowOnError extends boolean = false>(options: Options<GetChatBranchData, ThrowOnError>): RequestResult<GetChatBranchResponses, GetChatBranchErrors, ThrowOnError> => (options.client ?? client).get<GetChatBranchResponses, GetChatBranchErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_CHAT_BRANCH_URL,
    ...options
});

/**
 * List the models a message can request instead of its persona's default
 *
 * Models a sender may pick for the next answer (`llm_override` on a new message), with the
 * reasoning effort levels each accepts. Models without reasoning support list no levels.
 *
 */
export const listLlmModelOptions = <ThrowOnError extends boolean = false>(options?: Options<ListLlmModelOptionsData, ThrowOnError>): RequestResult<ListLlmModelOptionsResponses, ListLlmModelOptionsErrors, ThrowOnError> => (options?.client ?? client).get<ListLlmModelOptionsResponses, ListLlmModelOptionsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_LLM_MODEL_OPTIONS_URL,
    ...options
});

/**
 * Get an LLM view of a chat branch
 *
 * Returns the LLM-facing view of messages for a branch to help debug model behavior.
 * In `regular_chat` mode, returns the conversation history anchored at the target message's
 * timestamp. The view ends with the target AI response and represents the branch context
 * as seen by the model up to that point. Note: transient elements such as working-set file
 * snapshots from the original request are not reconstructed.
 * In `agentic_cycle` mode, the last agentic cycle is appended in expanded form, including tool calls and tool results.
 *
 */
export const getChatBranchLlmView = <ThrowOnError extends boolean = false>(options: Options<GetChatBranchLlmViewData, ThrowOnError>): RequestResult<GetChatBranchLlmViewResponses, GetChatBranchLlmViewErrors, ThrowOnError> => (options.client ?? client).get<GetChatBranchLlmViewResponses, GetChatBranchLlmViewErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'ServiceAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_CHAT_BRANCH_LLM_VIEW_URL,
    ...options
});

/**
 * List messages in a chat branch
 *
 * Lists all messages visible in this branch, including messages from parent branches
 * up to the branch point.
 *
 * **Pagination:**
 * Messages are returned in chronological order (oldest first). Use the cursors in the
 * response to navigate:
 * - `previous_cursor`: Load older messages (scroll up)
 * - `next_cursor`: Load newer messages (scroll down)
 *
 * **Jump to Message:**
 * Use the `around` parameter with a message ID to center results around that message.
 * This is useful when opening a chat from a notification - both cursors will be returned
 * for bidirectional scrolling.
 *
 * **Initial vs Pagination Requests:**
 * - Initial request: Provide `page_size`, `around`, and/or filters.
 * **Default Behavior:** If no filters or `around` parameter are provided, returns the **latest** `page_size` messages (scrolling up from the bottom).
 * - Pagination request: Provide only `cursor` (all parameters are encoded in it).
 * **Validation:** Providing `cursor` with any other parameter returns **422 Unprocessable Entity**.
 *
 */
export const listChatBranchMessages = <ThrowOnError extends boolean = false>(options: Options<ListChatBranchMessagesData, ThrowOnError>): RequestResult<ListChatBranchMessagesResponses, ListChatBranchMessagesErrors, ThrowOnError> => (options.client ?? client).get<ListChatBranchMessagesResponses, ListChatBranchMessagesErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_CHAT_BRANCH_MESSAGES_URL,
    ...options
});

/**
 * Send a message to a chat branch
 */
export const createChatBranchMessage = <ThrowOnError extends boolean = false>(options: Options<CreateChatBranchMessageData, ThrowOnError>): RequestResult<CreateChatBranchMessageResponses, CreateChatBranchMessageErrors, ThrowOnError> => (options.client ?? client).post<CreateChatBranchMessageResponses, CreateChatBranchMessageErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_CHAT_BRANCH_MESSAGE_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record user interaction with an interactive content block
 *
 * Records a user's interaction with an interactive element (button or prompt) within a message.
 * The interaction is recorded by updating the content block with interaction metadata.
 *
 * **Conflict Handling**: If the content block already has an interaction recorded, returns 409 Conflict
 * with the existing message without creating a new event.
 *
 * **SSE Event**: Emits a `chat.message.interaction.created` event for real-time updates.
 *
 */
export const interactWithChatMessage = <ThrowOnError extends boolean = false>(options: Options<InteractWithChatMessageData, ThrowOnError>): RequestResult<InteractWithChatMessageResponses, InteractWithChatMessageErrors, ThrowOnError> => (options.client ?? client).post<InteractWithChatMessageResponses, InteractWithChatMessageErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: INTERACT_WITH_CHAT_MESSAGE_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Answer every question in a question set
 *
 * Records one complete question-set interaction atomically and emits one chat message update event.
 */
export const answerChatQuestions = <ThrowOnError extends boolean = false>(options: Options<AnswerChatQuestionsData, ThrowOnError>): RequestResult<AnswerChatQuestionsResponses, AnswerChatQuestionsErrors, ThrowOnError> => (options.client ?? client).post<AnswerChatQuestionsResponses, AnswerChatQuestionsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: ANSWER_CHAT_QUESTIONS_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List file system entries (Edit Session)
 *
 * List files and folders in the edit session.
 */
export const listEditSessionFsEntries = <ThrowOnError extends boolean = false>(options: Options<ListEditSessionFsEntriesData, ThrowOnError>): RequestResult<ListEditSessionFsEntriesResponses, ListEditSessionFsEntriesErrors, ThrowOnError> => (options.client ?? client).get<ListEditSessionFsEntriesResponses, ListEditSessionFsEntriesErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_EDIT_SESSION_FS_ENTRIES_URL,
    ...options
});

/**
 * Create file system entry
 *
 * Create a new file or folder in the edit session.
 */
export const createFsEntry = <ThrowOnError extends boolean = false>(options: Options<CreateFsEntryData, ThrowOnError>): RequestResult<CreateFsEntryResponses, CreateFsEntryErrors, ThrowOnError> => (options.client ?? client).post<CreateFsEntryResponses, CreateFsEntryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_FS_ENTRY_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete file system entry
 *
 * Delete a file or folder in the edit session.
 */
export const deleteFsEntry = <ThrowOnError extends boolean = false>(options: Options<DeleteFsEntryData, ThrowOnError>): RequestResult<DeleteFsEntryResponses, DeleteFsEntryErrors, ThrowOnError> => (options.client ?? client).delete<DeleteFsEntryResponses, DeleteFsEntryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: DELETE_FS_ENTRY_URL,
    ...options
});

/**
 * Get file system entry metadata (Edit Session)
 *
 * Get metadata for a specific file or folder in the edit session.
 */
export const getEditSessionFsEntry = <ThrowOnError extends boolean = false>(options: Options<GetEditSessionFsEntryData, ThrowOnError>): RequestResult<GetEditSessionFsEntryResponses, GetEditSessionFsEntryErrors, ThrowOnError> => (options.client ?? client).get<GetEditSessionFsEntryResponses, GetEditSessionFsEntryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_EDIT_SESSION_FS_ENTRY_URL,
    ...options
});

/**
 * Update file system entry metadata
 *
 * Update name or parent folder (move/rename) in the edit session.
 */
export const updateFsEntry = <ThrowOnError extends boolean = false>(options: Options<UpdateFsEntryData, ThrowOnError>): RequestResult<UpdateFsEntryResponses, UpdateFsEntryErrors, ThrowOnError> => (options.client ?? client).patch<UpdateFsEntryResponses, UpdateFsEntryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: UPDATE_FS_ENTRY_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read file content (Edit Session)
 *
 * Get a 307 redirect to download the file content from the edit session.
 */
export const getEditSessionFsEntryContent = <ThrowOnError extends boolean = false>(options: Options<GetEditSessionFsEntryContentData, ThrowOnError>): RequestResult<unknown, GetEditSessionFsEntryContentErrors, ThrowOnError> => (options.client ?? client).get<unknown, GetEditSessionFsEntryContentErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_EDIT_SESSION_FS_ENTRY_CONTENT_URL,
    ...options
});

/**
 * Incremental edit
 *
 * Apply incremental edits to a file using a JSON request carrying either unified diff content or JSON Patch operations.
 */
export const patchFsEntryContent = <ThrowOnError extends boolean = false>(options: Options<PatchFsEntryContentData, ThrowOnError>): RequestResult<PatchFsEntryContentResponses, PatchFsEntryContentErrors, ThrowOnError> => (options.client ?? client).patch<PatchFsEntryContentResponses, PatchFsEntryContentErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: PATCH_FS_ENTRY_CONTENT_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request upload URL
 *
 * Request a signed URL to upload content for a file.
 */
export const requestUploadUrl = <ThrowOnError extends boolean = false>(options: Options<RequestUploadUrlData, ThrowOnError>): RequestResult<RequestUploadUrlResponses, RequestUploadUrlErrors, ThrowOnError> => (options.client ?? client).post<RequestUploadUrlResponses, RequestUploadUrlErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REQUEST_UPLOAD_URL_URL,
    ...options
});

/**
 * Replace file content if unchanged
 *
 * Atomically compare the current file's raw-byte SHA-256 and replace its content. A mismatch writes nothing. Recompute the replacement from a fresh read after a conflict.
 */
export const replaceFsEntryContent = <ThrowOnError extends boolean = false>(options: Options<ReplaceFsEntryContentData, ThrowOnError>): RequestResult<ReplaceFsEntryContentResponses, ReplaceFsEntryContentErrors, ThrowOnError> => (options.client ?? client).put<ReplaceFsEntryContentResponses, ReplaceFsEntryContentErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REPLACE_FS_ENTRY_CONTENT_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get file system entry metadata by path (Edit Session)
 *
 * Get metadata for a specific file or folder in the edit session. Percent-encode the whole file path as a single URL path segment; in particular, slashes must be sent as `%2F`.
 */
export const getEditSessionFsEntryByPath = <ThrowOnError extends boolean = false>(options: Options<GetEditSessionFsEntryByPathData, ThrowOnError>): RequestResult<GetEditSessionFsEntryByPathResponses, GetEditSessionFsEntryByPathErrors, ThrowOnError> => (options.client ?? client).get<GetEditSessionFsEntryByPathResponses, GetEditSessionFsEntryByPathErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_EDIT_SESSION_FS_ENTRY_BY_PATH_URL,
    ...options
});

/**
 * Read file content by path (Edit Session)
 *
 * Get a 307 redirect to download file content from the edit session. Percent-encode the whole file path as a single URL path segment; in particular, slashes must be sent as `%2F`.
 */
export const getEditSessionFsEntryContentByPath = <ThrowOnError extends boolean = false>(options: Options<GetEditSessionFsEntryContentByPathData, ThrowOnError>): RequestResult<unknown, GetEditSessionFsEntryContentByPathErrors, ThrowOnError> => (options.client ?? client).get<unknown, GetEditSessionFsEntryContentByPathErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_EDIT_SESSION_FS_ENTRY_CONTENT_BY_PATH_URL,
    ...options
});

/**
 * Copy file
 *
 * Copy a file/folder (creates new UUID).
 */
export const copyFsEntry = <ThrowOnError extends boolean = false>(options: Options<CopyFsEntryData, ThrowOnError>): RequestResult<CopyFsEntryResponses, CopyFsEntryErrors, ThrowOnError> => (options.client ?? client).post<CopyFsEntryResponses, CopyFsEntryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: COPY_FS_ENTRY_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reimport file
 *
 * Force reimport processing for a file. Runs asynchronously; returns immediately.
 *
 * **Receiving results:**
 * - **SSE**: Listen for a `problems:update` event filtered by
 * `source_ids=edit_session:{es_id}`. When it fires, re-fetch the problems endpoint.
 * - **Polling**: Re-fetch `GET /edit-sessions/{es_id}/problems`. Reimport is complete when
 * `pending_checks` contains no entry with `kind: import`.
 *
 */
export const reimportFsEntry = <ThrowOnError extends boolean = false>(options: Options<ReimportFsEntryData, ThrowOnError>): RequestResult<ReimportFsEntryResponses, ReimportFsEntryErrors, ThrowOnError> => (options.client ?? client).post<ReimportFsEntryResponses, ReimportFsEntryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REIMPORT_FS_ENTRY_URL,
    ...options
});

/**
 * Validate file (Edit Session)
 *
 * Synchronously validates a single structured file in the edit session branch and
 * returns its current problems. Only works on files; folders return 422.
 *
 */
export const validateEditSessionFsEntry = <ThrowOnError extends boolean = false>(options: Options<ValidateEditSessionFsEntryData, ThrowOnError>): RequestResult<ValidateEditSessionFsEntryResponses, ValidateEditSessionFsEntryErrors, ThrowOnError> => (options.client ?? client).post<ValidateEditSessionFsEntryResponses, ValidateEditSessionFsEntryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: VALIDATE_EDIT_SESSION_FS_ENTRY_URL,
    ...options
});

/**
 * Create file from structured data
 *
 * Extract structured data to create a new file (Drag & Drop Data -> File).
 */
export const createFsEntryFromData = <ThrowOnError extends boolean = false>(options: Options<CreateFsEntryFromDataData, ThrowOnError>): RequestResult<CreateFsEntryFromDataResponses, CreateFsEntryFromDataErrors, ThrowOnError> => (options.client ?? client).post<CreateFsEntryFromDataResponses, CreateFsEntryFromDataErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_FS_ENTRY_FROM_DATA_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List edit-session problems
 *
 * Get validation errors, broken references and import issues scoped to an EditSession (working branch).
 */
export const listEditSessionProblems = <ThrowOnError extends boolean = false>(options: Options<ListEditSessionProblemsData, ThrowOnError>): RequestResult<ListEditSessionProblemsResponses, ListEditSessionProblemsErrors, ThrowOnError> => (options.client ?? client).get<ListEditSessionProblemsResponses, ListEditSessionProblemsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_EDIT_SESSION_PROBLEMS_URL,
    ...options
});

/**
 * Reimport files (Edit Session)
 *
 * Force reimport processing for files within an edit session branch. Runs asynchronously;
 * returns immediately.
 *
 * **Receiving results:**
 * - **SSE**: Listen for a `problems:update` event filtered by
 * `source_ids=edit_session:{es_id}`. When it fires, re-fetch the problems endpoint.
 * - **Polling**: Re-fetch `GET /edit-sessions/{es_id}/problems`. Reimport is complete when
 * `pending_checks` contains no entry with `kind: import`.
 *
 */
export const reimportEditSessionContentPath = <ThrowOnError extends boolean = false>(options: Options<ReimportEditSessionContentPathData, ThrowOnError>): RequestResult<ReimportEditSessionContentPathResponses, ReimportEditSessionContentPathErrors, ThrowOnError> => (options.client ?? client).post<ReimportEditSessionContentPathResponses, ReimportEditSessionContentPathErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REIMPORT_EDIT_SESSION_CONTENT_PATH_URL,
    ...options
});

/**
 * Trigger validation (Edit Session)
 *
 * Asynchronously validates all structured files in the edit session branch.
 * Returns immediately; validation runs in the background.
 *
 * **Receiving results:**
 * - **SSE**: Listen for a `problems:update` event filtered by
 * `source_ids=edit_session:{es_id}`. When it fires, re-fetch the problems endpoint.
 * - **Polling**: Re-fetch `GET /edit-sessions/{es_id}/problems` at a reasonable
 * interval (suggested: 2–5 s). Validation is complete when the response's
 * `pending_checks` contains no entry with `kind: validation`.
 *
 */
export const triggerEditSessionValidation = <ThrowOnError extends boolean = false>(options: Options<TriggerEditSessionValidationData, ThrowOnError>): RequestResult<TriggerEditSessionValidationResponses, TriggerEditSessionValidationErrors, ThrowOnError> => (options.client ?? client).post<TriggerEditSessionValidationResponses, TriggerEditSessionValidationErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: TRIGGER_EDIT_SESSION_VALIDATION_URL,
    ...options
});

/**
 * Refresh EditSession TreeView
 *
 * Force regeneration of the edit session's content tree. Optional `path` query parameter may limit to a subtree.
 */
export const refreshEditSessionContentTree = <ThrowOnError extends boolean = false>(options: Options<RefreshEditSessionContentTreeData, ThrowOnError>): RequestResult<RefreshEditSessionContentTreeResponses, RefreshEditSessionContentTreeErrors, ThrowOnError> => (options.client ?? client).post<RefreshEditSessionContentTreeResponses, RefreshEditSessionContentTreeErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REFRESH_EDIT_SESSION_CONTENT_TREE_URL,
    ...options
});

/**
 * Get content tree (Edit Session, flat response)
 *
 * Returns a flat array of tree nodes for the edit session state. Clients rebuild the hierarchical
 * tree using parent_id relationships.
 *
 */
export const getEditSessionContentTree = <ThrowOnError extends boolean = false>(options: Options<GetEditSessionContentTreeData, ThrowOnError>): RequestResult<GetEditSessionContentTreeResponses, GetEditSessionContentTreeErrors, ThrowOnError> => (options.client ?? client).get<GetEditSessionContentTreeResponses, GetEditSessionContentTreeErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_EDIT_SESSION_CONTENT_TREE_URL,
    ...options
});

/**
 * Get context suggestions for edit session
 *
 * Get AI-powered suggestions for editable scope and readonly context based on intended changes
 */
export const listContextSuggestions = <ThrowOnError extends boolean = false>(options: Options<ListContextSuggestionsData, ThrowOnError>): RequestResult<ListContextSuggestionsResponses, ListContextSuggestionsErrors, ThrowOnError> => (options.client ?? client).post<ListContextSuggestionsResponses, ListContextSuggestionsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_CONTEXT_SUGGESTIONS_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List edit sessions for project
 *
 * Get all edit sessions for a project with optional filtering
 */
export const listEditSessions = <ThrowOnError extends boolean = false>(options: Options<ListEditSessionsData, ThrowOnError>): RequestResult<ListEditSessionsResponses, ListEditSessionsErrors, ThrowOnError> => (options.client ?? client).get<ListEditSessionsResponses, ListEditSessionsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_EDIT_SESSIONS_URL,
    ...options
});

/**
 * Create edit session
 *
 * Create a new edit session with defined editable scope and readonly context
 */
export const createEditSession = <ThrowOnError extends boolean = false>(options: Options<CreateEditSessionData, ThrowOnError>): RequestResult<CreateEditSessionResponses, CreateEditSessionErrors, ThrowOnError> => (options.client ?? client).post<CreateEditSessionResponses, CreateEditSessionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_EDIT_SESSION_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete edit session
 *
 * Delete/close an edit session (abandons any unmerged changes)
 */
export const deleteEditSession = <ThrowOnError extends boolean = false>(options: Options<DeleteEditSessionData, ThrowOnError>): RequestResult<DeleteEditSessionResponses, DeleteEditSessionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteEditSessionResponses, DeleteEditSessionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: DELETE_EDIT_SESSION_URL,
    ...options
});

/**
 * Get edit session details
 *
 * Get detailed information about a specific edit session
 */
export const getEditSession = <ThrowOnError extends boolean = false>(options: Options<GetEditSessionData, ThrowOnError>): RequestResult<GetEditSessionResponses, GetEditSessionErrors, ThrowOnError> => (options.client ?? client).get<GetEditSessionResponses, GetEditSessionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_EDIT_SESSION_URL,
    ...options
});

/**
 * Update edit session
 *
 * Update edit session metadata (name, description, etc.)
 */
export const updateEditSession = <ThrowOnError extends boolean = false>(options: Options<UpdateEditSessionData, ThrowOnError>): RequestResult<UpdateEditSessionResponses, UpdateEditSessionErrors, ThrowOnError> => (options.client ?? client).patch<UpdateEditSessionResponses, UpdateEditSessionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: UPDATE_EDIT_SESSION_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Archive edit session
 *
 * Archive the edit session. It can be unarchived by any modification.
 */
export const archiveEditSession = <ThrowOnError extends boolean = false>(options: Options<ArchiveEditSessionData, ThrowOnError>): RequestResult<ArchiveEditSessionResponses, ArchiveEditSessionErrors, ThrowOnError> => (options.client ?? client).post<ArchiveEditSessionResponses, ArchiveEditSessionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: ARCHIVE_EDIT_SESSION_URL,
    ...options
});

/**
 * Undo last change
 *
 * Undo the last change in the edit session
 */
export const undoEditSession = <ThrowOnError extends boolean = false>(options: Options<UndoEditSessionData, ThrowOnError>): RequestResult<UndoEditSessionResponses, UndoEditSessionErrors, ThrowOnError> => (options.client ?? client).post<UndoEditSessionResponses, UndoEditSessionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: UNDO_EDIT_SESSION_URL,
    ...options
});

/**
 * Redo undone change
 *
 * Redo a previously undone change in the edit session
 */
export const redoEditSession = <ThrowOnError extends boolean = false>(options: Options<RedoEditSessionData, ThrowOnError>): RequestResult<RedoEditSessionResponses, RedoEditSessionErrors, ThrowOnError> => (options.client ?? client).post<RedoEditSessionResponses, RedoEditSessionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REDO_EDIT_SESSION_URL,
    ...options
});

/**
 * Restore edit session content
 *
 * Hard-resets the edit session branch to the given history item without creating a new commit. If no body is provided, restores the state before the latest visible history item.
 */
export const revertEditSession = <ThrowOnError extends boolean = false>(options: Options<RevertEditSessionData, ThrowOnError>): RequestResult<RevertEditSessionResponses, RevertEditSessionErrors, ThrowOnError> => (options.client ?? client).post<RevertEditSessionResponses, RevertEditSessionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REVERT_EDIT_SESSION_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * View change history
 *
 * Get the change history for an edit session.
 *
 * History items are returned in reverse chronological order (newest first).
 * The `pagination.next_cursor` can be used to load older history items, if present.
 * This endpoint does not support `pagination.previous_cursor`.
 *
 */
export const listEditSessionHistory = <ThrowOnError extends boolean = false>(options: Options<ListEditSessionHistoryData, ThrowOnError>): RequestResult<ListEditSessionHistoryResponses, ListEditSessionHistoryErrors, ThrowOnError> => (options.client ?? client).get<ListEditSessionHistoryResponses, ListEditSessionHistoryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_EDIT_SESSION_HISTORY_URL,
    ...options
});

/**
 * Get a single history item
 *
 * Get a specific history item by ID for an edit session
 */
export const getEditSessionHistoryItem = <ThrowOnError extends boolean = false>(options: Options<GetEditSessionHistoryItemData, ThrowOnError>): RequestResult<GetEditSessionHistoryItemResponses, GetEditSessionHistoryItemErrors, ThrowOnError> => (options.client ?? client).get<GetEditSessionHistoryItemResponses, GetEditSessionHistoryItemErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_EDIT_SESSION_HISTORY_ITEM_URL,
    ...options
});

/**
 * Get unified diff for a history item
 *
 * Returns a unified patch (diff) showing the changes introduced by a specific history item compared to its first parent. For merge history items, this shows the diff against parent #1 (the target branch tip). When compare_to is provided, returns the direct selected-item-to-target comparison instead.
 */
export const getEditSessionHistoryItemDiff = <ThrowOnError extends boolean = false>(options: Options<GetEditSessionHistoryItemDiffData, ThrowOnError>): RequestResult<GetEditSessionHistoryItemDiffResponses, GetEditSessionHistoryItemDiffErrors, ThrowOnError> => (options.client ?? client).get<GetEditSessionHistoryItemDiffResponses, GetEditSessionHistoryItemDiffErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_EDIT_SESSION_HISTORY_ITEM_DIFF_URL,
    ...options
});

/**
 * Get a human-readable summary for a history comparison
 *
 * Returns semantic per-file summaries for the same selected history range used by the history diff endpoint. Without compare_to, the selected item is compared to its first parent or the empty tree. With compare_to, the selected item is compared directly to the target.
 */
export const getEditSessionHistoryItemSummary = <ThrowOnError extends boolean = false>(options: Options<GetEditSessionHistoryItemSummaryData, ThrowOnError>): RequestResult<GetEditSessionHistoryItemSummaryResponses, GetEditSessionHistoryItemSummaryErrors, ThrowOnError> => (options.client ?? client).get<GetEditSessionHistoryItemSummaryResponses, GetEditSessionHistoryItemSummaryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_EDIT_SESSION_HISTORY_ITEM_SUMMARY_URL,
    ...options
});

/**
 * Merge conflict check
 *
 * Check for potential merge conflicts without performing the merge.
 */
export const canMergeEditSession = <ThrowOnError extends boolean = false>(options: Options<CanMergeEditSessionData, ThrowOnError>): RequestResult<CanMergeEditSessionResponses, CanMergeEditSessionErrors, ThrowOnError> => (options.client ?? client).get<CanMergeEditSessionResponses, CanMergeEditSessionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CAN_MERGE_EDIT_SESSION_URL,
    ...options
});

/**
 * Merge edit session changes
 *
 * Merge the edit session's changes back to the main project with conflict resolution
 */
export const mergeEditSession = <ThrowOnError extends boolean = false>(options: Options<MergeEditSessionData, ThrowOnError>): RequestResult<MergeEditSessionResponses, MergeEditSessionErrors, ThrowOnError> => (options.client ?? client).post<MergeEditSessionResponses, MergeEditSessionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: MERGE_EDIT_SESSION_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sync conflict check
 *
 * Check for potential sync conflicts without performing the sync (dry-run).
 */
export const canSyncEditSession = <ThrowOnError extends boolean = false>(options: Options<CanSyncEditSessionData, ThrowOnError>): RequestResult<CanSyncEditSessionResponses, CanSyncEditSessionErrors, ThrowOnError> => (options.client ?? client).get<CanSyncEditSessionResponses, CanSyncEditSessionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CAN_SYNC_EDIT_SESSION_URL,
    ...options
});

/**
 * Synchronize edit session with main
 *
 * Synchronize edit session with latest main project state (Pull operation) with optional conflict resolution
 */
export const syncEditSession = <ThrowOnError extends boolean = false>(options: Options<SyncEditSessionData, ThrowOnError>): RequestResult<SyncEditSessionResponses, SyncEditSessionErrors, ThrowOnError> => (options.client ?? client).post<SyncEditSessionResponses, SyncEditSessionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: SYNC_EDIT_SESSION_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get diff view of edit session content against main
 *
 * Returns the existing unified patch plus unfiltered per-file change summaries.
 */
export const getEditSessionDiff = <ThrowOnError extends boolean = false>(options: Options<GetEditSessionDiffData, ThrowOnError>): RequestResult<GetEditSessionDiffResponses, GetEditSessionDiffErrors, ThrowOnError> => (options.client ?? client).get<GetEditSessionDiffResponses, GetEditSessionDiffErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_EDIT_SESSION_DIFF_URL,
    ...options
});

/**
 * List threads for edit session
 *
 * Get all threads associated with an edit session
 */
export const listEditSessionThreads = <ThrowOnError extends boolean = false>(options: Options<ListEditSessionThreadsData, ThrowOnError>): RequestResult<ListEditSessionThreadsResponses, ListEditSessionThreadsErrors, ThrowOnError> => (options.client ?? client).get<ListEditSessionThreadsResponses, ListEditSessionThreadsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_EDIT_SESSION_THREADS_URL,
    ...options
});

/**
 * Create thread in edit session
 *
 * Create a new thread within an edit session (auto-creates associated chat)
 */
export const createEditSessionThread = <ThrowOnError extends boolean = false>(options: Options<CreateEditSessionThreadData, ThrowOnError>): RequestResult<CreateEditSessionThreadResponses, CreateEditSessionThreadErrors, ThrowOnError> => (options.client ?? client).post<CreateEditSessionThreadResponses, CreateEditSessionThreadErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_EDIT_SESSION_THREAD_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List chats for edit session
 *
 * Get all chats associated with an edit session
 */
export const listEditSessionChats = <ThrowOnError extends boolean = false>(options: Options<ListEditSessionChatsData, ThrowOnError>): RequestResult<ListEditSessionChatsResponses, ListEditSessionChatsErrors, ThrowOnError> => (options.client ?? client).get<ListEditSessionChatsResponses, ListEditSessionChatsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_EDIT_SESSION_CHATS_URL,
    ...options
});

/**
 * Create chat for edit session
 *
 * Create a new chat associated with an edit session
 */
export const createEditSessionChat = <ThrowOnError extends boolean = false>(options: Options<CreateEditSessionChatData, ThrowOnError>): RequestResult<CreateEditSessionChatResponses, CreateEditSessionChatErrors, ThrowOnError> => (options.client ?? client).post<CreateEditSessionChatResponses, CreateEditSessionChatErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_EDIT_SESSION_CHAT_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List file system entries (Thread)
 *
 * List files and folders in the thread.
 */
export const listThreadFsEntries = <ThrowOnError extends boolean = false>(options: Options<ListThreadFsEntriesData, ThrowOnError>): RequestResult<ListThreadFsEntriesResponses, ListThreadFsEntriesErrors, ThrowOnError> => (options.client ?? client).get<ListThreadFsEntriesResponses, ListThreadFsEntriesErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_THREAD_FS_ENTRIES_URL,
    ...options
});

/**
 * Create file system entry
 *
 * Create a new file or folder in the thread.
 */
export const createThreadFsEntry = <ThrowOnError extends boolean = false>(options: Options<CreateThreadFsEntryData, ThrowOnError>): RequestResult<CreateThreadFsEntryResponses, CreateThreadFsEntryErrors, ThrowOnError> => (options.client ?? client).post<CreateThreadFsEntryResponses, CreateThreadFsEntryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_THREAD_FS_ENTRY_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete file system entry
 *
 * Delete a file or folder in the thread.
 */
export const deleteThreadFsEntry = <ThrowOnError extends boolean = false>(options: Options<DeleteThreadFsEntryData, ThrowOnError>): RequestResult<DeleteThreadFsEntryResponses, DeleteThreadFsEntryErrors, ThrowOnError> => (options.client ?? client).delete<DeleteThreadFsEntryResponses, DeleteThreadFsEntryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: DELETE_THREAD_FS_ENTRY_URL,
    ...options
});

/**
 * Get file system entry metadata (Thread)
 *
 * Get metadata for a specific file or folder in the thread.
 */
export const getThreadFsEntry = <ThrowOnError extends boolean = false>(options: Options<GetThreadFsEntryData, ThrowOnError>): RequestResult<GetThreadFsEntryResponses, GetThreadFsEntryErrors, ThrowOnError> => (options.client ?? client).get<GetThreadFsEntryResponses, GetThreadFsEntryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_THREAD_FS_ENTRY_URL,
    ...options
});

/**
 * Update file system entry metadata
 *
 * Update name or parent folder (move/rename) in the thread.
 */
export const updateThreadFsEntry = <ThrowOnError extends boolean = false>(options: Options<UpdateThreadFsEntryData, ThrowOnError>): RequestResult<UpdateThreadFsEntryResponses, UpdateThreadFsEntryErrors, ThrowOnError> => (options.client ?? client).patch<UpdateThreadFsEntryResponses, UpdateThreadFsEntryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: UPDATE_THREAD_FS_ENTRY_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read file content (Thread)
 *
 * Get a 307 redirect to download the file content from the thread.
 */
export const getThreadFsEntryContent = <ThrowOnError extends boolean = false>(options: Options<GetThreadFsEntryContentData, ThrowOnError>): RequestResult<unknown, GetThreadFsEntryContentErrors, ThrowOnError> => (options.client ?? client).get<unknown, GetThreadFsEntryContentErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_THREAD_FS_ENTRY_CONTENT_URL,
    ...options
});

/**
 * Incremental edit
 *
 * Apply incremental edits to a file using a JSON request carrying either unified diff content or JSON Patch operations.
 */
export const patchThreadFsEntryContent = <ThrowOnError extends boolean = false>(options: Options<PatchThreadFsEntryContentData, ThrowOnError>): RequestResult<PatchThreadFsEntryContentResponses, PatchThreadFsEntryContentErrors, ThrowOnError> => (options.client ?? client).patch<PatchThreadFsEntryContentResponses, PatchThreadFsEntryContentErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: PATCH_THREAD_FS_ENTRY_CONTENT_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request upload URL
 *
 * Request a signed URL to upload content for a file.
 */
export const requestThreadUploadUrl = <ThrowOnError extends boolean = false>(options: Options<RequestThreadUploadUrlData, ThrowOnError>): RequestResult<RequestThreadUploadUrlResponses, RequestThreadUploadUrlErrors, ThrowOnError> => (options.client ?? client).post<RequestThreadUploadUrlResponses, RequestThreadUploadUrlErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REQUEST_THREAD_UPLOAD_URL_URL,
    ...options
});

/**
 * Replace file content if unchanged
 *
 * Atomically compare the current file's raw-byte SHA-256 and replace its content. A mismatch writes nothing. Recompute the replacement from a fresh read after a conflict.
 */
export const replaceThreadFsEntryContent = <ThrowOnError extends boolean = false>(options: Options<ReplaceThreadFsEntryContentData, ThrowOnError>): RequestResult<ReplaceThreadFsEntryContentResponses, ReplaceThreadFsEntryContentErrors, ThrowOnError> => (options.client ?? client).put<ReplaceThreadFsEntryContentResponses, ReplaceThreadFsEntryContentErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REPLACE_THREAD_FS_ENTRY_CONTENT_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get file system entry metadata by path (Thread)
 *
 * Get metadata for a specific file or folder in the thread. Percent-encode the whole file path as a single URL path segment; in particular, slashes must be sent as `%2F`.
 */
export const getThreadFsEntryByPath = <ThrowOnError extends boolean = false>(options: Options<GetThreadFsEntryByPathData, ThrowOnError>): RequestResult<GetThreadFsEntryByPathResponses, GetThreadFsEntryByPathErrors, ThrowOnError> => (options.client ?? client).get<GetThreadFsEntryByPathResponses, GetThreadFsEntryByPathErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_THREAD_FS_ENTRY_BY_PATH_URL,
    ...options
});

/**
 * Read file content by path (Thread)
 *
 * Get a 307 redirect to download file content from the thread. Percent-encode the whole file path as a single URL path segment; in particular, slashes must be sent as `%2F`.
 */
export const getThreadFsEntryContentByPath = <ThrowOnError extends boolean = false>(options: Options<GetThreadFsEntryContentByPathData, ThrowOnError>): RequestResult<unknown, GetThreadFsEntryContentByPathErrors, ThrowOnError> => (options.client ?? client).get<unknown, GetThreadFsEntryContentByPathErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_THREAD_FS_ENTRY_CONTENT_BY_PATH_URL,
    ...options
});

/**
 * Copy file
 *
 * Copy a file/folder (creates new UUID).
 */
export const copyThreadFsEntry = <ThrowOnError extends boolean = false>(options: Options<CopyThreadFsEntryData, ThrowOnError>): RequestResult<CopyThreadFsEntryResponses, CopyThreadFsEntryErrors, ThrowOnError> => (options.client ?? client).post<CopyThreadFsEntryResponses, CopyThreadFsEntryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: COPY_THREAD_FS_ENTRY_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reimport file
 *
 * Force reimport processing for a file. Runs asynchronously; returns immediately.
 *
 * **Receiving results:**
 * - **SSE**: Listen for a `problems:update` event filtered by
 * `source_ids=edit_session.thread:{thread_id}`. When it fires, re-fetch the problems endpoint.
 * - **Polling**: Re-fetch `GET /edit-session-threads/{thread_id}/problems`. Reimport is complete
 * when `pending_checks` contains no entry with `kind: import`.
 *
 */
export const reimportThreadFsEntry = <ThrowOnError extends boolean = false>(options: Options<ReimportThreadFsEntryData, ThrowOnError>): RequestResult<ReimportThreadFsEntryResponses, ReimportThreadFsEntryErrors, ThrowOnError> => (options.client ?? client).post<ReimportThreadFsEntryResponses, ReimportThreadFsEntryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REIMPORT_THREAD_FS_ENTRY_URL,
    ...options
});

/**
 * Validate file (Thread)
 *
 * Synchronously validates a single structured file in the thread branch and
 * returns its current problems. Only works on files; folders return 422.
 *
 */
export const validateThreadFsEntry = <ThrowOnError extends boolean = false>(options: Options<ValidateThreadFsEntryData, ThrowOnError>): RequestResult<ValidateThreadFsEntryResponses, ValidateThreadFsEntryErrors, ThrowOnError> => (options.client ?? client).post<ValidateThreadFsEntryResponses, ValidateThreadFsEntryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: VALIDATE_THREAD_FS_ENTRY_URL,
    ...options
});

/**
 * Create file from structured data
 *
 * Extract structured data to create a new file (Drag & Drop Data -> File).
 */
export const createThreadFsEntryFromData = <ThrowOnError extends boolean = false>(options: Options<CreateThreadFsEntryFromDataData, ThrowOnError>): RequestResult<CreateThreadFsEntryFromDataResponses, CreateThreadFsEntryFromDataErrors, ThrowOnError> => (options.client ?? client).post<CreateThreadFsEntryFromDataResponses, CreateThreadFsEntryFromDataErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_THREAD_FS_ENTRY_FROM_DATA_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List thread problems
 *
 * Get validation errors, broken references and import issues scoped to a Thread.
 */
export const listThreadProblems = <ThrowOnError extends boolean = false>(options: Options<ListThreadProblemsData, ThrowOnError>): RequestResult<ListThreadProblemsResponses, ListThreadProblemsErrors, ThrowOnError> => (options.client ?? client).get<ListThreadProblemsResponses, ListThreadProblemsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_THREAD_PROBLEMS_URL,
    ...options
});

/**
 * Reimport files (Thread)
 *
 * Force reimport processing for files within a thread branch. Runs asynchronously;
 * returns immediately.
 *
 * **Receiving results:**
 * - **SSE**: Listen for a `problems:update` event filtered by
 * `source_ids=edit_session.thread:{thread_id}`. When it fires, re-fetch the problems endpoint.
 * - **Polling**: Re-fetch `GET /edit-session-threads/{thread_id}/problems`. Reimport is complete
 * when `pending_checks` contains no entry with `kind: import`.
 *
 */
export const reimportThreadContentPath = <ThrowOnError extends boolean = false>(options: Options<ReimportThreadContentPathData, ThrowOnError>): RequestResult<ReimportThreadContentPathResponses, ReimportThreadContentPathErrors, ThrowOnError> => (options.client ?? client).post<ReimportThreadContentPathResponses, ReimportThreadContentPathErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REIMPORT_THREAD_CONTENT_PATH_URL,
    ...options
});

/**
 * Trigger validation (Thread)
 *
 * Asynchronously validates all structured files in the thread branch.
 * Returns immediately; validation runs in the background.
 *
 * **Receiving results:**
 * - **SSE**: Listen for a `problems:update` event filtered by
 * `source_ids=edit_session.thread:{thread_id}`. When it fires, re-fetch the problems endpoint.
 * - **Polling**: Re-fetch `GET /edit-session-threads/{thread_id}/problems` at a reasonable
 * interval (suggested: 2–5 s). Validation is complete when the response's
 * `pending_checks` contains no entry with `kind: validation`.
 *
 */
export const triggerThreadValidation = <ThrowOnError extends boolean = false>(options: Options<TriggerThreadValidationData, ThrowOnError>): RequestResult<TriggerThreadValidationResponses, TriggerThreadValidationErrors, ThrowOnError> => (options.client ?? client).post<TriggerThreadValidationResponses, TriggerThreadValidationErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: TRIGGER_THREAD_VALIDATION_URL,
    ...options
});

/**
 * Refresh Thread TreeView
 *
 * Force regeneration of the thread's content tree. Optional `path` query parameter may limit to a subtree.
 */
export const refreshThreadContentTree = <ThrowOnError extends boolean = false>(options: Options<RefreshThreadContentTreeData, ThrowOnError>): RequestResult<RefreshThreadContentTreeResponses, RefreshThreadContentTreeErrors, ThrowOnError> => (options.client ?? client).post<RefreshThreadContentTreeResponses, RefreshThreadContentTreeErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REFRESH_THREAD_CONTENT_TREE_URL,
    ...options
});

/**
 * Get content tree (Thread, flat response)
 *
 * Returns a flat array of tree nodes for the thread state. Clients rebuild the hierarchical
 * tree using parent_id relationships.
 *
 */
export const getThreadContentTree = <ThrowOnError extends boolean = false>(options: Options<GetThreadContentTreeData, ThrowOnError>): RequestResult<GetThreadContentTreeResponses, GetThreadContentTreeErrors, ThrowOnError> => (options.client ?? client).get<GetThreadContentTreeResponses, GetThreadContentTreeErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_THREAD_CONTENT_TREE_URL,
    ...options
});

/**
 * Delete thread
 *
 * Delete/cancel a thread
 */
export const deleteThread = <ThrowOnError extends boolean = false>(options: Options<DeleteThreadData, ThrowOnError>): RequestResult<DeleteThreadResponses, DeleteThreadErrors, ThrowOnError> => (options.client ?? client).delete<DeleteThreadResponses, DeleteThreadErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: DELETE_THREAD_URL,
    ...options
});

/**
 * Get thread details
 *
 * Get detailed information about a specific thread
 */
export const getThread = <ThrowOnError extends boolean = false>(options: Options<GetThreadData, ThrowOnError>): RequestResult<GetThreadResponses, GetThreadErrors, ThrowOnError> => (options.client ?? client).get<GetThreadResponses, GetThreadErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_THREAD_URL,
    ...options
});

/**
 * Update thread
 *
 * Update thread metadata and progress items
 */
export const updateThread = <ThrowOnError extends boolean = false>(options: Options<UpdateThreadData, ThrowOnError>): RequestResult<UpdateThreadResponses, UpdateThreadErrors, ThrowOnError> => (options.client ?? client).patch<UpdateThreadResponses, UpdateThreadErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: UPDATE_THREAD_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Archive thread
 *
 * Archive the thread. Mutations on archived threads are blocked; use the unarchive endpoint to reopen.
 */
export const archiveThread = <ThrowOnError extends boolean = false>(options: Options<ArchiveThreadData, ThrowOnError>): RequestResult<ArchiveThreadResponses, ArchiveThreadErrors, ThrowOnError> => (options.client ?? client).post<ArchiveThreadResponses, ArchiveThreadErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: ARCHIVE_THREAD_URL,
    ...options
});

/**
 * Unarchive thread
 *
 * Unarchive the thread. Cannot be called if the parent edit session is archived. The thread is queued for auto-sync after unarchiving.
 *
 */
export const unarchiveThread = <ThrowOnError extends boolean = false>(options: Options<UnarchiveThreadData, ThrowOnError>): RequestResult<UnarchiveThreadResponses, UnarchiveThreadErrors, ThrowOnError> => (options.client ?? client).post<UnarchiveThreadResponses, UnarchiveThreadErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: UNARCHIVE_THREAD_URL,
    ...options
});

/**
 * Merge conflict check
 *
 * Check for potential merge conflicts without performing the merge.
 */
export const canMergeThread = <ThrowOnError extends boolean = false>(options: Options<CanMergeThreadData, ThrowOnError>): RequestResult<CanMergeThreadResponses, CanMergeThreadErrors, ThrowOnError> => (options.client ?? client).get<CanMergeThreadResponses, CanMergeThreadErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CAN_MERGE_THREAD_URL,
    ...options
});

/**
 * Merge thread changes
 *
 * Merge changes back to the parent EditSession (Thread-to-EditSession merge). Takes no request body: a clean merge (or a conflict confined to `.meta` files, resolved mechanically) returns 200; a real content conflict starts an AI-assisted resolution and returns 202. There is no manual conflict picker for this action.
 */
export const mergeThread = <ThrowOnError extends boolean = false>(options: Options<MergeThreadData, ThrowOnError>): RequestResult<MergeThreadResponses, MergeThreadErrors, ThrowOnError> => (options.client ?? client).post<MergeThreadResponses, MergeThreadErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: MERGE_THREAD_URL,
    ...options
});

/**
 * Sync conflict check
 *
 * Check for potential sync conflicts without performing the sync (dry-run).
 */
export const canSyncThread = <ThrowOnError extends boolean = false>(options: Options<CanSyncThreadData, ThrowOnError>): RequestResult<CanSyncThreadResponses, CanSyncThreadErrors, ThrowOnError> => (options.client ?? client).get<CanSyncThreadResponses, CanSyncThreadErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CAN_SYNC_THREAD_URL,
    ...options
});

/**
 * Synchronize thread with EditSession
 *
 * Synchronize thread with latest EditSession state (Pull operation). Takes no request body: a clean sync (or a conflict confined to `.meta` files, resolved mechanically) returns 200; a real content conflict starts an AI-assisted resolution and returns 202. There is no manual conflict picker for this action.
 */
export const syncThread = <ThrowOnError extends boolean = false>(options: Options<SyncThreadData, ThrowOnError>): RequestResult<SyncThreadResponses, SyncThreadErrors, ThrowOnError> => (options.client ?? client).post<SyncThreadResponses, SyncThreadErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: SYNC_THREAD_URL,
    ...options
});

/**
 * Cancel an AI-assisted merge resolution
 *
 * Cancel the in-flight merge resolution and remove its scratch and chat branches.
 */
export const cancelMergeResolutionThread = <ThrowOnError extends boolean = false>(options: Options<CancelMergeResolutionThreadData, ThrowOnError>): RequestResult<CancelMergeResolutionThreadResponses, CancelMergeResolutionThreadErrors, ThrowOnError> => (options.client ?? client).post<CancelMergeResolutionThreadResponses, CancelMergeResolutionThreadErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CANCEL_MERGE_RESOLUTION_THREAD_URL,
    ...options
});

/**
 * Get diff view of thread content against edit session
 *
 * Returns the existing unified patch plus unfiltered per-file change summaries.
 */
export const getThreadDiff = <ThrowOnError extends boolean = false>(options: Options<GetThreadDiffData, ThrowOnError>): RequestResult<GetThreadDiffResponses, GetThreadDiffErrors, ThrowOnError> => (options.client ?? client).get<GetThreadDiffResponses, GetThreadDiffErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_THREAD_DIFF_URL,
    ...options
});

/**
 * View change history for thread
 *
 * Get the change history for an edit session thread.
 *
 * History items are returned in reverse chronological order (newest first).
 * The `pagination.next_cursor` can be used to load older history items, if present.
 * This endpoint does not support `pagination.previous_cursor`.
 *
 */
export const listThreadHistory = <ThrowOnError extends boolean = false>(options: Options<ListThreadHistoryData, ThrowOnError>): RequestResult<ListThreadHistoryResponses, ListThreadHistoryErrors, ThrowOnError> => (options.client ?? client).get<ListThreadHistoryResponses, ListThreadHistoryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_THREAD_HISTORY_URL,
    ...options
});

/**
 * Get a single thread history item
 *
 * Get a specific history item by ID for an edit session thread
 */
export const getThreadHistoryItem = <ThrowOnError extends boolean = false>(options: Options<GetThreadHistoryItemData, ThrowOnError>): RequestResult<GetThreadHistoryItemResponses, GetThreadHistoryItemErrors, ThrowOnError> => (options.client ?? client).get<GetThreadHistoryItemResponses, GetThreadHistoryItemErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_THREAD_HISTORY_ITEM_URL,
    ...options
});

/**
 * Get unified diff for a thread history item
 *
 * Returns a unified patch (diff) showing the changes introduced by a specific history item compared to its first parent. For merge history items, this shows the diff against parent #1 (the target branch tip). When compare_to is provided, returns the direct selected-item-to-target comparison instead.
 */
export const getThreadHistoryItemDiff = <ThrowOnError extends boolean = false>(options: Options<GetThreadHistoryItemDiffData, ThrowOnError>): RequestResult<GetThreadHistoryItemDiffResponses, GetThreadHistoryItemDiffErrors, ThrowOnError> => (options.client ?? client).get<GetThreadHistoryItemDiffResponses, GetThreadHistoryItemDiffErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_THREAD_HISTORY_ITEM_DIFF_URL,
    ...options
});

/**
 * Get a human-readable summary for a thread history comparison
 *
 * Returns semantic per-file summaries for the same selected history range used by the history diff endpoint. Without compare_to, the selected item is compared to its first parent or the empty tree. With compare_to, the selected item is compared directly to the target.
 */
export const getThreadHistoryItemSummary = <ThrowOnError extends boolean = false>(options: Options<GetThreadHistoryItemSummaryData, ThrowOnError>): RequestResult<GetThreadHistoryItemSummaryResponses, GetThreadHistoryItemSummaryErrors, ThrowOnError> => (options.client ?? client).get<GetThreadHistoryItemSummaryResponses, GetThreadHistoryItemSummaryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_THREAD_HISTORY_ITEM_SUMMARY_URL,
    ...options
});

/**
 * Restore thread content
 *
 * Hard-resets the thread branch to the given history item without creating a new commit. If no body is provided, restores the state before the latest visible history item.
 */
export const revertThread = <ThrowOnError extends boolean = false>(options: Options<RevertThreadData, ThrowOnError>): RequestResult<RevertThreadResponses, RevertThreadErrors, ThrowOnError> => (options.client ?? client).post<RevertThreadResponses, RevertThreadErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REVERT_THREAD_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Stream real-time events using Server-Sent Events (SSE)
 *
 * Establishes a connection for streaming real-time updates across all user activity.
 *
 * **Important Notes:**
 * - This is a best-effort delivery system, not a source of truth
 * - Clients should maintain their own state and use polling fallback when needed
 * - Connection will be automatically closed for idle clients
 *
 * **Event Format:**
 * Events are sent using Server-Sent Events (SSE) format. The `Event.type` field is sent in the SSE `event:` field for browser compatibility, while the complete JSON payload (containing `type`, `create_ts`, and `data`) is sent in the `data:` field.
 *
 * Example SSE message:
 * ```
 * id: 1234567890123456789
 * event: chat.message:complete
 * data: {"type": "chat.message:complete", "create_ts": 1727826900.123456, "id": 1234567890123456789, "data": {...}}
 * ```
 *
 * The `id` is sent both in the SSE `id:` field (for browser `MessageEvent.lastEventId` tracking) and in the JSON payload. On reconnection, browsers automatically send the `Last-Event-ID` header. If both `Last-Event-ID` and `after_id` are sent, `Last-Event-ID` takes precedence.
 *
 */
export const streamEvents = <ThrowOnError extends boolean = false>(options?: Options<StreamEventsData, ThrowOnError, StreamEventsResponse>): Promise<ServerSentEventsResult<StreamEventsResponses>> => (options?.client ?? client).sse.get<StreamEventsResponses, StreamEventsErrors, ThrowOnError>({
    querySerializer: { parameters: { types: { array: { explode: false } }, source_ids: { array: { explode: false } } } },
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: STREAM_EVENTS_URL,
    ...options
});

/**
 * List project external runs
 */
export const listProjectExternalRuns = <ThrowOnError extends boolean = false>(options: Options<ListProjectExternalRunsData, ThrowOnError>): RequestResult<ListProjectExternalRunsResponses, ListProjectExternalRunsErrors, ThrowOnError> => (options.client ?? client).get<ListProjectExternalRunsResponses, ListProjectExternalRunsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_PROJECT_EXTERNAL_RUNS_URL,
    ...options
});

/**
 * Create a project external run
 */
export const createProjectExternalRun = <ThrowOnError extends boolean = false>(options: Options<CreateProjectExternalRunData, ThrowOnError>): RequestResult<CreateProjectExternalRunResponses, CreateProjectExternalRunErrors, ThrowOnError> => (options.client ?? client).post<CreateProjectExternalRunResponses, CreateProjectExternalRunErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_PROJECT_EXTERNAL_RUN_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an external run
 */
export const deleteProjectExternalRun = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectExternalRunData, ThrowOnError>): RequestResult<DeleteProjectExternalRunResponses, DeleteProjectExternalRunErrors, ThrowOnError> => (options.client ?? client).delete<DeleteProjectExternalRunResponses, DeleteProjectExternalRunErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: DELETE_PROJECT_EXTERNAL_RUN_URL,
    ...options
});

/**
 * Get a project external run
 */
export const getProjectExternalRun = <ThrowOnError extends boolean = false>(options: Options<GetProjectExternalRunData, ThrowOnError>): RequestResult<GetProjectExternalRunResponses, GetProjectExternalRunErrors, ThrowOnError> => (options.client ?? client).get<GetProjectExternalRunResponses, GetProjectExternalRunErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_PROJECT_EXTERNAL_RUN_URL,
    ...options
});

/**
 * Update project external run settings
 */
export const updateProjectExternalRunSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateProjectExternalRunSettingsData, ThrowOnError>): RequestResult<UpdateProjectExternalRunSettingsResponses, UpdateProjectExternalRunSettingsErrors, ThrowOnError> => (options.client ?? client).patch<UpdateProjectExternalRunSettingsResponses, UpdateProjectExternalRunSettingsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: UPDATE_PROJECT_EXTERNAL_RUN_SETTINGS_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create and associate a fresh project workspace transaction
 */
export const createProjectExternalRunWorkspaceTransaction = <ThrowOnError extends boolean = false>(options: Options<CreateProjectExternalRunWorkspaceTransactionData, ThrowOnError>): RequestResult<CreateProjectExternalRunWorkspaceTransactionResponses, CreateProjectExternalRunWorkspaceTransactionErrors, ThrowOnError> => (options.client ?? client).post<CreateProjectExternalRunWorkspaceTransactionResponses, CreateProjectExternalRunWorkspaceTransactionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_PROJECT_EXTERNAL_RUN_WORKSPACE_TRANSACTION_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start a project external run
 */
export const startProjectExternalRun = <ThrowOnError extends boolean = false>(options: Options<StartProjectExternalRunData, ThrowOnError>): RequestResult<StartProjectExternalRunResponses, StartProjectExternalRunErrors, ThrowOnError> => (options.client ?? client).post<StartProjectExternalRunResponses, StartProjectExternalRunErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: START_PROJECT_EXTERNAL_RUN_URL,
    ...options
});

/**
 * Complete a project external run
 */
export const completeProjectExternalRun = <ThrowOnError extends boolean = false>(options: Options<CompleteProjectExternalRunData, ThrowOnError>): RequestResult<CompleteProjectExternalRunResponses, CompleteProjectExternalRunErrors, ThrowOnError> => (options.client ?? client).post<CompleteProjectExternalRunResponses, CompleteProjectExternalRunErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: COMPLETE_PROJECT_EXTERNAL_RUN_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel a project external run
 */
export const cancelProjectExternalRun = <ThrowOnError extends boolean = false>(options: Options<CancelProjectExternalRunData, ThrowOnError>): RequestResult<CancelProjectExternalRunResponses, CancelProjectExternalRunErrors, ThrowOnError> => (options.client ?? client).post<CancelProjectExternalRunResponses, CancelProjectExternalRunErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CANCEL_PROJECT_EXTERNAL_RUN_URL,
    ...options
});

/**
 * Append a record to a project external run
 */
export const appendProjectExternalRunRecord = <ThrowOnError extends boolean = false>(options: Options<AppendProjectExternalRunRecordData, ThrowOnError>): RequestResult<AppendProjectExternalRunRecordResponses, AppendProjectExternalRunRecordErrors, ThrowOnError> => (options.client ?? client).post<AppendProjectExternalRunRecordResponses, AppendProjectExternalRunRecordErrors, ThrowOnError>({
    bodySerializer: null,
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: APPEND_PROJECT_EXTERNAL_RUN_RECORD_URL,
    ...options,
    headers: {
        'Content-Type': '*/*',
        ...options.headers
    }
});

/**
 * List records for a project external run
 */
export const listProjectExternalRunRecords = <ThrowOnError extends boolean = false>(options: Options<ListProjectExternalRunRecordsData, ThrowOnError>): RequestResult<ListProjectExternalRunRecordsResponses, ListProjectExternalRunRecordsErrors, ThrowOnError> => (options.client ?? client).get<ListProjectExternalRunRecordsResponses, ListProjectExternalRunRecordsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_PROJECT_EXTERNAL_RUN_RECORDS_URL,
    ...options
});

/**
 * Read external run record content
 */
export const getProjectExternalRunRecordContent = <ThrowOnError extends boolean = false>(options: Options<GetProjectExternalRunRecordContentData, ThrowOnError>): RequestResult<GetProjectExternalRunRecordContentResponses, GetProjectExternalRunRecordContentErrors, ThrowOnError> => (options.client ?? client).get<GetProjectExternalRunRecordContentResponses, GetProjectExternalRunRecordContentErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_PROJECT_EXTERNAL_RUN_RECORD_CONTENT_URL,
    ...options
});

/**
 * List edit-session external runs
 */
export const listEditSessionExternalRuns = <ThrowOnError extends boolean = false>(options: Options<ListEditSessionExternalRunsData, ThrowOnError>): RequestResult<ListEditSessionExternalRunsResponses, ListEditSessionExternalRunsErrors, ThrowOnError> => (options.client ?? client).get<ListEditSessionExternalRunsResponses, ListEditSessionExternalRunsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_EDIT_SESSION_EXTERNAL_RUNS_URL,
    ...options
});

/**
 * Create an edit-session external run
 */
export const createEditSessionExternalRun = <ThrowOnError extends boolean = false>(options: Options<CreateEditSessionExternalRunData, ThrowOnError>): RequestResult<CreateEditSessionExternalRunResponses, CreateEditSessionExternalRunErrors, ThrowOnError> => (options.client ?? client).post<CreateEditSessionExternalRunResponses, CreateEditSessionExternalRunErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_EDIT_SESSION_EXTERNAL_RUN_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an external run
 */
export const deleteEditSessionExternalRun = <ThrowOnError extends boolean = false>(options: Options<DeleteEditSessionExternalRunData, ThrowOnError>): RequestResult<DeleteEditSessionExternalRunResponses, DeleteEditSessionExternalRunErrors, ThrowOnError> => (options.client ?? client).delete<DeleteEditSessionExternalRunResponses, DeleteEditSessionExternalRunErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: DELETE_EDIT_SESSION_EXTERNAL_RUN_URL,
    ...options
});

/**
 * Get an edit-session external run
 */
export const getEditSessionExternalRun = <ThrowOnError extends boolean = false>(options: Options<GetEditSessionExternalRunData, ThrowOnError>): RequestResult<GetEditSessionExternalRunResponses, GetEditSessionExternalRunErrors, ThrowOnError> => (options.client ?? client).get<GetEditSessionExternalRunResponses, GetEditSessionExternalRunErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_EDIT_SESSION_EXTERNAL_RUN_URL,
    ...options
});

/**
 * Update edit-session external run settings
 */
export const updateEditSessionExternalRunSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateEditSessionExternalRunSettingsData, ThrowOnError>): RequestResult<UpdateEditSessionExternalRunSettingsResponses, UpdateEditSessionExternalRunSettingsErrors, ThrowOnError> => (options.client ?? client).patch<UpdateEditSessionExternalRunSettingsResponses, UpdateEditSessionExternalRunSettingsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: UPDATE_EDIT_SESSION_EXTERNAL_RUN_SETTINGS_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create and associate a fresh edit-session workspace transaction
 */
export const createEditSessionExternalRunWorkspaceTransaction = <ThrowOnError extends boolean = false>(options: Options<CreateEditSessionExternalRunWorkspaceTransactionData, ThrowOnError>): RequestResult<CreateEditSessionExternalRunWorkspaceTransactionResponses, CreateEditSessionExternalRunWorkspaceTransactionErrors, ThrowOnError> => (options.client ?? client).post<CreateEditSessionExternalRunWorkspaceTransactionResponses, CreateEditSessionExternalRunWorkspaceTransactionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_EDIT_SESSION_EXTERNAL_RUN_WORKSPACE_TRANSACTION_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start an edit-session external run
 */
export const startEditSessionExternalRun = <ThrowOnError extends boolean = false>(options: Options<StartEditSessionExternalRunData, ThrowOnError>): RequestResult<StartEditSessionExternalRunResponses, StartEditSessionExternalRunErrors, ThrowOnError> => (options.client ?? client).post<StartEditSessionExternalRunResponses, StartEditSessionExternalRunErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: START_EDIT_SESSION_EXTERNAL_RUN_URL,
    ...options
});

/**
 * Complete an edit-session external run
 */
export const completeEditSessionExternalRun = <ThrowOnError extends boolean = false>(options: Options<CompleteEditSessionExternalRunData, ThrowOnError>): RequestResult<CompleteEditSessionExternalRunResponses, CompleteEditSessionExternalRunErrors, ThrowOnError> => (options.client ?? client).post<CompleteEditSessionExternalRunResponses, CompleteEditSessionExternalRunErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: COMPLETE_EDIT_SESSION_EXTERNAL_RUN_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel an edit-session external run
 */
export const cancelEditSessionExternalRun = <ThrowOnError extends boolean = false>(options: Options<CancelEditSessionExternalRunData, ThrowOnError>): RequestResult<CancelEditSessionExternalRunResponses, CancelEditSessionExternalRunErrors, ThrowOnError> => (options.client ?? client).post<CancelEditSessionExternalRunResponses, CancelEditSessionExternalRunErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CANCEL_EDIT_SESSION_EXTERNAL_RUN_URL,
    ...options
});

/**
 * Append a record to an edit-session external run
 */
export const appendEditSessionExternalRunRecord = <ThrowOnError extends boolean = false>(options: Options<AppendEditSessionExternalRunRecordData, ThrowOnError>): RequestResult<AppendEditSessionExternalRunRecordResponses, AppendEditSessionExternalRunRecordErrors, ThrowOnError> => (options.client ?? client).post<AppendEditSessionExternalRunRecordResponses, AppendEditSessionExternalRunRecordErrors, ThrowOnError>({
    bodySerializer: null,
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: APPEND_EDIT_SESSION_EXTERNAL_RUN_RECORD_URL,
    ...options,
    headers: {
        'Content-Type': '*/*',
        ...options.headers
    }
});

/**
 * List records for an edit-session external run
 */
export const listEditSessionExternalRunRecords = <ThrowOnError extends boolean = false>(options: Options<ListEditSessionExternalRunRecordsData, ThrowOnError>): RequestResult<ListEditSessionExternalRunRecordsResponses, ListEditSessionExternalRunRecordsErrors, ThrowOnError> => (options.client ?? client).get<ListEditSessionExternalRunRecordsResponses, ListEditSessionExternalRunRecordsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_EDIT_SESSION_EXTERNAL_RUN_RECORDS_URL,
    ...options
});

/**
 * Read edit-session external run record content
 */
export const getEditSessionExternalRunRecordContent = <ThrowOnError extends boolean = false>(options: Options<GetEditSessionExternalRunRecordContentData, ThrowOnError>): RequestResult<GetEditSessionExternalRunRecordContentResponses, GetEditSessionExternalRunRecordContentErrors, ThrowOnError> => (options.client ?? client).get<GetEditSessionExternalRunRecordContentResponses, GetEditSessionExternalRunRecordContentErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_EDIT_SESSION_EXTERNAL_RUN_RECORD_CONTENT_URL,
    ...options
});

/**
 * List thread external runs
 */
export const listThreadExternalRuns = <ThrowOnError extends boolean = false>(options: Options<ListThreadExternalRunsData, ThrowOnError>): RequestResult<ListThreadExternalRunsResponses, ListThreadExternalRunsErrors, ThrowOnError> => (options.client ?? client).get<ListThreadExternalRunsResponses, ListThreadExternalRunsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_THREAD_EXTERNAL_RUNS_URL,
    ...options
});

/**
 * Create a thread external run
 */
export const createThreadExternalRun = <ThrowOnError extends boolean = false>(options: Options<CreateThreadExternalRunData, ThrowOnError>): RequestResult<CreateThreadExternalRunResponses, CreateThreadExternalRunErrors, ThrowOnError> => (options.client ?? client).post<CreateThreadExternalRunResponses, CreateThreadExternalRunErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_THREAD_EXTERNAL_RUN_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an external run
 */
export const deleteThreadExternalRun = <ThrowOnError extends boolean = false>(options: Options<DeleteThreadExternalRunData, ThrowOnError>): RequestResult<DeleteThreadExternalRunResponses, DeleteThreadExternalRunErrors, ThrowOnError> => (options.client ?? client).delete<DeleteThreadExternalRunResponses, DeleteThreadExternalRunErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: DELETE_THREAD_EXTERNAL_RUN_URL,
    ...options
});

/**
 * Get a thread external run
 */
export const getThreadExternalRun = <ThrowOnError extends boolean = false>(options: Options<GetThreadExternalRunData, ThrowOnError>): RequestResult<GetThreadExternalRunResponses, GetThreadExternalRunErrors, ThrowOnError> => (options.client ?? client).get<GetThreadExternalRunResponses, GetThreadExternalRunErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_THREAD_EXTERNAL_RUN_URL,
    ...options
});

/**
 * Update thread external run settings
 */
export const updateThreadExternalRunSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateThreadExternalRunSettingsData, ThrowOnError>): RequestResult<UpdateThreadExternalRunSettingsResponses, UpdateThreadExternalRunSettingsErrors, ThrowOnError> => (options.client ?? client).patch<UpdateThreadExternalRunSettingsResponses, UpdateThreadExternalRunSettingsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: UPDATE_THREAD_EXTERNAL_RUN_SETTINGS_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create and associate a fresh thread workspace transaction
 */
export const createThreadExternalRunWorkspaceTransaction = <ThrowOnError extends boolean = false>(options: Options<CreateThreadExternalRunWorkspaceTransactionData, ThrowOnError>): RequestResult<CreateThreadExternalRunWorkspaceTransactionResponses, CreateThreadExternalRunWorkspaceTransactionErrors, ThrowOnError> => (options.client ?? client).post<CreateThreadExternalRunWorkspaceTransactionResponses, CreateThreadExternalRunWorkspaceTransactionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_THREAD_EXTERNAL_RUN_WORKSPACE_TRANSACTION_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start a thread external run
 */
export const startThreadExternalRun = <ThrowOnError extends boolean = false>(options: Options<StartThreadExternalRunData, ThrowOnError>): RequestResult<StartThreadExternalRunResponses, StartThreadExternalRunErrors, ThrowOnError> => (options.client ?? client).post<StartThreadExternalRunResponses, StartThreadExternalRunErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: START_THREAD_EXTERNAL_RUN_URL,
    ...options
});

/**
 * Complete a thread external run
 */
export const completeThreadExternalRun = <ThrowOnError extends boolean = false>(options: Options<CompleteThreadExternalRunData, ThrowOnError>): RequestResult<CompleteThreadExternalRunResponses, CompleteThreadExternalRunErrors, ThrowOnError> => (options.client ?? client).post<CompleteThreadExternalRunResponses, CompleteThreadExternalRunErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: COMPLETE_THREAD_EXTERNAL_RUN_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel a thread external run
 */
export const cancelThreadExternalRun = <ThrowOnError extends boolean = false>(options: Options<CancelThreadExternalRunData, ThrowOnError>): RequestResult<CancelThreadExternalRunResponses, CancelThreadExternalRunErrors, ThrowOnError> => (options.client ?? client).post<CancelThreadExternalRunResponses, CancelThreadExternalRunErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CANCEL_THREAD_EXTERNAL_RUN_URL,
    ...options
});

/**
 * Append a record to a thread external run
 */
export const appendThreadExternalRunRecord = <ThrowOnError extends boolean = false>(options: Options<AppendThreadExternalRunRecordData, ThrowOnError>): RequestResult<AppendThreadExternalRunRecordResponses, AppendThreadExternalRunRecordErrors, ThrowOnError> => (options.client ?? client).post<AppendThreadExternalRunRecordResponses, AppendThreadExternalRunRecordErrors, ThrowOnError>({
    bodySerializer: null,
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: APPEND_THREAD_EXTERNAL_RUN_RECORD_URL,
    ...options,
    headers: {
        'Content-Type': '*/*',
        ...options.headers
    }
});

/**
 * List records for a thread external run
 */
export const listThreadExternalRunRecords = <ThrowOnError extends boolean = false>(options: Options<ListThreadExternalRunRecordsData, ThrowOnError>): RequestResult<ListThreadExternalRunRecordsResponses, ListThreadExternalRunRecordsErrors, ThrowOnError> => (options.client ?? client).get<ListThreadExternalRunRecordsResponses, ListThreadExternalRunRecordsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_THREAD_EXTERNAL_RUN_RECORDS_URL,
    ...options
});

/**
 * Read thread external run record content
 */
export const getThreadExternalRunRecordContent = <ThrowOnError extends boolean = false>(options: Options<GetThreadExternalRunRecordContentData, ThrowOnError>): RequestResult<GetThreadExternalRunRecordContentResponses, GetThreadExternalRunRecordContentErrors, ThrowOnError> => (options.client ?? client).get<GetThreadExternalRunRecordContentResponses, GetThreadExternalRunRecordContentErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_THREAD_EXTERNAL_RUN_RECORD_CONTENT_URL,
    ...options
});

/**
 * Delete invitation
 */
export const deleteInvitation = <ThrowOnError extends boolean = false>(options: Options<DeleteInvitationData, ThrowOnError>): RequestResult<DeleteInvitationResponses, DeleteInvitationErrors, ThrowOnError> => (options.client ?? client).delete<DeleteInvitationResponses, DeleteInvitationErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: DELETE_INVITATION_URL,
    ...options
});

/**
 * Get invitation by token
 */
export const getInvitationByToken = <ThrowOnError extends boolean = false>(options: Options<GetInvitationByTokenData, ThrowOnError>): RequestResult<GetInvitationByTokenResponses, GetInvitationByTokenErrors, ThrowOnError> => (options.client ?? client).get<GetInvitationByTokenResponses, GetInvitationByTokenErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_INVITATION_BY_TOKEN_URL,
    ...options
});

/**
 * Get invitation's resource by token
 */
export const getInvitationResourceByToken = <ThrowOnError extends boolean = false>(options: Options<GetInvitationResourceByTokenData, ThrowOnError>): RequestResult<GetInvitationResourceByTokenResponses, GetInvitationResourceByTokenErrors, ThrowOnError> => (options.client ?? client).get<GetInvitationResourceByTokenResponses, GetInvitationResourceByTokenErrors, ThrowOnError>({ url: GET_INVITATION_RESOURCE_BY_TOKEN_URL, ...options });

/**
 * Accept invitation
 */
export const acceptInvitation = <ThrowOnError extends boolean = false>(options: Options<AcceptInvitationData, ThrowOnError>): RequestResult<AcceptInvitationResponses, AcceptInvitationErrors, ThrowOnError> => (options.client ?? client).post<AcceptInvitationResponses, AcceptInvitationErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: ACCEPT_INVITATION_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Decline invitation
 */
export const declineInvitation = <ThrowOnError extends boolean = false>(options: Options<DeclineInvitationData, ThrowOnError>): RequestResult<DeclineInvitationResponses, DeclineInvitationErrors, ThrowOnError> => (options.client ?? client).post<DeclineInvitationResponses, DeclineInvitationErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: DECLINE_INVITATION_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview project invite link
 */
export const getProjectInviteLinkPreview = <ThrowOnError extends boolean = false>(options: Options<GetProjectInviteLinkPreviewData, ThrowOnError>): RequestResult<GetProjectInviteLinkPreviewResponses, GetProjectInviteLinkPreviewErrors, ThrowOnError> => (options.client ?? client).get<GetProjectInviteLinkPreviewResponses, GetProjectInviteLinkPreviewErrors, ThrowOnError>({ url: GET_PROJECT_INVITE_LINK_PREVIEW_URL, ...options });

/**
 * Accept project invite link
 */
export const acceptProjectInviteLink = <ThrowOnError extends boolean = false>(options: Options<AcceptProjectInviteLinkData, ThrowOnError>): RequestResult<AcceptProjectInviteLinkResponses, AcceptProjectInviteLinkErrors, ThrowOnError> => (options.client ?? client).post<AcceptProjectInviteLinkResponses, AcceptProjectInviteLinkErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: ACCEPT_PROJECT_INVITE_LINK_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Convenience alias - redirects to current user's invitations
 *
 * Convenience endpoint that redirects to `/users/{user_id}/invitations` using the authenticated user's ID.
 * Returns 307 redirect for client to follow. Use canonical URLs directly when latency is critical.
 *
 */
export const listUserInvitationsRedirect = <ThrowOnError extends boolean = false>(options?: Options<ListUserInvitationsRedirectData, ThrowOnError>): RequestResult<unknown, ListUserInvitationsRedirectErrors, ThrowOnError> => (options?.client ?? client).get<unknown, ListUserInvitationsRedirectErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_USER_INVITATIONS_REDIRECT_URL,
    ...options
});

/**
 * List user's invitations
 */
export const listUserInvitations = <ThrowOnError extends boolean = false>(options: Options<ListUserInvitationsData, ThrowOnError>): RequestResult<ListUserInvitationsResponses, ListUserInvitationsErrors, ThrowOnError> => (options.client ?? client).get<ListUserInvitationsResponses, ListUserInvitationsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_USER_INVITATIONS_URL,
    ...options
});

/**
 * List pending project invitations
 */
export const listProjectInvitations = <ThrowOnError extends boolean = false>(options: Options<ListProjectInvitationsData, ThrowOnError>): RequestResult<ListProjectInvitationsResponses, ListProjectInvitationsErrors, ThrowOnError> => (options.client ?? client).get<ListProjectInvitationsResponses, ListProjectInvitationsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_PROJECT_INVITATIONS_URL,
    ...options
});

/**
 * Send invitation to project
 */
export const sendProjectInvitation = <ThrowOnError extends boolean = false>(options: Options<SendProjectInvitationData, ThrowOnError>): RequestResult<SendProjectInvitationResponses, SendProjectInvitationErrors, ThrowOnError> => (options.client ?? client).post<SendProjectInvitationResponses, SendProjectInvitationErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: SEND_PROJECT_INVITATION_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List project invite links
 */
export const listProjectInviteLinks = <ThrowOnError extends boolean = false>(options: Options<ListProjectInviteLinksData, ThrowOnError>): RequestResult<ListProjectInviteLinksResponses, ListProjectInviteLinksErrors, ThrowOnError> => (options.client ?? client).get<ListProjectInviteLinksResponses, ListProjectInviteLinksErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_PROJECT_INVITE_LINKS_URL,
    ...options
});

/**
 * Create project invite link
 */
export const createProjectInviteLink = <ThrowOnError extends boolean = false>(options: Options<CreateProjectInviteLinkData, ThrowOnError>): RequestResult<CreateProjectInviteLinkResponses, CreateProjectInviteLinkErrors, ThrowOnError> => (options.client ?? client).post<CreateProjectInviteLinkResponses, CreateProjectInviteLinkErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_PROJECT_INVITE_LINK_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke project invite link
 */
export const revokeProjectInviteLink = <ThrowOnError extends boolean = false>(options: Options<RevokeProjectInviteLinkData, ThrowOnError>): RequestResult<RevokeProjectInviteLinkResponses, RevokeProjectInviteLinkErrors, ThrowOnError> => (options.client ?? client).delete<RevokeProjectInviteLinkResponses, RevokeProjectInviteLinkErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REVOKE_PROJECT_INVITE_LINK_URL,
    ...options
});

/**
 * List pending organization invitations
 */
export const listOrganizationInvitations = <ThrowOnError extends boolean = false>(options: Options<ListOrganizationInvitationsData, ThrowOnError>): RequestResult<ListOrganizationInvitationsResponses, ListOrganizationInvitationsErrors, ThrowOnError> => (options.client ?? client).get<ListOrganizationInvitationsResponses, ListOrganizationInvitationsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_ORGANIZATION_INVITATIONS_URL,
    ...options
});

/**
 * Send invitation to organization
 */
export const sendOrganizationInvitation = <ThrowOnError extends boolean = false>(options: Options<SendOrganizationInvitationData, ThrowOnError>): RequestResult<SendOrganizationInvitationResponses, SendOrganizationInvitationErrors, ThrowOnError> => (options.client ?? client).post<SendOrganizationInvitationResponses, SendOrganizationInvitationErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: SEND_ORGANIZATION_INVITATION_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Run enterprise seed process
 */
export const seedLocalDevEnterprise = <ThrowOnError extends boolean = false>(options?: Options<SeedLocalDevEnterpriseData, ThrowOnError>): RequestResult<SeedLocalDevEnterpriseResponses, SeedLocalDevEnterpriseErrors, ThrowOnError> => (options?.client ?? client).post<SeedLocalDevEnterpriseResponses, SeedLocalDevEnterpriseErrors, ThrowOnError>({ url: SEED_LOCAL_DEV_ENTERPRISE_URL, ...options });

/**
 * List project marketing versions
 */
export const listProjectMarketing = <ThrowOnError extends boolean = false>(options: Options<ListProjectMarketingData, ThrowOnError>): RequestResult<ListProjectMarketingResponses, ListProjectMarketingErrors, ThrowOnError> => (options.client ?? client).get<ListProjectMarketingResponses, ListProjectMarketingErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_PROJECT_MARKETING_URL,
    ...options
});

/**
 * Save a new project marketing version
 */
export const createProjectMarketing = <ThrowOnError extends boolean = false>(options: Options<CreateProjectMarketingData, ThrowOnError>): RequestResult<CreateProjectMarketingResponses, CreateProjectMarketingErrors, ThrowOnError> => (options.client ?? client).post<CreateProjectMarketingResponses, CreateProjectMarketingErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_PROJECT_MARKETING_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove a project marketing version from the gallery
 */
export const deleteProjectMarketing = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectMarketingData, ThrowOnError>): RequestResult<DeleteProjectMarketingResponses, DeleteProjectMarketingErrors, ThrowOnError> => (options.client ?? client).delete<DeleteProjectMarketingResponses, DeleteProjectMarketingErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: DELETE_PROJECT_MARKETING_URL,
    ...options
});

/**
 * Rename a project marketing version
 */
export const renameProjectMarketing = <ThrowOnError extends boolean = false>(options: Options<RenameProjectMarketingData, ThrowOnError>): RequestResult<RenameProjectMarketingResponses, RenameProjectMarketingErrors, ThrowOnError> => (options.client ?? client).patch<RenameProjectMarketingResponses, RenameProjectMarketingErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: RENAME_PROJECT_MARKETING_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List user's memberships
 */
export const listUserMemberships = <ThrowOnError extends boolean = false>(options: Options<ListUserMembershipsData, ThrowOnError>): RequestResult<ListUserMembershipsResponses, ListUserMembershipsErrors, ThrowOnError> => (options.client ?? client).get<ListUserMembershipsResponses, ListUserMembershipsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_USER_MEMBERSHIPS_URL,
    ...options
});

/**
 * List organization members
 */
export const listOrganizationMembers = <ThrowOnError extends boolean = false>(options: Options<ListOrganizationMembersData, ThrowOnError>): RequestResult<ListOrganizationMembersResponses, ListOrganizationMembersErrors, ThrowOnError> => (options.client ?? client).get<ListOrganizationMembersResponses, ListOrganizationMembersErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_ORGANIZATION_MEMBERS_URL,
    ...options
});

/**
 * Remove member from organization
 */
export const removeOrganizationMember = <ThrowOnError extends boolean = false>(options: Options<RemoveOrganizationMemberData, ThrowOnError>): RequestResult<RemoveOrganizationMemberResponses, RemoveOrganizationMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveOrganizationMemberResponses, RemoveOrganizationMemberErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REMOVE_ORGANIZATION_MEMBER_URL,
    ...options
});

/**
 * Update member role
 */
export const updateOrganizationMember = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationMemberData, ThrowOnError>): RequestResult<UpdateOrganizationMemberResponses, UpdateOrganizationMemberErrors, ThrowOnError> => (options.client ?? client).patch<UpdateOrganizationMemberResponses, UpdateOrganizationMemberErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: UPDATE_ORGANIZATION_MEMBER_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List project members
 */
export const listProjectMembers = <ThrowOnError extends boolean = false>(options: Options<ListProjectMembersData, ThrowOnError>): RequestResult<ListProjectMembersResponses, ListProjectMembersErrors, ThrowOnError> => (options.client ?? client).get<ListProjectMembersResponses, ListProjectMembersErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_PROJECT_MEMBERS_URL,
    ...options
});

/**
 * Remove member from project
 */
export const removeProjectMember = <ThrowOnError extends boolean = false>(options: Options<RemoveProjectMemberData, ThrowOnError>): RequestResult<RemoveProjectMemberResponses, RemoveProjectMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveProjectMemberResponses, RemoveProjectMemberErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REMOVE_PROJECT_MEMBER_URL,
    ...options
});

/**
 * Update project member role
 */
export const updateProjectMember = <ThrowOnError extends boolean = false>(options: Options<UpdateProjectMemberData, ThrowOnError>): RequestResult<UpdateProjectMemberResponses, UpdateProjectMemberErrors, ThrowOnError> => (options.client ?? client).patch<UpdateProjectMemberResponses, UpdateProjectMemberErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: UPDATE_PROJECT_MEMBER_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all organizations (Admin only)
 *
 * Admin endpoint to list ALL organizations in the system. Regular users should use `/users/{user_id}/organizations` to list their own organizations.
 *
 */
export const listOrganizations = <ThrowOnError extends boolean = false>(options?: Options<ListOrganizationsData, ThrowOnError>): RequestResult<ListOrganizationsResponses, ListOrganizationsErrors, ThrowOnError> => (options?.client ?? client).get<ListOrganizationsResponses, ListOrganizationsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_ORGANIZATIONS_URL,
    ...options
});

/**
 * Create a new organization
 */
export const createOrganization = <ThrowOnError extends boolean = false>(options: Options<CreateOrganizationData, ThrowOnError>): RequestResult<CreateOrganizationResponses, CreateOrganizationErrors, ThrowOnError> => (options.client ?? client).post<CreateOrganizationResponses, CreateOrganizationErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_ORGANIZATION_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get organization details
 */
export const getOrganization = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationData, ThrowOnError>): RequestResult<GetOrganizationResponses, GetOrganizationErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationResponses, GetOrganizationErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_ORGANIZATION_URL,
    ...options
});

/**
 * Update organization
 */
export const updateOrganization = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationData, ThrowOnError>): RequestResult<UpdateOrganizationResponses, UpdateOrganizationErrors, ThrowOnError> => (options.client ?? client).patch<UpdateOrganizationResponses, UpdateOrganizationErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: UPDATE_ORGANIZATION_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Archive organization
 */
export const archiveOrganization = <ThrowOnError extends boolean = false>(options: Options<ArchiveOrganizationData, ThrowOnError>): RequestResult<ArchiveOrganizationResponses, ArchiveOrganizationErrors, ThrowOnError> => (options.client ?? client).post<ArchiveOrganizationResponses, ArchiveOrganizationErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: ARCHIVE_ORGANIZATION_URL,
    ...options
});

/**
 * Transfer organization ownership
 */
export const transferOwnership = <ThrowOnError extends boolean = false>(options: Options<TransferOwnershipData, ThrowOnError>): RequestResult<TransferOwnershipResponses, TransferOwnershipErrors, ThrowOnError> => (options.client ?? client).post<TransferOwnershipResponses, TransferOwnershipErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: TRANSFER_OWNERSHIP_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Convenience alias - redirects to user's organizations
 *
 * Convenience endpoint that redirects to `/users/{user_id}/organizations` using the authenticated user's ID.
 * Returns 307 redirect for client to follow. Use canonical URLs directly when latency is critical.
 *
 */
export const redirectToUserOrganizations = <ThrowOnError extends boolean = false>(options?: Options<RedirectToUserOrganizationsData, ThrowOnError>): RequestResult<unknown, RedirectToUserOrganizationsErrors, ThrowOnError> => (options?.client ?? client).get<unknown, RedirectToUserOrganizationsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REDIRECT_TO_USER_ORGANIZATIONS_URL,
    ...options
});

/**
 * Convenience redirect to user's organization memberships
 *
 * Convenience endpoint that redirects to `/users/{user_id}/memberships?resource_type=organization`.
 * Returns 307 redirect for client to follow. This provides a simpler URL for the common use case
 * of listing a user's organizations while leveraging the unified memberships endpoint.
 *
 */
export const redirectToUserOrganizationMemberships = <ThrowOnError extends boolean = false>(options: Options<RedirectToUserOrganizationMembershipsData, ThrowOnError>): RequestResult<unknown, RedirectToUserOrganizationMembershipsErrors, ThrowOnError> => (options.client ?? client).get<unknown, RedirectToUserOrganizationMembershipsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REDIRECT_TO_USER_ORGANIZATION_MEMBERSHIPS_URL,
    ...options
});

/**
 * List available skills in project context
 *
 * Returns the skills available to run in the context of the project main branch.
 */
export const listProjectSkills = <ThrowOnError extends boolean = false>(options: Options<ListProjectSkillsData, ThrowOnError>): RequestResult<ListProjectSkillsResponses, ListProjectSkillsErrors, ThrowOnError> => (options.client ?? client).get<ListProjectSkillsResponses, ListProjectSkillsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_PROJECT_SKILLS_URL,
    ...options
});

/**
 * Run skill script in project context
 *
 * Runs a script file from the selected skill and waits until execution completes. Sync mode returns the full output or fails if the output exceeds the capture limit; truncation and spill are not part of this API contract. Async mode will be added later.
 */
export const runProjectSkillScript = <ThrowOnError extends boolean = false>(options: Options<RunProjectSkillScriptData, ThrowOnError>): RequestResult<RunProjectSkillScriptResponses, RunProjectSkillScriptErrors, ThrowOnError> => (options.client ?? client).post<RunProjectSkillScriptResponses, RunProjectSkillScriptErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: RUN_PROJECT_SKILL_SCRIPT_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Run skill binary in project context
 *
 * Runs a binary file from the selected skill and waits until execution completes. Sync mode returns the full output or fails if the output exceeds the capture limit; truncation and spill are not part of this API contract. Async mode will be added later.
 */
export const runProjectSkillBinary = <ThrowOnError extends boolean = false>(options: Options<RunProjectSkillBinaryData, ThrowOnError>): RequestResult<RunProjectSkillBinaryResponses, RunProjectSkillBinaryErrors, ThrowOnError> => (options.client ?? client).post<RunProjectSkillBinaryResponses, RunProjectSkillBinaryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: RUN_PROJECT_SKILL_BINARY_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Run a script from the current trusted plugin
 *
 * Runs a caller-selected script below the current server-owned plugin root and waits until execution completes. The plugin identifier selects the current installed package; the request path is relative to that package root.
 */
export const runProjectPluginScript = <ThrowOnError extends boolean = false>(options: Options<RunProjectPluginScriptData, ThrowOnError>): RequestResult<RunProjectPluginScriptResponses, RunProjectPluginScriptErrors, ThrowOnError> => (options.client ?? client).post<RunProjectPluginScriptResponses, RunProjectPluginScriptErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: RUN_PROJECT_PLUGIN_SCRIPT_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Run a binary from the current trusted plugin
 *
 * Runs a caller-selected binary below the current server-owned plugin root and waits until execution completes. The plugin identifier selects the current installed package; the request path is relative to that package root.
 */
export const runProjectPluginBinary = <ThrowOnError extends boolean = false>(options: Options<RunProjectPluginBinaryData, ThrowOnError>): RequestResult<RunProjectPluginBinaryResponses, RunProjectPluginBinaryErrors, ThrowOnError> => (options.client ?? client).post<RunProjectPluginBinaryResponses, RunProjectPluginBinaryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: RUN_PROJECT_PLUGIN_BINARY_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List available skills in edit session context
 *
 * Returns the skills available to run in the context of the edit session branch.
 */
export const listEditSessionSkills = <ThrowOnError extends boolean = false>(options: Options<ListEditSessionSkillsData, ThrowOnError>): RequestResult<ListEditSessionSkillsResponses, ListEditSessionSkillsErrors, ThrowOnError> => (options.client ?? client).get<ListEditSessionSkillsResponses, ListEditSessionSkillsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_EDIT_SESSION_SKILLS_URL,
    ...options
});

/**
 * Run skill script in edit session context
 *
 * Runs a script file from the selected skill and waits until execution completes. When `version_id` is present, project inputs are read-only and come from that visible historical version while declared output blobs remain writable. Sync mode returns the full output or fails if the output exceeds the capture limit; truncation and spill are not part of this API contract. Async mode will be added later.
 */
export const runEditSessionSkillScript = <ThrowOnError extends boolean = false>(options: Options<RunEditSessionSkillScriptData, ThrowOnError>): RequestResult<RunEditSessionSkillScriptResponses, RunEditSessionSkillScriptErrors, ThrowOnError> => (options.client ?? client).post<RunEditSessionSkillScriptResponses, RunEditSessionSkillScriptErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: RUN_EDIT_SESSION_SKILL_SCRIPT_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Run skill binary in edit session context
 *
 * Runs a binary file from the selected skill and waits until execution completes. When `version_id` is present, project inputs are read-only and come from that visible historical version while declared output blobs remain writable. Sync mode returns the full output or fails if the output exceeds the capture limit; truncation and spill are not part of this API contract. Async mode will be added later.
 */
export const runEditSessionSkillBinary = <ThrowOnError extends boolean = false>(options: Options<RunEditSessionSkillBinaryData, ThrowOnError>): RequestResult<RunEditSessionSkillBinaryResponses, RunEditSessionSkillBinaryErrors, ThrowOnError> => (options.client ?? client).post<RunEditSessionSkillBinaryResponses, RunEditSessionSkillBinaryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: RUN_EDIT_SESSION_SKILL_BINARY_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Run a script from the current trusted plugin in edit session context
 *
 * Runs a caller-selected script below the current server-owned plugin root against the edit session branch. When `version_id` is present, project inputs come from that visible historical version. The plugin identifier selects the current installed package; the request path is relative to that package root.
 */
export const runEditSessionPluginScript = <ThrowOnError extends boolean = false>(options: Options<RunEditSessionPluginScriptData, ThrowOnError>): RequestResult<RunEditSessionPluginScriptResponses, RunEditSessionPluginScriptErrors, ThrowOnError> => (options.client ?? client).post<RunEditSessionPluginScriptResponses, RunEditSessionPluginScriptErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: RUN_EDIT_SESSION_PLUGIN_SCRIPT_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Run a binary from the current trusted plugin in edit session context
 *
 * Runs a caller-selected binary below the current server-owned plugin root against the edit session branch. When `version_id` is present, project inputs come from that visible historical version. The plugin identifier selects the current installed package; the request path is relative to that package root.
 */
export const runEditSessionPluginBinary = <ThrowOnError extends boolean = false>(options: Options<RunEditSessionPluginBinaryData, ThrowOnError>): RequestResult<RunEditSessionPluginBinaryResponses, RunEditSessionPluginBinaryErrors, ThrowOnError> => (options.client ?? client).post<RunEditSessionPluginBinaryResponses, RunEditSessionPluginBinaryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: RUN_EDIT_SESSION_PLUGIN_BINARY_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List available skills in edit session thread context
 *
 * Returns the skills available to run in the context of the edit session thread branch.
 */
export const listEditSessionThreadSkills = <ThrowOnError extends boolean = false>(options: Options<ListEditSessionThreadSkillsData, ThrowOnError>): RequestResult<ListEditSessionThreadSkillsResponses, ListEditSessionThreadSkillsErrors, ThrowOnError> => (options.client ?? client).get<ListEditSessionThreadSkillsResponses, ListEditSessionThreadSkillsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_EDIT_SESSION_THREAD_SKILLS_URL,
    ...options
});

/**
 * Run skill script in edit session thread context
 *
 * Runs a script file from the selected skill and waits until execution completes. When `version_id` is present, project inputs are read-only and come from that visible historical version while declared output blobs remain writable. Sync mode returns the full output or fails if the output exceeds the capture limit; truncation and spill are not part of this API contract. Async mode will be added later.
 */
export const runEditSessionThreadSkillScript = <ThrowOnError extends boolean = false>(options: Options<RunEditSessionThreadSkillScriptData, ThrowOnError>): RequestResult<RunEditSessionThreadSkillScriptResponses, RunEditSessionThreadSkillScriptErrors, ThrowOnError> => (options.client ?? client).post<RunEditSessionThreadSkillScriptResponses, RunEditSessionThreadSkillScriptErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: RUN_EDIT_SESSION_THREAD_SKILL_SCRIPT_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Run skill binary in edit session thread context
 *
 * Runs a binary file from the selected skill and waits until execution completes. When `version_id` is present, project inputs are read-only and come from that visible historical version while declared output blobs remain writable. Sync mode returns the full output or fails if the output exceeds the capture limit; truncation and spill are not part of this API contract. Async mode will be added later.
 */
export const runEditSessionThreadSkillBinary = <ThrowOnError extends boolean = false>(options: Options<RunEditSessionThreadSkillBinaryData, ThrowOnError>): RequestResult<RunEditSessionThreadSkillBinaryResponses, RunEditSessionThreadSkillBinaryErrors, ThrowOnError> => (options.client ?? client).post<RunEditSessionThreadSkillBinaryResponses, RunEditSessionThreadSkillBinaryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: RUN_EDIT_SESSION_THREAD_SKILL_BINARY_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Run a script from the current trusted plugin in edit session thread context
 *
 * Runs a caller-selected script below the current server-owned plugin root against the edit session thread branch. When `version_id` is present, project inputs come from that visible historical version. The plugin identifier selects the current installed package; the request path is relative to that package root.
 */
export const runEditSessionThreadPluginScript = <ThrowOnError extends boolean = false>(options: Options<RunEditSessionThreadPluginScriptData, ThrowOnError>): RequestResult<RunEditSessionThreadPluginScriptResponses, RunEditSessionThreadPluginScriptErrors, ThrowOnError> => (options.client ?? client).post<RunEditSessionThreadPluginScriptResponses, RunEditSessionThreadPluginScriptErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: RUN_EDIT_SESSION_THREAD_PLUGIN_SCRIPT_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Run a binary from the current trusted plugin in edit session thread context
 *
 * Runs a caller-selected binary below the current server-owned plugin root against the edit session thread branch. When `version_id` is present, project inputs come from that visible historical version. The plugin identifier selects the current installed package; the request path is relative to that package root.
 */
export const runEditSessionThreadPluginBinary = <ThrowOnError extends boolean = false>(options: Options<RunEditSessionThreadPluginBinaryData, ThrowOnError>): RequestResult<RunEditSessionThreadPluginBinaryResponses, RunEditSessionThreadPluginBinaryErrors, ThrowOnError> => (options.client ?? client).post<RunEditSessionThreadPluginBinaryResponses, RunEditSessionThreadPluginBinaryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: RUN_EDIT_SESSION_THREAD_PLUGIN_BINARY_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Convenience alias - redirects to current user's presence record endpoint
 *
 * Convenience endpoint that redirects to `/users/{user_id}/presence` using the authenticated user's ID.
 * Returns 307 redirect so clients preserve the original POST method and body.
 *
 */
export const redirectToUserPresenceRecord = <ThrowOnError extends boolean = false>(options: Options<RedirectToUserPresenceRecordData, ThrowOnError>): RequestResult<unknown, RedirectToUserPresenceRecordErrors, ThrowOnError> => (options.client ?? client).post<unknown, RedirectToUserPresenceRecordErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REDIRECT_TO_USER_PRESENCE_RECORD_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record presence on a resource
 */
export const recordUserPresence = <ThrowOnError extends boolean = false>(options: Options<RecordUserPresenceData, ThrowOnError>): RequestResult<RecordUserPresenceResponses, RecordUserPresenceErrors, ThrowOnError> => (options.client ?? client).post<RecordUserPresenceResponses, RecordUserPresenceErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: RECORD_USER_PRESENCE_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Convenience alias - redirects to current user's projects
 *
 * Convenience endpoint that redirects to `/users/{user_id}/projects` using the authenticated user's ID.
 * Returns 307 redirect for client to follow. Use canonical URLs directly when latency is critical.
 *
 */
export const redirectToUserProjects = <ThrowOnError extends boolean = false>(options?: Options<RedirectToUserProjectsData, ThrowOnError>): RequestResult<unknown, RedirectToUserProjectsErrors, ThrowOnError> => (options?.client ?? client).get<unknown, RedirectToUserProjectsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REDIRECT_TO_USER_PROJECTS_URL,
    ...options
});

/**
 * Convenience redirect to user's project memberships
 *
 * Convenience endpoint that redirects to `/users/{user_id}/memberships?resource_type=project`.
 * Returns 307 redirect for client to follow. This provides a simpler URL for the common use case
 * of listing a user's projects while leveraging the unified memberships endpoint.
 *
 */
export const redirectToUserProjectMemberships = <ThrowOnError extends boolean = false>(options: Options<RedirectToUserProjectMembershipsData, ThrowOnError>): RequestResult<unknown, RedirectToUserProjectMembershipsErrors, ThrowOnError> => (options.client ?? client).get<unknown, RedirectToUserProjectMembershipsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REDIRECT_TO_USER_PROJECT_MEMBERSHIPS_URL,
    ...options
});

/**
 * Get project details
 */
export const getProject = <ThrowOnError extends boolean = false>(options: Options<GetProjectData, ThrowOnError>): RequestResult<GetProjectResponses, GetProjectErrors, ThrowOnError> => (options.client ?? client).get<GetProjectResponses, GetProjectErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_PROJECT_URL,
    ...options
});

/**
 * Update project
 */
export const updateProject = <ThrowOnError extends boolean = false>(options: Options<UpdateProjectData, ThrowOnError>): RequestResult<UpdateProjectResponses, UpdateProjectErrors, ThrowOnError> => (options.client ?? client).patch<UpdateProjectResponses, UpdateProjectErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: UPDATE_PROJECT_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload project thumbnail image
 */
export const uploadProjectThumbnail = <ThrowOnError extends boolean = false>(options: Options<UploadProjectThumbnailData, ThrowOnError>): RequestResult<UploadProjectThumbnailResponses, UploadProjectThumbnailErrors, ThrowOnError> => (options.client ?? client).post<UploadProjectThumbnailResponses, UploadProjectThumbnailErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: UPLOAD_PROJECT_THUMBNAIL_URL,
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Archive project
 */
export const archiveProject = <ThrowOnError extends boolean = false>(options: Options<ArchiveProjectData, ThrowOnError>): RequestResult<ArchiveProjectResponses, ArchiveProjectErrors, ThrowOnError> => (options.client ?? client).post<ArchiveProjectResponses, ArchiveProjectErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: ARCHIVE_PROJECT_URL,
    ...options
});

/**
 * Duplicate project
 *
 * Asynchronously copies the project's files, edit sessions, threads, chats, retained
 * history, and related project-owned data.
 * The caller becomes the sole owner of the new project. Existing memberships are not copied.
 * If `org_id` is omitted, the duplicate is created in the same organization as the source.
 *
 */
export const duplicateProject = <ThrowOnError extends boolean = false>(options: Options<DuplicateProjectData, ThrowOnError>): RequestResult<DuplicateProjectResponses, DuplicateProjectErrors, ThrowOnError> => (options.client ?? client).post<DuplicateProjectResponses, DuplicateProjectErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: DUPLICATE_PROJECT_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get project copy operation status
 *
 * Returns an accepted project copy operation only to the user who initiated it.
 */
export const getProjectCopyOperation = <ThrowOnError extends boolean = false>(options: Options<GetProjectCopyOperationData, ThrowOnError>): RequestResult<GetProjectCopyOperationResponses, GetProjectCopyOperationErrors, ThrowOnError> => (options.client ?? client).get<GetProjectCopyOperationResponses, GetProjectCopyOperationErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_PROJECT_COPY_OPERATION_URL,
    ...options
});

/**
 * List organization projects
 */
export const listOrganizationProjects = <ThrowOnError extends boolean = false>(options: Options<ListOrganizationProjectsData, ThrowOnError>): RequestResult<ListOrganizationProjectsResponses, ListOrganizationProjectsErrors, ThrowOnError> => (options.client ?? client).get<ListOrganizationProjectsResponses, ListOrganizationProjectsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_ORGANIZATION_PROJECTS_URL,
    ...options
});

/**
 * Create a new project in organization
 */
export const createOrganizationProject = <ThrowOnError extends boolean = false>(options: Options<CreateOrganizationProjectData, ThrowOnError>): RequestResult<CreateOrganizationProjectResponses, CreateOrganizationProjectErrors, ThrowOnError> => (options.client ?? client).post<CreateOrganizationProjectResponses, CreateOrganizationProjectErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: CREATE_ORGANIZATION_PROJECT_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List file system entries
 *
 * List files and folders in the project (published state).
 */
export const listFsEntries = <ThrowOnError extends boolean = false>(options: Options<ListFsEntriesData, ThrowOnError>): RequestResult<ListFsEntriesResponses, ListFsEntriesErrors, ThrowOnError> => (options.client ?? client).get<ListFsEntriesResponses, ListFsEntriesErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_FS_ENTRIES_URL,
    ...options
});

/**
 * Get file system entry metadata
 *
 * Get metadata for a specific file or folder (published state).
 */
export const getFsEntry = <ThrowOnError extends boolean = false>(options: Options<GetFsEntryData, ThrowOnError>): RequestResult<GetFsEntryResponses, GetFsEntryErrors, ThrowOnError> => (options.client ?? client).get<GetFsEntryResponses, GetFsEntryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_FS_ENTRY_URL,
    ...options
});

/**
 * Read file content
 *
 * Get a 307 redirect to download the file content (published state).
 */
export const getFsEntryContent = <ThrowOnError extends boolean = false>(options: Options<GetFsEntryContentData, ThrowOnError>): RequestResult<unknown, GetFsEntryContentErrors, ThrowOnError> => (options.client ?? client).get<unknown, GetFsEntryContentErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_FS_ENTRY_CONTENT_URL,
    ...options
});

/**
 * Get file system entry metadata by path
 *
 * Get metadata for a specific file or folder (published state). Percent-encode the whole file path as a single URL path segment; in particular, slashes must be sent as `%2F`.
 */
export const getFsEntryByPath = <ThrowOnError extends boolean = false>(options: Options<GetFsEntryByPathData, ThrowOnError>): RequestResult<GetFsEntryByPathResponses, GetFsEntryByPathErrors, ThrowOnError> => (options.client ?? client).get<GetFsEntryByPathResponses, GetFsEntryByPathErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_FS_ENTRY_BY_PATH_URL,
    ...options
});

/**
 * Read file content by path
 *
 * Get a 307 redirect to download file content (published state). Percent-encode the whole file path as a single URL path segment; in particular, slashes must be sent as `%2F`.
 */
export const getFsEntryContentByPath = <ThrowOnError extends boolean = false>(options: Options<GetFsEntryContentByPathData, ThrowOnError>): RequestResult<unknown, GetFsEntryContentByPathErrors, ThrowOnError> => (options.client ?? client).get<unknown, GetFsEntryContentByPathErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_FS_ENTRY_CONTENT_BY_PATH_URL,
    ...options
});

/**
 * List project problems
 *
 * Get validation errors, broken references, etc.
 */
export const listProblems = <ThrowOnError extends boolean = false>(options: Options<ListProblemsData, ThrowOnError>): RequestResult<ListProblemsResponses, ListProblemsErrors, ThrowOnError> => (options.client ?? client).get<ListProblemsResponses, ListProblemsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_PROBLEMS_URL,
    ...options
});

/**
 * Refresh TreeView
 *
 * Force regeneration of the project's content tree. Optional `path` query parameter can limit the refresh to a subtree.
 */
export const refreshContentTree = <ThrowOnError extends boolean = false>(options: Options<RefreshContentTreeData, ThrowOnError>): RequestResult<RefreshContentTreeResponses, RefreshContentTreeErrors, ThrowOnError> => (options.client ?? client).post<RefreshContentTreeResponses, RefreshContentTreeErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REFRESH_CONTENT_TREE_URL,
    ...options
});

/**
 * Reimport files
 *
 * Force reimport processing for project files. Optional `path` query parameter can limit the reimport to a subtree.
 */
export const reimportContentPath = <ThrowOnError extends boolean = false>(options: Options<ReimportContentPathData, ThrowOnError>): RequestResult<ReimportContentPathResponses, ReimportContentPathErrors, ThrowOnError> => (options.client ?? client).post<ReimportContentPathResponses, ReimportContentPathErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REIMPORT_CONTENT_PATH_URL,
    ...options
});

/**
 * Get content tree (flat response)
 *
 * Returns a flat array of tree nodes. Clients rebuild the hierarchical tree using parent_id relationships.
 * This design simplifies server implementation, enables efficient partial updates, and allows flexible
 * client-side tree operations.
 *
 */
export const getContentTree = <ThrowOnError extends boolean = false>(options: Options<GetContentTreeData, ThrowOnError>): RequestResult<GetContentTreeResponses, GetContentTreeErrors, ThrowOnError> => (options.client ?? client).get<GetContentTreeResponses, GetContentTreeErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_CONTENT_TREE_URL,
    ...options
});

/**
 * Get type info
 *
 * Returns StructuredTypeInfo (metadata) for the specified type.
 */
export const getStructuredTypeInfoInProject = <ThrowOnError extends boolean = false>(options: Options<GetStructuredTypeInfoInProjectData, ThrowOnError>): RequestResult<GetStructuredTypeInfoInProjectResponses, GetStructuredTypeInfoInProjectErrors, ThrowOnError> => (options.client ?? client).get<GetStructuredTypeInfoInProjectResponses, GetStructuredTypeInfoInProjectErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_STRUCTURED_TYPE_INFO_IN_PROJECT_URL,
    ...options
});

/**
 * Get raw schema
 *
 * Returns the raw JSON/YAML schema for the structured type.
 */
export const getStructuredTypeSchemaInProject = <ThrowOnError extends boolean = false>(options: Options<GetStructuredTypeSchemaInProjectData, ThrowOnError>): RequestResult<GetStructuredTypeSchemaInProjectResponses, GetStructuredTypeSchemaInProjectErrors, ThrowOnError> => (options.client ?? client).get<GetStructuredTypeSchemaInProjectResponses, GetStructuredTypeSchemaInProjectErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_STRUCTURED_TYPE_SCHEMA_IN_PROJECT_URL,
    ...options
});

/**
 * Get value + extras
 *
 * Returns the structured value with optional enhanced data.
 */
export const getStructuredValueInfoInProject = <ThrowOnError extends boolean = false>(options: Options<GetStructuredValueInfoInProjectData, ThrowOnError>): RequestResult<GetStructuredValueInfoInProjectResponses, GetStructuredValueInfoInProjectErrors, ThrowOnError> => (options.client ?? client).get<GetStructuredValueInfoInProjectResponses, GetStructuredValueInfoInProjectErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_STRUCTURED_VALUE_INFO_IN_PROJECT_URL,
    ...options
});

/**
 * Type info redirect
 *
 * Returns a 307 Temporary Redirect to the associated Type Info URL.
 */
export const redirectStructuredValueTypeInProject = <ThrowOnError extends boolean = false>(options: Options<RedirectStructuredValueTypeInProjectData, ThrowOnError>): RequestResult<unknown, RedirectStructuredValueTypeInProjectErrors, ThrowOnError> => (options.client ?? client).get<unknown, RedirectStructuredValueTypeInProjectErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REDIRECT_STRUCTURED_VALUE_TYPE_IN_PROJECT_URL,
    ...options
});

/**
 * Schema redirect
 *
 * Returns a 307 Temporary Redirect to the associated Type Schema URL.
 */
export const redirectStructuredValueTypeSchemaInProject = <ThrowOnError extends boolean = false>(options: Options<RedirectStructuredValueTypeSchemaInProjectData, ThrowOnError>): RequestResult<unknown, RedirectStructuredValueTypeSchemaInProjectErrors, ThrowOnError> => (options.client ?? client).get<unknown, RedirectStructuredValueTypeSchemaInProjectErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REDIRECT_STRUCTURED_VALUE_TYPE_SCHEMA_IN_PROJECT_URL,
    ...options
});

/**
 * Create bundle
 *
 * Build a bundle from a buildable structured value.
 */
export const buildStructuredValueInProject = <ThrowOnError extends boolean = false>(options: Options<BuildStructuredValueInProjectData, ThrowOnError>): RequestResult<BuildStructuredValueInProjectResponses, BuildStructuredValueInProjectErrors, ThrowOnError> => (options.client ?? client).post<BuildStructuredValueInProjectResponses, BuildStructuredValueInProjectErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: BUILD_STRUCTURED_VALUE_IN_PROJECT_URL,
    ...options
});

/**
 * Get type info (Session)
 */
export const getStructuredTypeInfoInEditSession = <ThrowOnError extends boolean = false>(options: Options<GetStructuredTypeInfoInEditSessionData, ThrowOnError>): RequestResult<GetStructuredTypeInfoInEditSessionResponses, GetStructuredTypeInfoInEditSessionErrors, ThrowOnError> => (options.client ?? client).get<GetStructuredTypeInfoInEditSessionResponses, GetStructuredTypeInfoInEditSessionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_STRUCTURED_TYPE_INFO_IN_EDIT_SESSION_URL,
    ...options
});

/**
 * Get raw schema (Session)
 */
export const getStructuredTypeSchemaInEditSession = <ThrowOnError extends boolean = false>(options: Options<GetStructuredTypeSchemaInEditSessionData, ThrowOnError>): RequestResult<GetStructuredTypeSchemaInEditSessionResponses, GetStructuredTypeSchemaInEditSessionErrors, ThrowOnError> => (options.client ?? client).get<GetStructuredTypeSchemaInEditSessionResponses, GetStructuredTypeSchemaInEditSessionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_STRUCTURED_TYPE_SCHEMA_IN_EDIT_SESSION_URL,
    ...options
});

/**
 * Get value + extras (Session)
 */
export const getStructuredValueInfoInEditSession = <ThrowOnError extends boolean = false>(options: Options<GetStructuredValueInfoInEditSessionData, ThrowOnError>): RequestResult<GetStructuredValueInfoInEditSessionResponses, GetStructuredValueInfoInEditSessionErrors, ThrowOnError> => (options.client ?? client).get<GetStructuredValueInfoInEditSessionResponses, GetStructuredValueInfoInEditSessionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_STRUCTURED_VALUE_INFO_IN_EDIT_SESSION_URL,
    ...options
});

/**
 * Type info redirect (Session)
 */
export const redirectStructuredValueTypeInEditSession = <ThrowOnError extends boolean = false>(options: Options<RedirectStructuredValueTypeInEditSessionData, ThrowOnError>): RequestResult<unknown, RedirectStructuredValueTypeInEditSessionErrors, ThrowOnError> => (options.client ?? client).get<unknown, RedirectStructuredValueTypeInEditSessionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REDIRECT_STRUCTURED_VALUE_TYPE_IN_EDIT_SESSION_URL,
    ...options
});

/**
 * Schema redirect (Session)
 */
export const redirectStructuredValueTypeSchemaInEditSession = <ThrowOnError extends boolean = false>(options: Options<RedirectStructuredValueTypeSchemaInEditSessionData, ThrowOnError>): RequestResult<unknown, RedirectStructuredValueTypeSchemaInEditSessionErrors, ThrowOnError> => (options.client ?? client).get<unknown, RedirectStructuredValueTypeSchemaInEditSessionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REDIRECT_STRUCTURED_VALUE_TYPE_SCHEMA_IN_EDIT_SESSION_URL,
    ...options
});

/**
 * Create bundle (Session)
 */
export const buildStructuredValueInEditSession = <ThrowOnError extends boolean = false>(options: Options<BuildStructuredValueInEditSessionData, ThrowOnError>): RequestResult<BuildStructuredValueInEditSessionResponses, BuildStructuredValueInEditSessionErrors, ThrowOnError> => (options.client ?? client).post<BuildStructuredValueInEditSessionResponses, BuildStructuredValueInEditSessionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: BUILD_STRUCTURED_VALUE_IN_EDIT_SESSION_URL,
    ...options
});

/**
 * Get type info (Thread)
 */
export const getStructuredTypeInfoInEditThread = <ThrowOnError extends boolean = false>(options: Options<GetStructuredTypeInfoInEditThreadData, ThrowOnError>): RequestResult<GetStructuredTypeInfoInEditThreadResponses, GetStructuredTypeInfoInEditThreadErrors, ThrowOnError> => (options.client ?? client).get<GetStructuredTypeInfoInEditThreadResponses, GetStructuredTypeInfoInEditThreadErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_STRUCTURED_TYPE_INFO_IN_EDIT_THREAD_URL,
    ...options
});

/**
 * Get raw schema (Thread)
 */
export const getStructuredTypeSchemaInEditThread = <ThrowOnError extends boolean = false>(options: Options<GetStructuredTypeSchemaInEditThreadData, ThrowOnError>): RequestResult<GetStructuredTypeSchemaInEditThreadResponses, GetStructuredTypeSchemaInEditThreadErrors, ThrowOnError> => (options.client ?? client).get<GetStructuredTypeSchemaInEditThreadResponses, GetStructuredTypeSchemaInEditThreadErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_STRUCTURED_TYPE_SCHEMA_IN_EDIT_THREAD_URL,
    ...options
});

/**
 * Get value + extras (Thread)
 */
export const getStructuredValueInfoInEditThread = <ThrowOnError extends boolean = false>(options: Options<GetStructuredValueInfoInEditThreadData, ThrowOnError>): RequestResult<GetStructuredValueInfoInEditThreadResponses, GetStructuredValueInfoInEditThreadErrors, ThrowOnError> => (options.client ?? client).get<GetStructuredValueInfoInEditThreadResponses, GetStructuredValueInfoInEditThreadErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_STRUCTURED_VALUE_INFO_IN_EDIT_THREAD_URL,
    ...options
});

/**
 * Type info redirect (Thread)
 */
export const redirectStructuredValueTypeInEditThread = <ThrowOnError extends boolean = false>(options: Options<RedirectStructuredValueTypeInEditThreadData, ThrowOnError>): RequestResult<unknown, RedirectStructuredValueTypeInEditThreadErrors, ThrowOnError> => (options.client ?? client).get<unknown, RedirectStructuredValueTypeInEditThreadErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REDIRECT_STRUCTURED_VALUE_TYPE_IN_EDIT_THREAD_URL,
    ...options
});

/**
 * Schema redirect (Thread)
 */
export const redirectStructuredValueTypeSchemaInEditThread = <ThrowOnError extends boolean = false>(options: Options<RedirectStructuredValueTypeSchemaInEditThreadData, ThrowOnError>): RequestResult<unknown, RedirectStructuredValueTypeSchemaInEditThreadErrors, ThrowOnError> => (options.client ?? client).get<unknown, RedirectStructuredValueTypeSchemaInEditThreadErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REDIRECT_STRUCTURED_VALUE_TYPE_SCHEMA_IN_EDIT_THREAD_URL,
    ...options
});

/**
 * Create bundle (Thread)
 */
export const buildStructuredValueInEditThread = <ThrowOnError extends boolean = false>(options: Options<BuildStructuredValueInEditThreadData, ThrowOnError>): RequestResult<BuildStructuredValueInEditThreadResponses, BuildStructuredValueInEditThreadErrors, ThrowOnError> => (options.client ?? client).post<BuildStructuredValueInEditThreadResponses, BuildStructuredValueInEditThreadErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: BUILD_STRUCTURED_VALUE_IN_EDIT_THREAD_URL,
    ...options
});

/**
 * Get editor-optimized schema (EditSession)
 *
 * Returns JSON Schema with x-refCollection converted to enum/enumNames for form editors in edit session.
 * This transformation makes collections easier to render as dropdowns in editors like react-jsonschema-form.
 * When version_id is present, value must be omitted or null; historical schemas always use committed content.
 *
 */
export const getStructuredValueEditorSchemaInEditSession = <ThrowOnError extends boolean = false>(options: Options<GetStructuredValueEditorSchemaInEditSessionData, ThrowOnError>): RequestResult<GetStructuredValueEditorSchemaInEditSessionResponses, GetStructuredValueEditorSchemaInEditSessionErrors, ThrowOnError> => (options.client ?? client).post<GetStructuredValueEditorSchemaInEditSessionResponses, GetStructuredValueEditorSchemaInEditSessionErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_STRUCTURED_VALUE_EDITOR_SCHEMA_IN_EDIT_SESSION_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get editor-optimized schema (Thread)
 *
 * Returns JSON Schema with x-refCollection converted to enum/enumNames for form editors in edit session thread.
 * This transformation makes collections easier to render as dropdowns in editors like react-jsonschema-form.
 * When version_id is present, value must be omitted or null; historical schemas always use committed content.
 *
 */
export const getStructuredValueEditorSchemaInEditThread = <ThrowOnError extends boolean = false>(options: Options<GetStructuredValueEditorSchemaInEditThreadData, ThrowOnError>): RequestResult<GetStructuredValueEditorSchemaInEditThreadResponses, GetStructuredValueEditorSchemaInEditThreadErrors, ThrowOnError> => (options.client ?? client).post<GetStructuredValueEditorSchemaInEditThreadResponses, GetStructuredValueEditorSchemaInEditThreadErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_STRUCTURED_VALUE_EDITOR_SCHEMA_IN_EDIT_THREAD_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List available project templates
 *
 * Returns all available project templates for use during project creation.
 */
export const listProjectTemplates = <ThrowOnError extends boolean = false>(options?: Options<ListProjectTemplatesData, ThrowOnError>): RequestResult<ListProjectTemplatesResponses, ListProjectTemplatesErrors, ThrowOnError> => (options?.client ?? client).get<ListProjectTemplatesResponses, ListProjectTemplatesErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_PROJECT_TEMPLATES_URL,
    ...options
});

/**
 * Trigger project template seeding for an organization
 *
 * Syncs the configured git repository and re-seeds the blank project and all templates for the given organization. Caller must be an Admin or Owner of the organization. The body allows overriding the branch of the git seed configuration; when omitted the org's configured seed branch is used. The repository URL and SSH key are server-configured and cannot be overridden via this API.
 *
 */
export const seedOrgProjects = <ThrowOnError extends boolean = false>(options: Options<SeedOrgProjectsData, ThrowOnError>): RequestResult<SeedOrgProjectsResponses, SeedOrgProjectsErrors, ThrowOnError> => (options.client ?? client).post<SeedOrgProjectsResponses, SeedOrgProjectsErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'ServiceAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: SEED_ORG_PROJECTS_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get project template details
 */
export const getProjectTemplate = <ThrowOnError extends boolean = false>(options: Options<GetProjectTemplateData, ThrowOnError>): RequestResult<GetProjectTemplateResponses, GetProjectTemplateErrors, ThrowOnError> => (options.client ?? client).get<GetProjectTemplateResponses, GetProjectTemplateErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_PROJECT_TEMPLATE_URL,
    ...options
});

/**
 * Get current service account
 */
export const getServiceAccountRedirect = <ThrowOnError extends boolean = false>(options?: Options<GetServiceAccountRedirectData, ThrowOnError>): RequestResult<unknown, GetServiceAccountRedirectErrors, ThrowOnError> => (options?.client ?? client).get<unknown, GetServiceAccountRedirectErrors, ThrowOnError>({
    security: [{
            key: 'ServiceAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_SERVICE_ACCOUNT_REDIRECT_URL,
    ...options
});

/**
 * Get service account by ID
 */
export const getServiceAccountById = <ThrowOnError extends boolean = false>(options: Options<GetServiceAccountByIdData, ThrowOnError>): RequestResult<GetServiceAccountByIdResponses, GetServiceAccountByIdErrors, ThrowOnError> => (options.client ?? client).get<GetServiceAccountByIdResponses, GetServiceAccountByIdErrors, ThrowOnError>({
    security: [{
            key: 'ServiceAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_SERVICE_ACCOUNT_BY_ID_URL,
    ...options
});

/**
 * Report usage records
 */
export const reportUsageRecords = <ThrowOnError extends boolean = false>(options: Options<ReportUsageRecordsData, ThrowOnError>): RequestResult<ReportUsageRecordsResponses, ReportUsageRecordsErrors, ThrowOnError> => (options.client ?? client).post<ReportUsageRecordsResponses, ReportUsageRecordsErrors, ThrowOnError>({
    security: [{
            key: 'ServiceAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REPORT_USAGE_RECORDS_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get organization usage summary
 *
 * Returns the current interim Dream Bucks figure for the organization and a
 * per-project breakdown: each usage record's token quantities × the rates of the
 * payer's Metronome contract at the record's time, the way Metronome draws them.
 * It is computed locally and is not a statement of customer debt. The request fails with
 * 402 when billing is disabled or usage in the range has a payer without a Metronome
 * contract, and with 503 while Metronome is unreachable and its rates are not cached. Quantities contain no customer-facing money or internal provider cost.
 *
 * `from_ts` is inclusive and `to_ts` is exclusive. Supply them together; if both
 * are omitted, the range is the current UTC calendar month-to-date. Ranges longer
 * than 366 days are rejected. Only usage with immutable capture-time organization
 * attribution is included.
 *
 */
export const getOrgUsageSummary = <ThrowOnError extends boolean = false>(options: Options<GetOrgUsageSummaryData, ThrowOnError>): RequestResult<GetOrgUsageSummaryResponses, GetOrgUsageSummaryErrors, ThrowOnError> => (options.client ?? client).get<GetOrgUsageSummaryResponses, GetOrgUsageSummaryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_ORG_USAGE_SUMMARY_URL,
    ...options
});

/**
 * List organization usage history
 *
 * Returns genuine UTC-aligned time buckets from the interim local Dream Bucks
 * estimate. History buckets contain quantities only; project and category groupings
 * belong in the summary endpoint.
 *
 * Buckets are ordered earliest to latest by `from_ts`. On an initial request,
 * `from_ts` is inclusive and `to_ts` is exclusive; supply them together or omit
 * both for the current UTC calendar month-to-date. `granularity` is `day` by
 * default. A request using `cursor` must omit `page_size`, `from_ts`, `to_ts`, and
 * `granularity` because the cursor carries the original query.
 *
 */
export const listOrgUsageHistory = <ThrowOnError extends boolean = false>(options: Options<ListOrgUsageHistoryData, ThrowOnError>): RequestResult<ListOrgUsageHistoryResponses, ListOrgUsageHistoryErrors, ThrowOnError> => (options.client ?? client).get<ListOrgUsageHistoryResponses, ListOrgUsageHistoryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_ORG_USAGE_HISTORY_URL,
    ...options
});

/**
 * Get project usage summary
 *
 * Returns the interim local Dream Bucks estimate whose immutable capture-time project
 * attribution matches the requested project. The parent organization is resolved by
 * the server and is not accepted as a request parameter. `from_ts` and `to_ts` are
 * supplied together; omitting both selects the current UTC calendar month-to-date.
 * Ranges longer than 366 days are rejected.
 *
 */
export const getProjectUsageSummary = <ThrowOnError extends boolean = false>(options: Options<GetProjectUsageSummaryData, ThrowOnError>): RequestResult<GetProjectUsageSummaryResponses, GetProjectUsageSummaryErrors, ThrowOnError> => (options.client ?? client).get<GetProjectUsageSummaryResponses, GetProjectUsageSummaryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_PROJECT_USAGE_SUMMARY_URL,
    ...options
});

/**
 * List project usage history
 *
 * Returns genuine UTC-aligned time buckets from the interim local Dream Bucks
 * estimate whose immutable capture-time project attribution matches the requested
 * project.
 *
 * Buckets are ordered earliest to latest by `from_ts`. On an initial request,
 * `from_ts` is inclusive and `to_ts` is exclusive; supply them together or omit
 * both for the current UTC calendar month-to-date. `granularity` is `day` by
 * default. A request using `cursor` must omit `page_size`, `from_ts`, `to_ts`, and
 * `granularity` because the cursor carries the original query.
 *
 */
export const listProjectUsageHistory = <ThrowOnError extends boolean = false>(options: Options<ListProjectUsageHistoryData, ThrowOnError>): RequestResult<ListProjectUsageHistoryResponses, ListProjectUsageHistoryErrors, ThrowOnError> => (options.client ?? client).get<ListProjectUsageHistoryResponses, ListProjectUsageHistoryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_PROJECT_USAGE_HISTORY_URL,
    ...options
});

/**
 * Get a chat branch's usage summary
 *
 * Returns the interim local Dream Bucks figure for the messages visible in this branch,
 * the same messages `GET /chat-branches/{branch_id}/messages` lists (this branch's and
 * its ancestors' up to the branch point), over the whole transcript. A message's usage
 * is every inference attributed to it: an AI reply's answer and the turn-taking decisions
 * it triggered. Usage attributed to no message (e.g. merge conflict checks) is not
 * included. Priced and failing like the other usage reads. Work per read is bounded; a
 * very long branch reports `is_truncated` instead of failing.
 *
 */
export const getChatBranchUsageSummary = <ThrowOnError extends boolean = false>(options: Options<GetChatBranchUsageSummaryData, ThrowOnError>): RequestResult<GetChatBranchUsageSummaryResponses, GetChatBranchUsageSummaryErrors, ThrowOnError> => (options.client ?? client).get<GetChatBranchUsageSummaryResponses, GetChatBranchUsageSummaryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_CHAT_BRANCH_USAGE_SUMMARY_URL,
    ...options
});

/**
 * Get a user's usage summary
 *
 * Returns the interim local Dream Bucks estimate for the incurring user. The caller
 * may request only their own usage. `from_ts` is inclusive and `to_ts` is exclusive;
 * supply them together, or omit both for the current UTC calendar month-to-date.
 *
 */
export const getUserUsageSummary = <ThrowOnError extends boolean = false>(options: Options<GetUserUsageSummaryData, ThrowOnError>): RequestResult<GetUserUsageSummaryResponses, GetUserUsageSummaryErrors, ThrowOnError> => (options.client ?? client).get<GetUserUsageSummaryResponses, GetUserUsageSummaryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_USER_USAGE_SUMMARY_URL,
    ...options
});

/**
 * List a user's usage history
 *
 * Returns genuine UTC-aligned time buckets of the interim local Dream Bucks estimate
 * for the incurring user. The caller may request only their own usage. Buckets are
 * ordered earliest to latest by `from_ts`.
 *
 */
export const listUserUsageHistory = <ThrowOnError extends boolean = false>(options: Options<ListUserUsageHistoryData, ThrowOnError>): RequestResult<ListUserUsageHistoryResponses, ListUserUsageHistoryErrors, ThrowOnError> => (options.client ?? client).get<ListUserUsageHistoryResponses, ListUserUsageHistoryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_USER_USAGE_HISTORY_URL,
    ...options
});

/**
 * Convenience alias for the current user's usage summary
 */
export const redirectToUserUsageSummary = <ThrowOnError extends boolean = false>(options?: Options<RedirectToUserUsageSummaryData, ThrowOnError>): RequestResult<unknown, RedirectToUserUsageSummaryErrors, ThrowOnError> => (options?.client ?? client).get<unknown, RedirectToUserUsageSummaryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REDIRECT_TO_USER_USAGE_SUMMARY_URL,
    ...options
});

/**
 * Convenience alias for the current user's usage history
 */
export const redirectToUserUsageHistory = <ThrowOnError extends boolean = false>(options?: Options<RedirectToUserUsageHistoryData, ThrowOnError>): RequestResult<unknown, RedirectToUserUsageHistoryErrors, ThrowOnError> => (options?.client ?? client).get<unknown, RedirectToUserUsageHistoryErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: REDIRECT_TO_USER_USAGE_HISTORY_URL,
    ...options
});

/**
 * Delete current user account
 */
export const deleteUser = <ThrowOnError extends boolean = false>(options?: Options<DeleteUserData, ThrowOnError>): RequestResult<unknown, DeleteUserErrors, ThrowOnError> => (options?.client ?? client).delete<unknown, DeleteUserErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: DELETE_USER_URL,
    ...options
});

/**
 * Get current user profile
 */
export const getUserRedirect = <ThrowOnError extends boolean = false>(options?: Options<GetUserRedirectData, ThrowOnError>): RequestResult<unknown, GetUserRedirectErrors, ThrowOnError> => (options?.client ?? client).get<unknown, GetUserRedirectErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_USER_REDIRECT_URL,
    ...options
});

/**
 * Update current user profile
 */
export const updateUser = <ThrowOnError extends boolean = false>(options?: Options<UpdateUserData, ThrowOnError>): RequestResult<unknown, UpdateUserErrors, ThrowOnError> => (options?.client ?? client).patch<unknown, UpdateUserErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: UPDATE_USER_URL,
    ...options
});

/**
 * Redirect to delete the current user's avatar
 */
export const deleteUserAvatarRedirect = <ThrowOnError extends boolean = false>(options?: Options<DeleteUserAvatarRedirectData, ThrowOnError>): RequestResult<unknown, DeleteUserAvatarRedirectErrors, ThrowOnError> => (options?.client ?? client).delete<unknown, DeleteUserAvatarRedirectErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: DELETE_USER_AVATAR_REDIRECT_URL,
    ...options
});

/**
 * Redirect to the current user's avatar
 */
export const getUserAvatarRedirect = <ThrowOnError extends boolean = false>(options?: Options<GetUserAvatarRedirectData, ThrowOnError>): RequestResult<unknown, GetUserAvatarRedirectErrors, ThrowOnError> => (options?.client ?? client).get<unknown, GetUserAvatarRedirectErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_USER_AVATAR_REDIRECT_URL,
    ...options
});

/**
 * Redirect to upload the current user's avatar
 */
export const uploadUserAvatarRedirect = <ThrowOnError extends boolean = false>(options: Options<UploadUserAvatarRedirectData, ThrowOnError>): RequestResult<unknown, UploadUserAvatarRedirectErrors, ThrowOnError> => (options.client ?? client).post<unknown, UploadUserAvatarRedirectErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: UPLOAD_USER_AVATAR_REDIRECT_URL,
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Delete user by ID
 */
export const deleteUserById = <ThrowOnError extends boolean = false>(options: Options<DeleteUserByIdData, ThrowOnError>): RequestResult<DeleteUserByIdResponses, DeleteUserByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteUserByIdResponses, DeleteUserByIdErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: DELETE_USER_BY_ID_URL,
    ...options
});

/**
 * Get user by ID
 */
export const getUser = <ThrowOnError extends boolean = false>(options: Options<GetUserData, ThrowOnError>): RequestResult<GetUserResponses, GetUserErrors, ThrowOnError> => (options.client ?? client).get<GetUserResponses, GetUserErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_USER_URL,
    ...options
});

/**
 * Update user by ID
 */
export const updateUserById = <ThrowOnError extends boolean = false>(options: Options<UpdateUserByIdData, ThrowOnError>): RequestResult<UpdateUserByIdResponses, UpdateUserByIdErrors, ThrowOnError> => (options.client ?? client).patch<UpdateUserByIdResponses, UpdateUserByIdErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: UPDATE_USER_BY_ID_URL,
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete user avatar
 */
export const deleteUserAvatar = <ThrowOnError extends boolean = false>(options: Options<DeleteUserAvatarData, ThrowOnError>): RequestResult<DeleteUserAvatarResponses, DeleteUserAvatarErrors, ThrowOnError> => (options.client ?? client).delete<DeleteUserAvatarResponses, DeleteUserAvatarErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: DELETE_USER_AVATAR_URL,
    ...options
});

/**
 * Redirect to a fresh signed user avatar URL
 */
export const getUserAvatar = <ThrowOnError extends boolean = false>(options: Options<GetUserAvatarData, ThrowOnError>): RequestResult<unknown, GetUserAvatarErrors, ThrowOnError> => (options.client ?? client).get<unknown, GetUserAvatarErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: GET_USER_AVATAR_URL,
    ...options
});

/**
 * Upload user avatar image
 */
export const uploadUserAvatar = <ThrowOnError extends boolean = false>(options: Options<UploadUserAvatarData, ThrowOnError>): RequestResult<UploadUserAvatarResponses, UploadUserAvatarErrors, ThrowOnError> => (options.client ?? client).post<UploadUserAvatarResponses, UploadUserAvatarErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: UPLOAD_USER_AVATAR_URL,
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Redirect to current user's memberships
 */
export const listUserMembershipsRedirect = <ThrowOnError extends boolean = false>(options?: Options<ListUserMembershipsRedirectData, ThrowOnError>): RequestResult<unknown, ListUserMembershipsRedirectErrors, ThrowOnError> => (options?.client ?? client).get<unknown, ListUserMembershipsRedirectErrors, ThrowOnError>({
    security: [{
            key: 'UserAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: LIST_USER_MEMBERSHIPS_REDIRECT_URL,
    ...options
});
